import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  URL: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type AccessRequest = {
  __typename?: 'AccessRequest';
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  register: Register;
  reminders: Array<AccessRequestReminder>;
  requestedAt: Scalars['DateTime']['output'];
  requestedByGroup: Group;
  requestedByUser: User;
};

export type AccessRequestReminder = {
  __typename?: 'AccessRequestReminder';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  remindedAt: Scalars['DateTime']['output'];
  remindedByUser: User;
};

export type Account = {
  __typename?: 'Account';
  entitlements: Array<AccountEntitlement>;
  group?: Maybe<Group>;
  hasLicenseAgreement: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isUserAdmin: Scalars['Boolean']['output'];
  locale: Locale;
  notary: Scalars['Boolean']['output'];
  user: User;
};

export enum AccountEntitlement {
  AuditTrailDetails = 'AUDIT_TRAIL_DETAILS',
  DeleteCorporateStructure = 'DELETE_CORPORATE_STRUCTURE',
  DeleteRegister = 'DELETE_REGISTER',
  DividendStatements = 'DIVIDEND_STATEMENTS',
  DocumentAdd = 'DOCUMENT_ADD',
  DocumentCreate = 'DOCUMENT_CREATE',
  ExportJsonRegister = 'EXPORT_JSON_REGISTER',
  Grouping = 'GROUPING',
  GroupManagement = 'GROUP_MANAGEMENT',
  HandOverFlow = 'HAND_OVER_FLOW',
  MutationSummary = 'MUTATION_SUMMARY',
  MyOffice = 'MY_OFFICE',
  NotPpu = 'NOT_PPU',
  PartyCreate = 'PARTY_CREATE',
  RegisterCreate = 'REGISTER_CREATE',
  SearchAllRegisters = 'SEARCH_ALL_REGISTERS',
  ShareCreate = 'SHARE_CREATE',
  StoreConsistencyCheck = 'STORE_CONSISTENCY_CHECK',
  StructureView = 'STRUCTURE_VIEW',
  SuperAdmin = 'SUPER_ADMIN',
  UboManage = 'UBO_MANAGE',
  UserManagement = 'USER_MANAGEMENT',
  ViewEvidend = 'VIEW_EVIDEND',
}

export type AccountInput = {
  locale: Locale;
};

export type Administration = {
  __typename?: 'Administration';
  details?: Maybe<AdministrationDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type AdministrationDetails = {
  __typename?: 'AdministrationDetails';
  administrator: Party;
  createdBy?: Maybe<RegisterMutation>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdministrationDetailsInput = {
  administratorId: Scalars['ID']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdministrationInput = {
  details?: InputMaybe<AdministrationDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type Attachment = {
  __typename?: 'Attachment';
  details?: Maybe<AttachmentDetails>;
  owner: Party;
  shareSeries: ShareSeries;
  type: AttachmentType;
};

export type AttachmentDetails = {
  __typename?: 'AttachmentDetails';
  attachedAt?: Maybe<Scalars['String']['output']>;
  bailiff: Party;
  createdBy?: Maybe<RegisterMutation>;
  requiredBy?: Maybe<Array<Party>>;
};

export type AttachmentDetailsInput = {
  attachedAt?: InputMaybe<Scalars['String']['input']>;
  bailiffId: Scalars['ID']['input'];
  requiredByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AttachmentInput = {
  details?: InputMaybe<AttachmentDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
  type: AttachmentType;
};

export enum AttachmentType {
  Enforceable = 'ENFORCEABLE',
  Prejudgement = 'PREJUDGEMENT',
}

export enum AuditTrailEventType {
  DocumentCreate = 'DOCUMENT_CREATE',
  DocumentDelete = 'DOCUMENT_DELETE',
  DocumentFileAdd = 'DOCUMENT_FILE_ADD',
  DocumentFileDelete = 'DOCUMENT_FILE_DELETE',
  DocumentUpdate = 'DOCUMENT_UPDATE',
  MutationCreate = 'MUTATION_CREATE',
  MutationDelete = 'MUTATION_DELETE',
  MutationDraft = 'MUTATION_DRAFT',
  MutationUndraft = 'MUTATION_UNDRAFT',
  PartyCreate = 'PARTY_CREATE',
  PartyDelete = 'PARTY_DELETE',
  PartyUpdate = 'PARTY_UPDATE',
  PermissionCreate = 'PERMISSION_CREATE',
  PermissionDelete = 'PERMISSION_DELETE',
  PermissionUpdate = 'PERMISSION_UPDATE',
  RegisterDataUpdate = 'REGISTER_DATA_UPDATE',
  RegisterSign = 'REGISTER_SIGN',
  RegisterSignDelete = 'REGISTER_SIGN_DELETE',
  ShareTypeCreate = 'SHARE_TYPE_CREATE',
  ShareTypeDelete = 'SHARE_TYPE_DELETE',
  ShareTypeUpdate = 'SHARE_TYPE_UPDATE',
}

export type AuditTrailParam = {
  __typename?: 'AuditTrailParam';
  name: AuditTrailParamName;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AuditTrailParamName {
  DocumentEffectiveDate = 'DOCUMENT_EFFECTIVE_DATE',
  DocumentFileName = 'DOCUMENT_FILE_NAME',
  DocumentMutationType = 'DOCUMENT_MUTATION_TYPE',
  DocumentType = 'DOCUMENT_TYPE',
  Entitlement = 'ENTITLEMENT',
  EntitlementEmail = 'ENTITLEMENT_EMAIL',
  Id = 'ID',
  IsKvkUpdate = 'IS_KVK_UPDATE',
  MutationEffectiveDate = 'MUTATION_EFFECTIVE_DATE',
  MutationTitle = 'MUTATION_TITLE',
  MutationType = 'MUTATION_TYPE',
  RegisterId = 'REGISTER_ID',
  ShareTypeClassifier = 'SHARE_TYPE_CLASSIFIER',
  ShareTypeEffectiveDate = 'SHARE_TYPE_EFFECTIVE_DATE',
  ShareTypeName = 'SHARE_TYPE_NAME',
  ShareTypeNominalValue = 'SHARE_TYPE_NOMINAL_VALUE',
  ShareTypeOldEffectiveDate = 'SHARE_TYPE_OLD_EFFECTIVE_DATE',
  SignatureDate = 'SIGNATURE_DATE',
  SignatureUserEmail = 'SIGNATURE_USER_EMAIL',
  SignatureUserFullName = 'SIGNATURE_USER_FULL_NAME',
}

export type Capital = {
  __typename?: 'Capital';
  date: Scalars['Date']['output'];
  shares: Array<CapitalShare>;
};

export type CapitalHistory = {
  __typename?: 'CapitalHistory';
  authorized: Array<Capital>;
  issued: Array<Capital>;
  paid: Array<Capital>;
  unpaid: Array<Capital>;
};

export type CapitalShare = {
  __typename?: 'CapitalShare';
  amount: Scalars['BigInt']['output'];
  shareType: ShareType;
};

export type CertifiableShareType = {
  __typename?: 'CertifiableShareType';
  legalEntity: LegalEntity;
  shareType: ShareType;
};

export type CompanySearchResult = {
  __typename?: 'CompanySearchResult';
  city: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  registryNumber: Scalars['String']['output'];
};

export type ConsistencyError = {
  __typename?: 'ConsistencyError';
  errorCode: ConsistencyErrorCode;
  legalEntityId: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['String']['output']>;
  shareTotalMongo?: Maybe<Scalars['Int']['output']>;
  shareTotalNeo?: Maybe<Scalars['Int']['output']>;
  shareTypeId?: Maybe<Scalars['String']['output']>;
};

export enum ConsistencyErrorCode {
  LegalEntityMissingInNeo = 'LEGAL_ENTITY_MISSING_IN_NEO',
  ShareOwnerNotInNeo = 'SHARE_OWNER_NOT_IN_NEO',
  ShareRangeTypeNotInNeo = 'SHARE_RANGE_TYPE_NOT_IN_NEO',
  ShareTypeTotalMismatch = 'SHARE_TYPE_TOTAL_MISMATCH',
}

export type ConsistencyLog = {
  __typename?: 'ConsistencyLog';
  consistencyErrors?: Maybe<Array<Maybe<ConsistencyError>>>;
  consistent?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Int']['output']>;
  totalProcessed?: Maybe<Scalars['Int']['output']>;
};

export type Conversion = {
  __typename?: 'Conversion';
  action: ConversionAction;
  owner: Party;
  paid?: Maybe<Scalars['Boolean']['output']>;
  shareSeries: ShareSeries;
};

export enum ConversionAction {
  Create = 'CREATE',
  Remove = 'REMOVE',
}

export type ConversionInput = {
  action: ConversionAction;
  ownerPartyId: Scalars['ID']['input'];
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  shareSeries: ShareSeriesInput;
};

export type CreateNotaryInput = {
  active: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  initials: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  location: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  type: NotaryType;
};

export type DeedNotary = {
  __typename?: 'DeedNotary';
  location: Scalars['String']['output'];
  name: Name;
};

export type DeedNotaryInput = {
  location: Scalars['String']['input'];
  name: NameInput;
};

export type DeedPassed = {
  __typename?: 'DeedPassed';
  assignedNotary?: Maybe<DeedNotary>;
  notary?: Maybe<DeedNotary>;
  notaryRole: NotaryRole;
};

export type DeedPassedInput = {
  assignedNotary?: InputMaybe<DeedNotaryInput>;
  notary?: InputMaybe<DeedNotaryInput>;
  notaryRole: NotaryRole;
};

export type DelegationDetails = {
  __typename?: 'DelegationDetails';
  createdBy?: Maybe<RegisterMutation>;
  delegatee: Party;
  dividend: Scalars['Boolean']['output'];
  meeting: Scalars['Boolean']['output'];
  voting: Scalars['Boolean']['output'];
};

export type DelegationDetailsInput = {
  delegateeId: Scalars['ID']['input'];
  dividend: Scalars['Boolean']['input'];
  meeting: Scalars['Boolean']['input'];
  voting: Scalars['Boolean']['input'];
};

export type Director = {
  __typename?: 'Director';
  appointedOn?: Maybe<Scalars['Date']['output']>;
  authority: DirectorAuthority;
  director: Party;
  endedOn?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  representationAuthority: RepresentationAuthority;
  status: DirectorStatus;
  title?: Maybe<Scalars['String']['output']>;
};

export enum DirectorAuthority {
  Jointly = 'JOINTLY',
  Solely = 'SOLELY',
}

export type DirectorInput = {
  authority: DirectorAuthority;
  directorPartyId: Scalars['ID']['input'];
  representationAuthority: RepresentationAuthority;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum DirectorStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum DirectorStatusFilter {
  Active = 'ACTIVE',
  All = 'ALL',
  Inactive = 'INACTIVE',
}

export type DistributionChart = {
  __typename?: 'DistributionChart';
  pieces: Array<DistributionChartPiece>;
};

export type DistributionChartFilterBy = {
  filter: DistributionChartFilterEnum;
  shareTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export enum DistributionChartFilterEnum {
  ShareType = 'SHARE_TYPE',
  WithDividendRights = 'WITH_DIVIDEND_RIGHTS',
  WithMeetingRights = 'WITH_MEETING_RIGHTS',
  WithVotingRights = 'WITH_VOTING_RIGHTS',
}

export enum DistributionChartGroupBy {
  DividendRightHolder = 'DIVIDEND_RIGHT_HOLDER',
  MeetingRightHolder = 'MEETING_RIGHT_HOLDER',
  Shareholder = 'SHAREHOLDER',
  VotingRightHolder = 'VOTING_RIGHT_HOLDER',
}

export type DistributionChartPiece = {
  __typename?: 'DistributionChartPiece';
  amount: Money;
  amountPercentage: Scalars['Float']['output'];
  party: Party;
  quantity: Scalars['BigInt']['output'];
  quantityPercentage: Scalars['Float']['output'];
};

export type DividendStatement = {
  __typename?: 'DividendStatement';
  description: Scalars['String']['output'];
  effectiveDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  partyStatements: Array<DividendStatementParty>;
  paymentDate: Scalars['Date']['output'];
  registerLegalEntity: LegalEntity;
  shareTypes: Array<DividendStatementShareType>;
  shouldSync: Scalars['Boolean']['output'];
  taxRate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type DividendStatementEntry = {
  __typename?: 'DividendStatementEntry';
  amountDelegated?: Maybe<Money>;
  amountFromDelegation?: Maybe<Money>;
  id: Scalars['ID']['output'];
  shareBatch: Array<ShareBatch>;
  shareBatchDelegated: Array<ShareBatch>;
  shareBatchFromDelegation: Array<ShareBatch>;
  shareCount: Scalars['Int']['output'];
  shareCountDelegated: Scalars['Int']['output'];
  shareCountFromDelegation: Scalars['Int']['output'];
  shareType: ShareType;
  totalAmount?: Maybe<Money>;
};

export type DividendStatementInput = {
  description: Scalars['String']['input'];
  effectiveDate: Scalars['Date']['input'];
  paymentDate: Scalars['Date']['input'];
  shareTypes: Array<DividendStatementShareTypeInput>;
  taxRate: Scalars['Float']['input'];
  title: Scalars['String']['input'];
};

export type DividendStatementParty = {
  __typename?: 'DividendStatementParty';
  description?: Maybe<Scalars['String']['output']>;
  entries: Array<DividendStatementEntry>;
  id: Scalars['ID']['output'];
  party: Party;
  taxAmount?: Maybe<Money>;
  totalAmount?: Maybe<Money>;
};

export type DividendStatementPartyInput = {
  description: Scalars['String']['input'];
};

export type DividendStatementShareType = {
  __typename?: 'DividendStatementShareType';
  amount?: Maybe<Money>;
  shareType: ShareType;
};

export type DividendStatementShareTypeInput = {
  amount: MoneyInput;
  shareTypeId: Scalars['ID']['input'];
};

export type Document = {
  __typename?: 'Document';
  canBeRemoved?: Maybe<Scalars['Boolean']['output']>;
  commentary?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  deedPassed?: Maybe<DeedPassed>;
  file?: Maybe<File>;
  id: Scalars['ID']['output'];
  labels: Array<DocumentLabel>;
  mutation?: Maybe<RegisterMutation>;
  type: DocumentType;
};

export type DocumentInput = {
  commentary?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  deedPassed?: InputMaybe<DeedPassedInput>;
  labels: Array<DocumentLabel>;
  type: DocumentType;
};

export enum DocumentLabel {
  ArticleOfAssociation = 'ARTICLE_OF_ASSOCIATION',
  CocExtract = 'COC_EXTRACT',
  ShareholdersAgreement = 'SHAREHOLDERS_AGREEMENT',
  ShareholdersRegister = 'SHAREHOLDERS_REGISTER',
  ShareholdersResolution = 'SHAREHOLDERS_RESOLUTION',
  TrustConditions = 'TRUST_CONDITIONS',
}

export enum DocumentType {
  NotarialDeed = 'NOTARIAL_DEED',
  Other = 'OTHER',
  PrivateDeed = 'PRIVATE_DEED',
}

export type EndAdministration = {
  __typename?: 'EndAdministration';
  owner: Party;
  shareSeries: ShareSeries;
};

export type EndAdministrationInput = {
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type EndAttachment = {
  __typename?: 'EndAttachment';
  details?: Maybe<AttachmentDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type EndAttachmentInput = {
  details?: InputMaybe<AttachmentDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type EndDirectorship = {
  __typename?: 'EndDirectorship';
  director: Party;
  directorshipId: Scalars['ID']['output'];
};

export type EndDirectorshipInput = {
  directorshipId: Scalars['ID']['input'];
};

export type EndPledge = {
  __typename?: 'EndPledge';
  details: Array<DelegationDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type EndPledgeInput = {
  details: Array<DelegationDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type EndUbo = {
  __typename?: 'EndUbo';
  ground: UboGround;
  naturalPerson: Party;
};

export type EndUboInput = {
  ground: UboGround;
  naturalPersonId: Scalars['ID']['input'];
};

export type EndUsufruct = {
  __typename?: 'EndUsufruct';
  details: Array<DelegationDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type EndUsufructInput = {
  details: Array<DelegationDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type EntitledEntity = {
  __typename?: 'EntitledEntity';
  email?: Maybe<Scalars['String']['output']>;
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  temporaryAccessExpiration?: Maybe<Scalars['Date']['output']>;
  type: EntityType;
};

export type EntitledEntityInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  entitlement: Entitlement;
  id?: InputMaybe<Scalars['ID']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EntitledEntitySummary = {
  __typename?: 'EntitledEntitySummary';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  registersCount: Scalars['Int']['output'];
  type: EntityType;
};

export type EntitledEntitySummaryResponse = {
  __typename?: 'EntitledEntitySummaryResponse';
  items: Array<EntitledEntitySummary>;
  pagination: Pagination;
};

export enum Entitlement {
  Administer = 'ADMINISTER',
  Manage = 'MANAGE',
  None = 'NONE',
  View = 'VIEW',
}

export enum EntityType {
  Group = 'GROUP',
  User = 'USER',
}

export type File = {
  __typename?: 'File';
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  uploadedAt: Scalars['DateTime']['output'];
};

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type GroupInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notary: Scalars['Boolean']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  subscriptionType: SubscriptionType;
  tradeRegisterNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityDocument = {
  __typename?: 'IdentityDocument';
  downloadHistory: Array<IdentityDocumentDownload>;
  expiryDate: Scalars['Date']['output'];
  file: File;
  id: Scalars['ID']['output'];
  type: IdentityDocumentType;
  uploadedBy: User;
  uploadedOn: Scalars['DateTime']['output'];
};

export type IdentityDocumentDownload = {
  __typename?: 'IdentityDocumentDownload';
  downloadedBy: User;
  downloadedOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export enum IdentityDocumentType {
  IdCard = 'ID_CARD',
  Passport = 'PASSPORT',
}

export type Incorporation = {
  __typename?: 'Incorporation';
  paid?: Maybe<Scalars['Boolean']['output']>;
  shareSeries: ShareSeries;
  to: Party;
};

export type IncorporationInput = {
  directors?: InputMaybe<Array<DirectorInput>>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  shareSeries: ShareSeriesInput;
  toPartyId: Scalars['ID']['input'];
};

export type Invitation = {
  __typename?: 'Invitation';
  accepted?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  invitedByGroup?: Maybe<Group>;
  invitedByUser?: Maybe<User>;
  register: LegalEntity;
  status: InvitationStatus;
  validUntil: Scalars['DateTime']['output'];
};

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
}

export type Issuance = {
  __typename?: 'Issuance';
  paid?: Maybe<Scalars['Boolean']['output']>;
  shareSeries: ShareSeries;
  to: Party;
};

export type IssuanceInput = {
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  shareSeries: ShareSeriesInput;
  toPartyId: Scalars['ID']['input'];
};

export type LegalEntity = {
  __typename?: 'LegalEntity';
  correspondenceAddress?: Maybe<PostalAddress>;
  countryOfRegistration: Scalars['String']['output'];
  directors: Array<Director>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  incorporatedOn?: Maybe<Scalars['Date']['output']>;
  isFoundation: Scalars['Boolean']['output'];
  lastFetchedFromKvkOn?: Maybe<Scalars['Date']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otherEntitledCount?: Maybe<Scalars['Int']['output']>;
  participation?: Maybe<Participation>;
  participations: Array<Participation>;
  partyUpdates: Array<PartyUpdate>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  register?: Maybe<Register>;
  rsinNumber?: Maybe<Scalars['String']['output']>;
  tradeRegisterNumber?: Maybe<Scalars['String']['output']>;
  ubos: Array<Ubo>;
  visitorAddress?: Maybe<PostalAddress>;
};

export type LegalEntityDirectorsArgs = {
  status?: InputMaybe<DirectorStatusFilter>;
};

export type LegalEntityInput = {
  correspondenceAddress?: InputMaybe<PostalAddressInput>;
  countryOfRegistration: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  incorporatedOn?: InputMaybe<Scalars['Date']['input']>;
  legalForm?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rsinNumber?: InputMaybe<Scalars['String']['input']>;
  tradeRegisterNumber?: InputMaybe<Scalars['String']['input']>;
  visitorAddress?: InputMaybe<PostalAddressInput>;
};

export type LicenseAgreementInput = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  invoiceEmail: Scalars['String']['input'];
  registryNumber: Scalars['String']['input'];
  subscriptionType: LicenseAgreementSubscriptionType;
};

export enum LicenseAgreementSubscriptionType {
  Evidendbas = 'EVIDENDBAS',
  Evidendcor = 'EVIDENDCOR',
  Evidendnot = 'EVIDENDNOT',
}

export type Liquidation = {
  __typename?: 'Liquidation';
  reason?: Maybe<Scalars['String']['output']>;
};

export type LiquidationInput = {
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum Locale {
  Dutch = 'DUTCH',
  EnglishBritish = 'ENGLISH_BRITISH',
}

export type MagicLinkInput = {
  account: AccountInput;
  entitlement: Entitlement;
  registerId: Scalars['String']['input'];
  user: UserInput;
};

export type ManagementGroup = {
  __typename?: 'ManagementGroup';
  email?: Maybe<Scalars['String']['output']>;
  group: Group;
  notary: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registersCount: Scalars['Int']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  subscriptionType: SubscriptionType;
  temporaryAccessExpiration?: Maybe<Scalars['Date']['output']>;
  tradeRegisterNumber?: Maybe<Scalars['String']['output']>;
};

export type ManagementUser = {
  __typename?: 'ManagementUser';
  admin?: Maybe<Scalars['Boolean']['output']>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<Group>;
  groupAdmin?: Maybe<Scalars['Boolean']['output']>;
  temporaryAccessExpiration?: Maybe<Scalars['Date']['output']>;
  user: User;
  userAdmin?: Maybe<Scalars['Boolean']['output']>;
};

export type MeetingRights = {
  __typename?: 'MeetingRights';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate: Scalars['Date']['output'];
};

export type MeetingRightsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate: Scalars['Date']['input'];
};

export type Money = {
  __typename?: 'Money';
  cents: Scalars['BigInt']['output'];
  currencyCode: Scalars['String']['output'];
  precision: Scalars['Int']['output'];
  units: Scalars['BigInt']['output'];
};

export type MoneyInput = {
  cents: Scalars['BigInt']['input'];
  currencyCode: Scalars['String']['input'];
  precision: Scalars['BigInt']['input'];
  units: Scalars['BigInt']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  acceptInvitation: Invitation;
  addAllSharesToShareGroup: Array<ShareGroupEntry>;
  addKvkNumberToLegalEntity: LegalEntity;
  addLegalEntityToRegister: LegalEntity;
  correctShareTypeVersion: ShareType;
  createAccessRequest: AccessRequest;
  createDividendStatement: DividendStatement;
  createDocument: Document;
  createGroup: ManagementGroup;
  createLegalEntity: LegalEntity;
  createMutation: RegisterMutation;
  createNaturalPerson: NaturalPerson;
  createNotary: Notary;
  createShareGroup: ShareGroup;
  createShareGroupEntry: ShareGroupEntry;
  createShareType: ShareType;
  createUser: ManagementUser;
  deepDeleteRegister: Array<Scalars['String']['output']>;
  deleteAccessRequest: AccessRequest;
  deleteDividendStatement: Scalars['Boolean']['output'];
  deleteDocument: Document;
  deleteFile: File;
  deleteGroupLogo: Group;
  deleteMutation?: Maybe<RegisterMutation>;
  deleteNotary: Scalars['Boolean']['output'];
  deleteParticipation: ParticipationResponse;
  deleteRegister: Scalars['Boolean']['output'];
  deleteShareGroup: ShareGroup;
  deleteShareGroupEntry: ShareGroupEntry;
  deleteShareType: ShareType;
  deleteShareTypeVersion: ShareType;
  deleteUser: Scalars['Boolean']['output'];
  recalculateRegister: Register;
  remindAccessRequest: AccessRequest;
  renameFile: File;
  requestIdentityDocumentDownload: Scalars['URL']['output'];
  revokeInvitation: Invitation;
  saveJsonRegister: SaveJsonRegisterResult;
  saveJsonRegisters: Array<SaveJsonRegisterResult>;
  savePartyUpdates: Array<PartyUpdate>;
  setNotaryActive: Notary;
  signRegister: Register;
  signupLicenseAgreement: Scalars['Boolean']['output'];
  syncDividendStatementWithRegister: DividendStatement;
  unsignRegister: Register;
  updateAccount: Account;
  updateDividendStatement: DividendStatement;
  updateDividendStatementParty: DividendStatementParty;
  updateDocument: Document;
  updateGroup: ManagementGroup;
  updateLegalEntity: LegalEntity;
  updateMutation: RegisterMutation;
  updateNaturalPerson: NaturalPerson;
  updateNotary: Notary;
  updateParticipation: ParticipationResponse;
  updateRegister: Register;
  updateRegisterEntitlements: UpdateRegisterEntitlementsResponse;
  updateShareGroup: ShareGroup;
  updateShareGroupEntry: ShareGroupEntry;
  updateShareType: ShareType;
  updateUser: ManagementUser;
  uploadFile: File;
  uploadGroupLogo: Group;
  uploadIdentityDocument: IdentityDocument;
  validateMutation: Array<RegisterMutation>;
};

export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
  userRegistration: UserRegistration;
};

export type MutationAddAllSharesToShareGroupArgs = {
  partyId: Scalars['ID']['input'];
  shareGroupId: Scalars['ID']['input'];
};

export type MutationAddKvkNumberToLegalEntityArgs = {
  kvkNumber: Scalars['String']['input'];
  legalEntityId: Scalars['ID']['input'];
};

export type MutationAddLegalEntityToRegisterArgs = {
  legalEntityId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
};

export type MutationCorrectShareTypeVersionArgs = {
  shareType: ShareTypeInput;
  shareTypeVersionId: Scalars['ID']['input'];
};

export type MutationCreateAccessRequestArgs = {
  entitlement: Entitlement;
  reason: Scalars['String']['input'];
  registerId: Scalars['ID']['input'];
};

export type MutationCreateDividendStatementArgs = {
  dividendStatement: DividendStatementInput;
  registerId: Scalars['ID']['input'];
};

export type MutationCreateDocumentArgs = {
  document: DocumentInput;
  registerId: Scalars['ID']['input'];
};

export type MutationCreateGroupArgs = {
  group: GroupInput;
};

export type MutationCreateLegalEntityArgs = {
  legalEntity: LegalEntityInput;
  registerId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateMutationArgs = {
  legalEntityId: Scalars['ID']['input'];
  mutation?: InputMaybe<RegisterMutationInput>;
  mutationType: MutationType;
};

export type MutationCreateNaturalPersonArgs = {
  naturalPerson: NaturalPersonInput;
  registerId: Scalars['ID']['input'];
};

export type MutationCreateNotaryArgs = {
  input: CreateNotaryInput;
};

export type MutationCreateShareGroupArgs = {
  registerId: Scalars['ID']['input'];
  shareGroupName: Scalars['String']['input'];
};

export type MutationCreateShareGroupEntryArgs = {
  shareGroupEntryInput: ShareGroupEntryInput;
};

export type MutationCreateShareTypeArgs = {
  registerId: Scalars['ID']['input'];
  shareType: ShareTypeInput;
};

export type MutationCreateUserArgs = {
  user: UserInput;
};

export type MutationDeepDeleteRegisterArgs = {
  registerId: Scalars['ID']['input'];
};

export type MutationDeleteAccessRequestArgs = {
  accessRequestId: Scalars['ID']['input'];
};

export type MutationDeleteDividendStatementArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteFileArgs = {
  documentId: Scalars['ID']['input'];
};

export type MutationDeleteGroupLogoArgs = {
  groupId: Scalars['ID']['input'];
};

export type MutationDeleteMutationArgs = {
  mutationId: Scalars['ID']['input'];
};

export type MutationDeleteNotaryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteParticipationArgs = {
  partyId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
};

export type MutationDeleteRegisterArgs = {
  registerId: Scalars['ID']['input'];
};

export type MutationDeleteShareGroupArgs = {
  shareGroupId: Scalars['ID']['input'];
};

export type MutationDeleteShareGroupEntryArgs = {
  shareGroupEntryId: Scalars['ID']['input'];
};

export type MutationDeleteShareTypeArgs = {
  shareTypeId: Scalars['ID']['input'];
};

export type MutationDeleteShareTypeVersionArgs = {
  shareTypeVersionId: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRecalculateRegisterArgs = {
  registerId: Scalars['ID']['input'];
};

export type MutationRemindAccessRequestArgs = {
  accessRequestId: Scalars['ID']['input'];
  reminder: Scalars['String']['input'];
};

export type MutationRenameFileArgs = {
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
};

export type MutationRequestIdentityDocumentDownloadArgs = {
  naturalPersonId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

export type MutationRevokeInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};

export type MutationSaveJsonRegisterArgs = {
  registerJson: Scalars['String']['input'];
};

export type MutationSaveJsonRegistersArgs = {
  registersJson: Scalars['String']['input'];
};

export type MutationSavePartyUpdatesArgs = {
  document?: InputMaybe<DocumentInput>;
  partyUpdates: Array<PartyUpdateInput>;
};

export type MutationSetNotaryActiveArgs = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSignRegisterArgs = {
  registerId: Scalars['ID']['input'];
};

export type MutationSignupLicenseAgreementArgs = {
  input: LicenseAgreementInput;
};

export type MutationSyncDividendStatementWithRegisterArgs = {
  effectiveDate: Scalars['Date']['input'];
  id: Scalars['ID']['input'];
  save: Scalars['Boolean']['input'];
};

export type MutationUnsignRegisterArgs = {
  registerSignatureId: Scalars['ID']['input'];
};

export type MutationUpdateAccountArgs = {
  account: AccountInput;
};

export type MutationUpdateDividendStatementArgs = {
  dividendStatement: DividendStatementInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateDividendStatementPartyArgs = {
  dividendStatementParty: DividendStatementPartyInput;
  id: Scalars['ID']['input'];
};

export type MutationUpdateDocumentArgs = {
  document: DocumentInput;
  documentId: Scalars['ID']['input'];
};

export type MutationUpdateGroupArgs = {
  group: GroupInput;
  groupId: Scalars['ID']['input'];
};

export type MutationUpdateLegalEntityArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  legalEntity: LegalEntityInput;
  legalEntityId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMutationArgs = {
  mutation: RegisterMutationInput;
  mutationId: Scalars['ID']['input'];
};

export type MutationUpdateNaturalPersonArgs = {
  naturalPerson: NaturalPersonInput;
  naturalPersonId: Scalars['ID']['input'];
};

export type MutationUpdateNotaryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNotaryInput;
};

export type MutationUpdateParticipationArgs = {
  participationInput: ParticipationInput;
  partyId: Scalars['ID']['input'];
};

export type MutationUpdateRegisterArgs = {
  register: RegisterInput;
  registerId: Scalars['ID']['input'];
};

export type MutationUpdateRegisterEntitlementsArgs = {
  entitledEntities: Array<EntitledEntityInput>;
  registerId: Scalars['ID']['input'];
};

export type MutationUpdateShareGroupArgs = {
  shareGroupId: Scalars['ID']['input'];
  shareGroupName: Scalars['String']['input'];
};

export type MutationUpdateShareGroupEntryArgs = {
  shareGroupEntryId: Scalars['ID']['input'];
  shareGroupEntryInput: ShareGroupEntryInput;
};

export type MutationUpdateShareTypeArgs = {
  shareType: ShareTypeInput;
  shareTypeId: Scalars['ID']['input'];
};

export type MutationUpdateUserArgs = {
  user: UserInput;
  userId: Scalars['ID']['input'];
};

export type MutationUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};

export type MutationUploadGroupLogoArgs = {
  groupId: Scalars['ID']['input'];
  logo: Scalars['String']['input'];
};

export type MutationUploadIdentityDocumentArgs = {
  expiryDate: Scalars['Date']['input'];
  file: Scalars['Upload']['input'];
  naturalPersonId: Scalars['ID']['input'];
  type: IdentityDocumentType;
};

export type MutationValidateMutationArgs = {
  mutation?: InputMaybe<RegisterMutationInput>;
  mutationId: Scalars['ID']['input'];
};

export type MutationFilterInput = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdatedByUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationPrice = {
  __typename?: 'MutationPrice';
  amountEuros: Scalars['Float']['output'];
  exemption?: Maybe<PriceExemption>;
};

export type MutationSummary = {
  __typename?: 'MutationSummary';
  group: Group;
  mutation: RegisterMutation;
};

export enum MutationType {
  Administration = 'ADMINISTRATION',
  AppointDirector = 'APPOINT_DIRECTOR',
  ArticleOfAssociation = 'ARTICLE_OF_ASSOCIATION',
  Attachment = 'ATTACHMENT',
  Conversion = 'CONVERSION',
  EndAdministration = 'END_ADMINISTRATION',
  EndAttachment = 'END_ATTACHMENT',
  EndDirectorship = 'END_DIRECTORSHIP',
  EndPledge = 'END_PLEDGE',
  EndUbo = 'END_UBO',
  EndUsufruct = 'END_USUFRUCT',
  Incorporation = 'INCORPORATION',
  Issuance = 'ISSUANCE',
  Liquidation = 'LIQUIDATION',
  Onboarding = 'ONBOARDING',
  PayingUp = 'PAYING_UP',
  Pledge = 'PLEDGE',
  Transfer = 'TRANSFER',
  TrustConditions = 'TRUST_CONDITIONS',
  Ubo = 'UBO',
  Usufruct = 'USUFRUCT',
  Withdrawal = 'WITHDRAWAL',
}

export type MutationsResponse = {
  __typename?: 'MutationsResponse';
  items: Array<RegisterMutation>;
  pagination: Pagination;
};

export type Name = {
  __typename?: 'Name';
  firstName?: Maybe<Scalars['String']['output']>;
  initials?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  preposition?: Maybe<Scalars['String']['output']>;
};

export type NameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  preposition?: InputMaybe<Scalars['String']['input']>;
};

export type NaturalPerson = {
  __typename?: 'NaturalPerson';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  dateOfDecease?: Maybe<Scalars['Date']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  identityDocument?: Maybe<IdentityDocument>;
  name: Name;
  participation?: Maybe<Participation>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<PostalAddress>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type NaturalPersonInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  dateOfDecease?: InputMaybe<Scalars['Date']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeOfBirth?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<PostalAddressInput>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type Notary = {
  __typename?: 'Notary';
  active: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  location: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  type: NotaryType;
};

export enum NotaryRole {
  AssignedNotary = 'ASSIGNED_NOTARY',
  DeputyNotary = 'DEPUTY_NOTARY',
  Notary = 'NOTARY',
  UnknownNotary = 'UNKNOWN_NOTARY',
}

export enum NotaryType {
  Associate = 'ASSOCIATE',
  Notary = 'NOTARY',
  Observer = 'OBSERVER',
}

export type Onboarding = {
  __typename?: 'Onboarding';
  paid?: Maybe<Scalars['Boolean']['output']>;
  shareSeries: ShareSeries;
  to: Party;
};

export type OnboardingInput = {
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  shareSeries: ShareSeriesInput;
  toPartyId: Scalars['ID']['input'];
};

export type Pagination = {
  __typename?: 'Pagination';
  count: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  sort: Array<SortInput>;
};

export type Participation = {
  __typename?: 'Participation';
  comment?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  meetingRights?: Maybe<MeetingRights>;
  participationTypes: Array<ParticipationType>;
  register: Register;
  shareBatches: Array<ShareBatch>;
  tags: Array<Scalars['String']['output']>;
};

export type ParticipationInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  meetingRights?: InputMaybe<MeetingRightsInput>;
  registerId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type ParticipationResponse = {
  __typename?: 'ParticipationResponse';
  party?: Maybe<Party>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export enum ParticipationType {
  Bailiff = 'BAILIFF',
  Guardian = 'GUARDIAN',
  Historical = 'HISTORICAL',
  Pledgee = 'PLEDGEE',
  RequiredInAttachment = 'REQUIRED_IN_ATTACHMENT',
  Shareholder = 'SHAREHOLDER',
  Usufructee = 'USUFRUCTEE',
}

export type Party = {
  __typename?: 'Party';
  id: Scalars['ID']['output'];
  legalEntity?: Maybe<LegalEntity>;
  naturalPerson?: Maybe<NaturalPerson>;
  type: PartyType;
};

export type PartyAttachment = {
  __typename?: 'PartyAttachment';
  attachedAt: Scalars['DateTime']['output'];
  bailiff: Party;
  requiredBy: Array<Party>;
  shareSeries: Array<ShareBatch>;
  type: AttachmentType;
};

export type PartyAttachmentState = {
  __typename?: 'PartyAttachmentState';
  attachments: Array<PartyAttachment>;
  party: Party;
};

export type PartyMutation = {
  __typename?: 'PartyMutation';
  delta: Array<ShareBatch>;
  mutation: RegisterMutation;
  result: Array<ShareBatch>;
  shareTypeUpdate: Array<ShareTypeUpdate>;
};

export type PartyMutationHistory = {
  __typename?: 'PartyMutationHistory';
  mutations: Array<PartyMutation>;
  party: Party;
  partyUpdateHistory: Array<PartyUpdateHistory>;
};

export type PartySearchFilterInput = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type: PartySearchType;
};

export type PartySearchResponse = {
  __typename?: 'PartySearchResponse';
  items: Array<Party>;
  pagination: Pagination;
};

export enum PartySearchType {
  AccessibleRegisters = 'ACCESSIBLE_REGISTERS',
  AccessibleShareholders = 'ACCESSIBLE_SHAREHOLDERS',
  AllRegisters = 'ALL_REGISTERS',
  EntitledEntityRegisters = 'ENTITLED_ENTITY_REGISTERS',
  GroupRegisters = 'GROUP_REGISTERS',
}

export enum PartyType {
  LegalEntity = 'LEGAL_ENTITY',
  NaturalPerson = 'NATURAL_PERSON',
}

export type PartyUpdate = {
  __typename?: 'PartyUpdate';
  after?: Maybe<Scalars['String']['output']>;
  before?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  document?: Maybe<Document>;
  field: PartyUpdateField;
  id: Scalars['ID']['output'];
  party: Party;
  reason?: Maybe<Scalars['String']['output']>;
  requiresDocument: Scalars['Boolean']['output'];
};

export enum PartyUpdateField {
  CorrespondenceAddressCity = 'CORRESPONDENCE_ADDRESS_CITY',
  CorrespondenceAddressCountryCode = 'CORRESPONDENCE_ADDRESS_COUNTRY_CODE',
  CorrespondenceAddressPostalCode = 'CORRESPONDENCE_ADDRESS_POSTAL_CODE',
  CorrespondenceAddressPostalCodeCity = 'CORRESPONDENCE_ADDRESS_POSTAL_CODE_CITY',
  CorrespondenceAddressPostOfficeBoxNumber = 'CORRESPONDENCE_ADDRESS_POST_OFFICE_BOX_NUMBER',
  CorrespondenceAddressRegion = 'CORRESPONDENCE_ADDRESS_REGION',
  CorrespondenceAddressStreetAndNumber = 'CORRESPONDENCE_ADDRESS_STREET_AND_NUMBER',
  CorrespondenceAddressStreetName = 'CORRESPONDENCE_ADDRESS_STREET_NAME',
  CorrespondenceAddressStreetNumber = 'CORRESPONDENCE_ADDRESS_STREET_NUMBER',
  CorrespondenceAddressStreetNumberAddition = 'CORRESPONDENCE_ADDRESS_STREET_NUMBER_ADDITION',
  CountryOfRegistration = 'COUNTRY_OF_REGISTRATION',
  EmailAddresses = 'EMAIL_ADDRESSES',
  IncorporatedBy = 'INCORPORATED_BY',
  IncorporatedOn = 'INCORPORATED_ON',
  LegalForm = 'LEGAL_FORM',
  PhoneNumber = 'PHONE_NUMBER',
  RegisteredOn = 'REGISTERED_ON',
  RsinNumber = 'RSIN_NUMBER',
  StatutoryName = 'STATUTORY_NAME',
  TradeRegisterNumber = 'TRADE_REGISTER_NUMBER',
  VisitorAddressCity = 'VISITOR_ADDRESS_CITY',
  VisitorAddressCountryCode = 'VISITOR_ADDRESS_COUNTRY_CODE',
  VisitorAddressPostalCode = 'VISITOR_ADDRESS_POSTAL_CODE',
  VisitorAddressPostalCodeCity = 'VISITOR_ADDRESS_POSTAL_CODE_CITY',
  VisitorAddressPostOfficeBoxNumber = 'VISITOR_ADDRESS_POST_OFFICE_BOX_NUMBER',
  VisitorAddressRegion = 'VISITOR_ADDRESS_REGION',
  VisitorAddressStreetAndNumber = 'VISITOR_ADDRESS_STREET_AND_NUMBER',
  VisitorAddressStreetName = 'VISITOR_ADDRESS_STREET_NAME',
  VisitorAddressStreetNumber = 'VISITOR_ADDRESS_STREET_NUMBER',
  VisitorAddressStreetNumberAddition = 'VISITOR_ADDRESS_STREET_NUMBER_ADDITION',
}

export type PartyUpdateHistory = {
  __typename?: 'PartyUpdateHistory';
  date: Scalars['Date']['output'];
  party: Party;
  updateFields: Array<PartyUpdateField>;
};

export type PartyUpdateInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  partyUpdateId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type PayingUp = {
  __typename?: 'PayingUp';
  owner: Party;
  shareSeries: ShareSeries;
};

export type PayingUpInput = {
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type Pledge = {
  __typename?: 'Pledge';
  details?: Maybe<DelegationDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type PledgeInput = {
  details?: InputMaybe<DelegationDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type PostalAddress = {
  __typename?: 'PostalAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postOfficeBoxNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalCodeCity?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetHouseNumber?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  streetNumberAddition?: Maybe<Scalars['String']['output']>;
};

export type PostalAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postOfficeBoxNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  postalCodeCity?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  streetNumberAddition?: InputMaybe<Scalars['String']['input']>;
};

export type PpuFilterInput = {
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PpuMutation = {
  __typename?: 'PpuMutation';
  amountEuros: Scalars['Float']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalEntity?: Maybe<LegalEntity>;
  product?: Maybe<PpuProduct>;
  productGroup?: Maybe<PpuProductGroup>;
  referenceId?: Maybe<Scalars['String']['output']>;
  type: PpuMutationType;
};

export type PpuMutationResponse = {
  __typename?: 'PpuMutationResponse';
  items: Array<PpuMutation>;
  totalCount: Scalars['Int']['output'];
  totalSpentEuros: Scalars['Float']['output'];
};

export enum PpuMutationType {
  Expense = 'Expense',
  Replenishment = 'Replenishment',
}

export type PpuProduct = {
  __typename?: 'PpuProduct';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PpuProductGroup = {
  __typename?: 'PpuProductGroup';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum PriceExemption {
  Backdated = 'BACKDATED',
  CorporateRegister = 'CORPORATE_REGISTER',
  FreeType = 'FREE_TYPE',
  SubscriptionIncludes = 'SUBSCRIPTION_INCLUDES',
}

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  accessRequests?: Maybe<Array<AccessRequest>>;
  account?: Maybe<Account>;
  availableShareTypesForCertification: Array<CertifiableShareType>;
  consistencyLog: ConsistencyLog;
  deleteRelease: Scalars['Boolean']['output'];
  dividendStatement: DividendStatement;
  dividendStatements: Array<DividendStatement>;
  downloadFile: Scalars['URL']['output'];
  entitledEntities: EntitledEntitySummaryResponse;
  entitledEntity?: Maybe<EntitledEntitySummary>;
  exportDividendStatementCsv: Scalars['URL']['output'];
  exportDividendStatementPartyPdf: Scalars['URL']['output'];
  exportDividendStatementPdf: Scalars['Boolean']['output'];
  exportRegisterOfShareholders: Scalars['URL']['output'];
  exportShareholderCsv: Scalars['URL']['output'];
  exportShareholderExcel: Scalars['URL']['output'];
  exportShareholderExtract: Scalars['URL']['output'];
  getDividendStatementDefaults: DividendStatement;
  group?: Maybe<ManagementGroup>;
  groups: Array<ManagementGroup>;
  invitation: Invitation;
  invitationPostalAddressLookup: PostalAddress;
  invitations: Array<Invitation>;
  jsonRegister: Scalars['String']['output'];
  jsonRegisters: Scalars['String']['output'];
  kvkLookup: LegalEntity;
  kvkUpdates: Array<PartyUpdate>;
  legalEntity: LegalEntity;
  mutation: RegisterMutation;
  mutationPrice: MutationPrice;
  mutationSummary: Array<MutationSummary>;
  mutations: MutationsResponse;
  naturalPerson: NaturalPerson;
  notaries: Array<Notary>;
  partySearch: PartySearchResponse;
  postalAddressLookup: PostalAddress;
  ppuMutation: PpuMutationResponse;
  ppuMutationExcel: Scalars['URL']['output'];
  register: Register;
  registerAuditTrail?: Maybe<RegisterAuditTrailResponse>;
  registerDistributionChart: DistributionChart;
  registerEntitlements: Array<EntitledEntity>;
  registerOfShareholders?: Maybe<RegisterOfShareholders>;
  releases: Array<Release>;
  searchCompanies: Array<CompanySearchResult>;
  shareGroupEntries: Array<ShareGroupEntry>;
  shareGroups: Array<ShareGroup>;
  shareholderExtract?: Maybe<ShareholderExtract>;
  shareholderGraph: ShareholderGraph;
  users: Array<ManagementUser>;
};

export type QueryAccessRequestsArgs = {
  registerId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAvailableShareTypesForCertificationArgs = {
  stakId: Scalars['ID']['input'];
};

export type QueryDeleteReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};

export type QueryDividendStatementArgs = {
  id: Scalars['ID']['input'];
  partyIdFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryDividendStatementsArgs = {
  registerId: Scalars['ID']['input'];
};

export type QueryDownloadFileArgs = {
  documentId: Scalars['ID']['input'];
};

export type QueryEntitledEntitiesArgs = {
  pagination: PaginationInput;
};

export type QueryEntitledEntityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExportDividendStatementCsvArgs = {
  id: Scalars['ID']['input'];
  locale: Locale;
};

export type QueryExportDividendStatementPartyPdfArgs = {
  id: Scalars['ID']['input'];
  locale: Locale;
  partyId: Scalars['ID']['input'];
};

export type QueryExportDividendStatementPdfArgs = {
  id: Scalars['ID']['input'];
  locale: Locale;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

export type QueryExportRegisterOfShareholdersArgs = {
  locale: Locale;
  registerId: Scalars['ID']['input'];
  sign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryExportShareholderCsvArgs = {
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Locale;
  registerId: Scalars['ID']['input'];
};

export type QueryExportShareholderExcelArgs = {
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Locale;
  registerId: Scalars['ID']['input'];
};

export type QueryExportShareholderExtractArgs = {
  locale: Locale;
  partyId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
};

export type QueryGetDividendStatementDefaultsArgs = {
  effectiveDate: Scalars['Date']['input'];
  registerId: Scalars['ID']['input'];
};

export type QueryGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryInvitationArgs = {
  token: Scalars['String']['input'];
};

export type QueryInvitationPostalAddressLookupArgs = {
  houseNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type QueryInvitationsArgs = {
  registerId: Scalars['ID']['input'];
};

export type QueryJsonRegisterArgs = {
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  registerId: Scalars['ID']['input'];
};

export type QueryJsonRegistersArgs = {
  anonymize?: InputMaybe<Scalars['Boolean']['input']>;
  registerIds: Array<Scalars['ID']['input']>;
};

export type QueryKvkLookupArgs = {
  kvkNumber: Scalars['String']['input'];
};

export type QueryKvkUpdatesArgs = {
  partyId: Scalars['ID']['input'];
};

export type QueryLegalEntityArgs = {
  legalEntityId: Scalars['ID']['input'];
};

export type QueryMutationArgs = {
  mutationId: Scalars['ID']['input'];
};

export type QueryMutationPriceArgs = {
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  legalEntityId: Scalars['ID']['input'];
  mutationType: MutationType;
};

export type QueryMutationSummaryArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryMutationsArgs = {
  filter?: InputMaybe<MutationFilterInput>;
  pagination: PaginationInput;
};

export type QueryNaturalPersonArgs = {
  naturalPersonId: Scalars['ID']['input'];
};

export type QueryPartySearchArgs = {
  filter?: InputMaybe<PartySearchFilterInput>;
  pagination: PaginationInput;
};

export type QueryPostalAddressLookupArgs = {
  postalCode: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
};

export type QueryPpuMutationArgs = {
  filter?: InputMaybe<PpuFilterInput>;
};

export type QueryPpuMutationExcelArgs = {
  filter?: InputMaybe<PpuFilterInput>;
  pagination: PaginationInput;
};

export type QueryRegisterArgs = {
  atDate?: InputMaybe<Scalars['Date']['input']>;
  mutationId?: InputMaybe<Scalars['String']['input']>;
  registerId: Scalars['ID']['input'];
};

export type QueryRegisterAuditTrailArgs = {
  filter: RegisterAuditTrailFilterInput;
  pagination: PaginationInput;
};

export type QueryRegisterDistributionChartArgs = {
  filterBy?: InputMaybe<DistributionChartFilterBy>;
  groupBy: DistributionChartGroupBy;
  registerId: Scalars['ID']['input'];
};

export type QueryRegisterEntitlementsArgs = {
  registerId: Scalars['ID']['input'];
};

export type QueryRegisterOfShareholdersArgs = {
  locale?: InputMaybe<Locale>;
  registerId: Scalars['ID']['input'];
};

export type QueryReleasesArgs = {
  locale?: InputMaybe<Locale>;
};

export type QuerySearchCompaniesArgs = {
  searchTerm: Scalars['String']['input'];
};

export type QueryShareGroupEntriesArgs = {
  registerId: Scalars['ID']['input'];
};

export type QueryShareGroupsArgs = {
  registerId: Scalars['ID']['input'];
};

export type QueryShareholderExtractArgs = {
  locale?: InputMaybe<Locale>;
  registerId: Scalars['ID']['input'];
  shareholderId: Scalars['ID']['input'];
};

export type QueryShareholderGraphArgs = {
  groupBy: ShareholderGraphGroupBy;
  legalEntityId: Scalars['ID']['input'];
  shareholderGraphType?: InputMaybe<ShareholderGraphType>;
};

export type QueryUsersArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
};

export type Register = {
  __typename?: 'Register';
  articleOfAssociationUpdatedOn?: Maybe<Scalars['Date']['output']>;
  documents: Array<Document>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endedOn?: Maybe<Scalars['Date']['output']>;
  entitlement: Entitlement;
  id: Scalars['ID']['output'];
  isSigned: Scalars['Boolean']['output'];
  lastUpdatedOn: Scalars['DateTime']['output'];
  legalEntity: LegalEntity;
  mutations: Array<RegisterMutation>;
  replacement: Scalars['Boolean']['output'];
  requestForAccess?: Maybe<AccessRequest>;
  shareBatches: Array<ShareBatch>;
  shareTypes: Array<ShareType>;
  shareholders: Array<Party>;
  signatures: Array<RegisterSignature>;
  trustConditionsUpdatedOn?: Maybe<Scalars['Date']['output']>;
};

export type RegisterAuditTrailEvent = {
  __typename?: 'RegisterAuditTrailEvent';
  details?: Maybe<Scalars['String']['output']>;
  eventType: AuditTrailEventType;
  id: Scalars['ID']['output'];
  params: Array<AuditTrailParam>;
  register: RegisterSummary;
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<ManagementUser>;
};

export type RegisterAuditTrailFilterInput = {
  eventTypes?: InputMaybe<Array<AuditTrailEventType>>;
  query?: InputMaybe<Scalars['String']['input']>;
  registerId: Scalars['String']['input'];
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RegisterAuditTrailResponse = {
  __typename?: 'RegisterAuditTrailResponse';
  items: Array<RegisterAuditTrailEvent>;
  pagination: Pagination;
};

export type RegisterInput = {
  replacement: Scalars['Boolean']['input'];
};

export type RegisterMutation = {
  __typename?: 'RegisterMutation';
  acknowledgedDate?: Maybe<Scalars['Date']['output']>;
  administration?: Maybe<Array<Administration>>;
  appointDirector?: Maybe<Array<Director>>;
  attachment?: Maybe<Array<Attachment>>;
  commentary?: Maybe<Scalars['String']['output']>;
  conversion?: Maybe<Array<Conversion>>;
  createdOn: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  dossierNumber?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  endAdministration?: Maybe<Array<EndAdministration>>;
  endAttachment?: Maybe<Array<EndAttachment>>;
  endDirectorship?: Maybe<Array<EndDirectorship>>;
  endPledge?: Maybe<Array<EndPledge>>;
  endUbo?: Maybe<Array<EndUbo>>;
  endUsufruct?: Maybe<Array<EndUsufruct>>;
  id: Scalars['ID']['output'];
  incorporation?: Maybe<Array<Incorporation>>;
  isDraft: Scalars['Boolean']['output'];
  issuance?: Maybe<Array<Issuance>>;
  lastUpdatedBy: User;
  lastUpdatedOn: Scalars['DateTime']['output'];
  liquidation?: Maybe<Liquidation>;
  onboarding?: Maybe<Array<Onboarding>>;
  payingUp?: Maybe<Array<PayingUp>>;
  pledge?: Maybe<Array<Pledge>>;
  price: MutationPrice;
  register: Register;
  seq?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  transfer?: Maybe<Array<Transfer>>;
  type: MutationType;
  ubo?: Maybe<Array<Ubo>>;
  usufruct?: Maybe<Array<Usufruct>>;
  validationErrors: Array<ValidationError>;
  withdrawal?: Maybe<Array<Withdrawal>>;
};

export type RegisterMutationInput = {
  acknowledgedDate?: InputMaybe<Scalars['Date']['input']>;
  administration?: InputMaybe<Array<AdministrationInput>>;
  appointDirector?: InputMaybe<Array<DirectorInput>>;
  attachment?: InputMaybe<Array<AttachmentInput>>;
  commentary?: InputMaybe<Scalars['String']['input']>;
  conversion?: InputMaybe<Array<ConversionInput>>;
  document?: InputMaybe<DocumentInput>;
  dossierNumber?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  endAdministration?: InputMaybe<Array<EndAdministrationInput>>;
  endAttachment?: InputMaybe<Array<EndAttachmentInput>>;
  endDirectorship?: InputMaybe<Array<EndDirectorshipInput>>;
  endPledge?: InputMaybe<Array<EndPledgeInput>>;
  endUbo?: InputMaybe<Array<EndUboInput>>;
  endUsufruct?: InputMaybe<Array<EndUsufructInput>>;
  incorporation?: InputMaybe<Array<IncorporationInput>>;
  isDraft: Scalars['Boolean']['input'];
  issuance?: InputMaybe<Array<IssuanceInput>>;
  liquidation?: InputMaybe<LiquidationInput>;
  onboarding?: InputMaybe<Array<OnboardingInput>>;
  payingUp?: InputMaybe<Array<PayingUpInput>>;
  pledge?: InputMaybe<Array<PledgeInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  transfer?: InputMaybe<Array<TransferInput>>;
  ubo?: InputMaybe<Array<UboInput>>;
  usufruct?: InputMaybe<Array<UsufructInput>>;
  withdrawal?: InputMaybe<Array<WithdrawalInput>>;
};

export type RegisterOfShareholders = {
  __typename?: 'RegisterOfShareholders';
  capitalHistory?: Maybe<CapitalHistory>;
  guardianMutationHistory: Array<PartyMutationHistory>;
  hasDraftMutation: Scalars['Boolean']['output'];
  hasInvalidMutation: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  partyAttachmentStates: Array<PartyAttachmentState>;
  partyMutationHistory: Array<PartyMutationHistory>;
  partyUpdateHistory: Array<PartyUpdateHistory>;
  pledgeeMutationHistory: Array<PartyMutationHistory>;
  register: Register;
  usufructuaryMutationHistory: Array<PartyMutationHistory>;
};

export type RegisterSignature = {
  __typename?: 'RegisterSignature';
  id: Scalars['ID']['output'];
  signedOn: Scalars['DateTime']['output'];
  user: User;
};

export type RegisterSummary = {
  __typename?: 'RegisterSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originId?: Maybe<Scalars['String']['output']>;
  tradeRegisterNumber?: Maybe<Scalars['String']['output']>;
};

export type Release = {
  __typename?: 'Release';
  content?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  locale: Locale;
  media?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum RepresentationAuthority {
  Limited = 'LIMITED',
  Unlimited = 'UNLIMITED',
}

export enum Salutation {
  Mr = 'MR',
  Ms = 'MS',
}

export type SaveJsonRegisterResult = {
  __typename?: 'SaveJsonRegisterResult';
  register: Register;
};

export type ShareBatch = {
  __typename?: 'ShareBatch';
  acquiredBy: Array<RegisterMutation>;
  administrationDetails?: Maybe<AdministrationDetails>;
  attachmentDetails?: Maybe<AttachmentDetails>;
  modifiedBy: Array<RegisterMutation>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  pledgeDetails: Array<DelegationDetails>;
  shareSeries: ShareSeries;
  shareholder: Party;
  usufructDetails: Array<DelegationDetails>;
};

export type ShareGroup = {
  __typename?: 'ShareGroup';
  entries: Array<ShareGroupEntry>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  registerId: Scalars['ID']['output'];
};

export type ShareGroupEntry = {
  __typename?: 'ShareGroupEntry';
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  party: Party;
  shareGroup: ShareGroup;
  shareSeries: ShareSeries;
};

export type ShareGroupEntryInput = {
  partyId: Scalars['ID']['input'];
  shareGroupId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type ShareSeries = {
  __typename?: 'ShareSeries';
  from: Scalars['BigInt']['output'];
  shareType: ShareType;
  to: Scalars['BigInt']['output'];
};

export type ShareSeriesInput = {
  from: Scalars['BigInt']['input'];
  shareTypeId: Scalars['ID']['input'];
  to: Scalars['BigInt']['input'];
};

export type ShareType = {
  __typename?: 'ShareType';
  authorizedCapitalAmount: Scalars['BigInt']['output'];
  certificatesPerShare?: Maybe<Scalars['Float']['output']>;
  classifier?: Maybe<Scalars['String']['output']>;
  createdInMutation?: Maybe<RegisterMutation>;
  dividend: Scalars['Boolean']['output'];
  endedOn?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  meeting: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nominalValue: Money;
  register: Register;
  underlyingShareType?: Maybe<ShareType>;
  versionId: Scalars['ID']['output'];
  versions: Array<ShareTypeVersion>;
  voting: Scalars['Boolean']['output'];
};

export type ShareTypeInput = {
  authorizedCapitalAmount: Scalars['BigInt']['input'];
  certificatesPerShare?: InputMaybe<Scalars['Float']['input']>;
  classifier?: InputMaybe<Scalars['String']['input']>;
  createdInMutationId: Scalars['ID']['input'];
  dividend: Scalars['Boolean']['input'];
  endedOn?: InputMaybe<Scalars['Date']['input']>;
  meeting: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nominalValue: MoneyInput;
  underlyingShareTypeId?: InputMaybe<Scalars['ID']['input']>;
  voting: Scalars['Boolean']['input'];
};

export type ShareTypeUpdate = {
  __typename?: 'ShareTypeUpdate';
  after: ShareTypeVersion;
  before: ShareTypeVersion;
};

export type ShareTypeVersion = {
  __typename?: 'ShareTypeVersion';
  authorizedCapitalAmount: Scalars['BigInt']['output'];
  certificatesPerShare?: Maybe<Scalars['Float']['output']>;
  classifier?: Maybe<Scalars['String']['output']>;
  createdInMutation?: Maybe<RegisterMutation>;
  dividend: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  meeting: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nominalValue: Money;
  underlyingShareType?: Maybe<ShareType>;
  voting: Scalars['Boolean']['output'];
};

export type ShareholderExtract = {
  __typename?: 'ShareholderExtract';
  guardianMutationHistory: Array<PartyMutation>;
  hasDraftMutation: Scalars['Boolean']['output'];
  hasInvalidMutation: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  party: Party;
  partyAttachments: Array<PartyAttachment>;
  partyMutationHistory: Array<PartyMutation>;
  partyUpdateHistory: Array<PartyUpdateHistory>;
  pledgeeMutationHistory: Array<PartyMutation>;
  register: Register;
  registerUpdateHistory: Array<PartyUpdateHistory>;
  usufructuaryMutationHistory: Array<PartyMutation>;
};

export type ShareholderGraph = {
  __typename?: 'ShareholderGraph';
  edges: Array<ShareholderGraphEdge>;
  nodes: Array<ShareholderGraphNode>;
};

export type ShareholderGraphEdge = {
  __typename?: 'ShareholderGraphEdge';
  effectiveIn?: Maybe<LegalEntity>;
  from: Party;
  percentage: Scalars['Float']['output'];
  quantity: Scalars['BigInt']['output'];
  to: Party;
};

export enum ShareholderGraphGroupBy {
  DividendRightHolder = 'DIVIDEND_RIGHT_HOLDER',
  MeetingRightHolder = 'MEETING_RIGHT_HOLDER',
  Shareholder = 'SHAREHOLDER',
  VotingRightHolder = 'VOTING_RIGHT_HOLDER',
}

export type ShareholderGraphNode = {
  __typename?: 'ShareholderGraphNode';
  id?: Maybe<Scalars['ID']['output']>;
  party: Party;
};

export enum ShareholderGraphType {
  GraphTypeFull = 'GRAPH_TYPE_FULL',
  GraphTypeLimited = 'GRAPH_TYPE_LIMITED',
}

export type SortInput = {
  field: Scalars['String']['input'];
  order?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SubscriptionType {
  Evidendadmin = 'EVIDENDADMIN',
  Evidendbas = 'EVIDENDBAS',
  Evidendcer = 'EVIDENDCER',
  Evidendcor = 'EVIDENDCOR',
  Evidendfree = 'EVIDENDFREE',
  Evidendlit = 'EVIDENDLIT',
  Evidendnot = 'EVIDENDNOT',
  Evidendven = 'EVIDENDVEN',
}

export type Transfer = {
  __typename?: 'Transfer';
  from: Party;
  shareSeries: ShareSeries;
  to?: Maybe<Party>;
};

export type TransferInput = {
  fromPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
  toPartyId?: InputMaybe<Scalars['ID']['input']>;
};

export type Ubo = {
  __typename?: 'Ubo';
  ground: UboGround;
  naturalPerson: Party;
  ownershipRange?: Maybe<UboOwnershipRange>;
};

export enum UboGround {
  Control = 'CONTROL',
  Director = 'DIRECTOR',
  Economic = 'ECONOMIC',
  Ownership = 'OWNERSHIP',
  Voting = 'VOTING',
}

export type UboInput = {
  ground: UboGround;
  naturalPersonId: Scalars['ID']['input'];
  ownershipRange?: InputMaybe<UboOwnershipRange>;
};

export enum UboOwnershipRange {
  Range_25_50 = 'RANGE_25_50',
  Range_51_75 = 'RANGE_51_75',
  Range_76_100 = 'RANGE_76_100',
}

export type UpdateNotaryInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  initials?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NotaryType>;
};

export type UpdateRegisterEntitlementsResponse = {
  __typename?: 'UpdateRegisterEntitlementsResponse';
  accessRequests?: Maybe<Array<AccessRequest>>;
  entitlements?: Maybe<Array<EntitledEntity>>;
  invitations?: Maybe<Array<Invitation>>;
  validationErrors?: Maybe<Array<ValidationError>>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Name;
};

export type UserInput = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  groupAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  name: NameInput;
  userAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserRegistration = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  houseNumberAddition?: InputMaybe<Scalars['String']['input']>;
  lastname: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  salutation: Salutation;
  street: Scalars['String']['input'];
};

export type Usufruct = {
  __typename?: 'Usufruct';
  details?: Maybe<DelegationDetails>;
  owner: Party;
  shareSeries: ShareSeries;
};

export type UsufructInput = {
  details?: InputMaybe<DelegationDetailsInput>;
  ownerPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  code: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  params: Array<ValidationErrorParam>;
};

export type ValidationErrorParam = {
  __typename?: 'ValidationErrorParam';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  from: Party;
  shareSeries: ShareSeries;
};

export type WithdrawalInput = {
  fromPartyId: Scalars['ID']['input'];
  shareSeries: ShareSeriesInput;
};

export type MoneyFieldsFragment = {
  __typename?: 'Money';
  currencyCode: string;
  units: any;
  cents: any;
  precision: number;
};

export type ValidationErrorsFieldsFragment = {
  __typename?: 'ValidationError';
  field?: string | null;
  code: string;
  message?: string | null;
  params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
};

export type PostalAddressFieldsFragment = {
  __typename?: 'PostalAddress';
  streetName?: string | null;
  streetNumber?: string | null;
  streetNumberAddition?: string | null;
  postalCode?: string | null;
  postOfficeBoxNumber?: string | null;
  city?: string | null;
  countryCode?: string | null;
  streetHouseNumber?: string | null;
  postalCodeCity?: string | null;
  region?: string | null;
};

export type LegalEntityFieldsFragment = {
  __typename?: 'LegalEntity';
  id: string;
  name: string;
  incorporatedOn?: any | null;
  legalForm?: string | null;
  isFoundation: boolean;
  phoneNumber?: string | null;
  emailAddress?: string | null;
  tradeRegisterNumber?: string | null;
  countryOfRegistration: string;
  rsinNumber?: string | null;
  visitorAddress?: {
    __typename?: 'PostalAddress';
    streetName?: string | null;
    streetNumber?: string | null;
    streetNumberAddition?: string | null;
    postalCode?: string | null;
    postOfficeBoxNumber?: string | null;
    city?: string | null;
    countryCode?: string | null;
    streetHouseNumber?: string | null;
    postalCodeCity?: string | null;
    region?: string | null;
  } | null;
  correspondenceAddress?: {
    __typename?: 'PostalAddress';
    streetName?: string | null;
    streetNumber?: string | null;
    streetNumberAddition?: string | null;
    postalCode?: string | null;
    postOfficeBoxNumber?: string | null;
    city?: string | null;
    countryCode?: string | null;
    streetHouseNumber?: string | null;
    postalCodeCity?: string | null;
    region?: string | null;
  } | null;
};

export type NameFieldsFragment = {
  __typename?: 'Name';
  preposition?: string | null;
  initials?: string | null;
  firstName?: string | null;
  nickname?: string | null;
  lastName: string;
};

export type EntitledEntityFieldsFragment = {
  __typename?: 'EntitledEntity';
  id: string;
  name: string;
  email?: string | null;
  type: EntityType;
  entitlement: Entitlement;
  temporaryAccessExpiration?: any | null;
};

export type AccessRequestFieldsFragment = {
  __typename?: 'AccessRequest';
  id: string;
  requestedAt: any;
  entitlement: Entitlement;
  reason: string;
  register: {
    __typename?: 'Register';
    id: string;
    legalEntity: { __typename?: 'LegalEntity'; name: string; tradeRegisterNumber?: string | null };
  };
  requestedByGroup: { __typename?: 'Group'; id: string; name: string };
  requestedByUser: {
    __typename?: 'User';
    id: string;
    email: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  };
};

export type InvitationFieldsFragment = {
  __typename?: 'Invitation';
  id: string;
  email: string;
  entitlement: Entitlement;
  status: InvitationStatus;
  created: any;
  validUntil: any;
  accepted?: any | null;
  register: {
    __typename?: 'LegalEntity';
    id: string;
    name: string;
    tradeRegisterNumber?: string | null;
  };
  invitedByGroup?: { __typename?: 'Group'; id: string; name: string } | null;
  invitedByUser?: {
    __typename?: 'User';
    id: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  } | null;
};

export type DeedNotaryFieldsFragment = {
  __typename?: 'DeedNotary';
  location: string;
  name: {
    __typename?: 'Name';
    preposition?: string | null;
    initials?: string | null;
    firstName?: string | null;
    nickname?: string | null;
    lastName: string;
  };
};

export type DocumentFieldsFragment = {
  __typename?: 'Document';
  id: string;
  type: DocumentType;
  labels: Array<DocumentLabel>;
  date: any;
  commentary?: string | null;
  canBeRemoved?: boolean | null;
  deedPassed?: {
    __typename?: 'DeedPassed';
    notaryRole: NotaryRole;
    notary?: {
      __typename?: 'DeedNotary';
      location: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
    assignedNotary?: {
      __typename?: 'DeedNotary';
      location: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  } | null;
  mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
  file?: { __typename?: 'File'; name: string; mimeType: string } | null;
};

export type IdentityDocumentFieldsFragment = {
  __typename?: 'IdentityDocument';
  id: string;
  type: IdentityDocumentType;
  expiryDate: any;
  uploadedOn: any;
  uploadedBy: {
    __typename?: 'User';
    id: string;
    email: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  };
  file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
  downloadHistory: Array<{
    __typename?: 'IdentityDocumentDownload';
    id: string;
    reason: string;
    downloadedOn: any;
    downloadedBy: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
  }>;
};

export type ShareTypeVersionFieldsFragment = {
  __typename?: 'ShareTypeVersion';
  id: string;
  name: string;
  voting: boolean;
  dividend: boolean;
  meeting: boolean;
  certificatesPerShare?: number | null;
  classifier?: string | null;
  authorizedCapitalAmount: any;
  nominalValue: {
    __typename?: 'Money';
    currencyCode: string;
    units: any;
    cents: any;
    precision: number;
  };
  underlyingShareType?: {
    __typename?: 'ShareType';
    id: string;
    classifier?: string | null;
    name: string;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    register: {
      __typename?: 'Register';
      id: string;
      legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
    };
  } | null;
  createdInMutation?: {
    __typename?: 'RegisterMutation';
    id: string;
    effectiveDate?: any | null;
  } | null;
};

export type ShareTypeFieldsFragment = {
  __typename?: 'ShareType';
  id: string;
  versionId: string;
  name: string;
  voting: boolean;
  dividend: boolean;
  meeting: boolean;
  classifier?: string | null;
  authorizedCapitalAmount: any;
  certificatesPerShare?: number | null;
  endedOn?: any | null;
  nominalValue: {
    __typename?: 'Money';
    currencyCode: string;
    units: any;
    cents: any;
    precision: number;
  };
  createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
  register: { __typename?: 'Register'; id: string };
  underlyingShareType?: {
    __typename?: 'ShareType';
    id: string;
    classifier?: string | null;
    name: string;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    register: {
      __typename?: 'Register';
      id: string;
      legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
    };
  } | null;
  versions: Array<{
    __typename?: 'ShareTypeVersion';
    id: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    certificatesPerShare?: number | null;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    createdInMutation?: {
      __typename?: 'RegisterMutation';
      id: string;
      effectiveDate?: any | null;
    } | null;
  }>;
};

export type ShareSeriesFieldsFragment = {
  __typename?: 'ShareSeries';
  from: any;
  to: any;
  shareType: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export type NaturalPersonFieldsFragment = {
  __typename?: 'NaturalPerson';
  id: string;
  tag?: string | null;
  dateOfBirth?: any | null;
  dateOfDecease?: any | null;
  placeOfBirth?: string | null;
  phoneNumber?: string | null;
  emailAddress?: string | null;
  name: {
    __typename?: 'Name';
    preposition?: string | null;
    initials?: string | null;
    firstName?: string | null;
    nickname?: string | null;
    lastName: string;
  };
  postalAddress?: {
    __typename?: 'PostalAddress';
    streetName?: string | null;
    streetNumber?: string | null;
    streetNumberAddition?: string | null;
    postalCode?: string | null;
    postOfficeBoxNumber?: string | null;
    city?: string | null;
    countryCode?: string | null;
    streetHouseNumber?: string | null;
    postalCodeCity?: string | null;
    region?: string | null;
  } | null;
  identityDocument?: {
    __typename?: 'IdentityDocument';
    id: string;
    type: IdentityDocumentType;
    expiryDate: any;
    uploadedOn: any;
    uploadedBy: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
    downloadHistory: Array<{
      __typename?: 'IdentityDocumentDownload';
      id: string;
      reason: string;
      downloadedOn: any;
      downloadedBy: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  } | null;
};

export type ParticipationsFieldsFragment = {
  __typename?: 'Participation';
  comment?: string | null;
  tags: Array<string>;
  participationTypes: Array<ParticipationType>;
  iban?: string | null;
  register: { __typename?: 'Register'; id: string };
  shareBatches: Array<{
    __typename?: 'ShareBatch';
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
      };
    };
  }>;
  meetingRights?: { __typename?: 'MeetingRights'; startDate: any; endDate?: any | null } | null;
};

export type PartyWithParticipationsFieldsFragment = {
  __typename?: 'Party';
  id: string;
  type: PartyType;
  legalEntity?: {
    __typename?: 'LegalEntity';
    name: string;
    tradeRegisterNumber?: string | null;
    isFoundation: boolean;
    participation?: {
      __typename?: 'Participation';
      comment?: string | null;
      tags: Array<string>;
      participationTypes: Array<ParticipationType>;
      iban?: string | null;
      register: { __typename?: 'Register'; id: string };
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
          };
        };
      }>;
      meetingRights?: { __typename?: 'MeetingRights'; startDate: any; endDate?: any | null } | null;
    } | null;
  } | null;
  naturalPerson?: {
    __typename?: 'NaturalPerson';
    tag?: string | null;
    dateOfBirth?: any | null;
    dateOfDecease?: any | null;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
    participation?: {
      __typename?: 'Participation';
      comment?: string | null;
      tags: Array<string>;
      participationTypes: Array<ParticipationType>;
      iban?: string | null;
      register: { __typename?: 'Register'; id: string };
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
          };
        };
      }>;
      meetingRights?: { __typename?: 'MeetingRights'; startDate: any; endDate?: any | null } | null;
    } | null;
  } | null;
};

export type PartyFieldsFragment = {
  __typename?: 'Party';
  id: string;
  type: PartyType;
  legalEntity?: {
    __typename?: 'LegalEntity';
    name: string;
    tradeRegisterNumber?: string | null;
    isFoundation: boolean;
    register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
  } | null;
  naturalPerson?: {
    __typename?: 'NaturalPerson';
    tag?: string | null;
    dateOfBirth?: any | null;
    dateOfDecease?: any | null;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  } | null;
};

export type DelegationDetailsFieldsFragment = {
  __typename?: 'DelegationDetails';
  voting: boolean;
  meeting: boolean;
  dividend: boolean;
  delegatee: {
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
};

export type MutationFieldsFragment = {
  __typename?: 'RegisterMutation';
  id: string;
  type: MutationType;
  title?: string | null;
  commentary?: string | null;
  effectiveDate?: any | null;
  acknowledgedDate?: any | null;
  createdOn: any;
  lastUpdatedOn: any;
  seq?: number | null;
  isDraft: boolean;
  editable: boolean;
  dossierNumber?: string | null;
  lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
  validationErrors: Array<{
    __typename?: 'ValidationError';
    field?: string | null;
    code: string;
    message?: string | null;
    params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
  }>;
  administration?: Array<{
    __typename?: 'Administration';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AdministrationDetails';
      endsAt?: any | null;
      administrator: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  appointDirector?: Array<{
    __typename?: 'Director';
    id: string;
    title?: string | null;
    authority: DirectorAuthority;
    representationAuthority: RepresentationAuthority;
    appointedOn?: any | null;
    endedOn?: any | null;
    status: DirectorStatus;
    director: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  attachment?: Array<{
    __typename?: 'Attachment';
    type: AttachmentType;
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AttachmentDetails';
      attachedAt?: string | null;
      bailiff: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      requiredBy?: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      }> | null;
    } | null;
  }> | null;
  conversion?: Array<{
    __typename?: 'Conversion';
    action: ConversionAction;
    paid?: boolean | null;
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  endAdministration?: Array<{
    __typename?: 'EndAdministration';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  endAttachment?: Array<{
    __typename?: 'EndAttachment';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AttachmentDetails';
      attachedAt?: string | null;
      bailiff: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  endDirectorship?: Array<{
    __typename?: 'EndDirectorship';
    directorshipId: string;
    director: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  endPledge?: Array<{
    __typename?: 'EndPledge';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  }> | null;
  endUbo?: Array<{
    __typename?: 'EndUbo';
    ground: UboGround;
    naturalPerson: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  endUsufruct?: Array<{
    __typename?: 'EndUsufruct';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  }> | null;
  incorporation?: Array<{
    __typename?: 'Incorporation';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  issuance?: Array<{
    __typename?: 'Issuance';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
  onboarding?: Array<{
    __typename?: 'Onboarding';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  payingUp?: Array<{
    __typename?: 'PayingUp';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  pledge?: Array<{
    __typename?: 'Pledge';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  transfer?: Array<{
    __typename?: 'Transfer';
    to?: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    from: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  ubo?: Array<{
    __typename?: 'Ubo';
    ground: UboGround;
    ownershipRange?: UboOwnershipRange | null;
    naturalPerson: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  usufruct?: Array<{
    __typename?: 'Usufruct';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  withdrawal?: Array<{
    __typename?: 'Withdrawal';
    from: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
};

export type ExportMutationFieldsFragment = {
  __typename?: 'RegisterMutation';
  type: MutationType;
  title?: string | null;
  commentary?: string | null;
  effectiveDate?: any | null;
  acknowledgedDate?: any | null;
  document?: {
    __typename?: 'Document';
    date: any;
    commentary?: string | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
  } | null;
  administration?: Array<{
    __typename?: 'Administration';
    owner: { __typename?: 'Party'; id: string; type: PartyType };
    details?: {
      __typename?: 'AdministrationDetails';
      endsAt?: any | null;
      administrator: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  conversion?: Array<{
    __typename?: 'Conversion';
    action: ConversionAction;
    paid?: boolean | null;
    owner: { __typename?: 'Party'; id: string; type: PartyType };
  }> | null;
  endAdministration?: Array<{
    __typename?: 'EndAdministration';
    owner: { __typename?: 'Party'; id: string; type: PartyType };
  }> | null;
  endPledge?: Array<{
    __typename?: 'EndPledge';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: { __typename?: 'ShareType'; id: string; name: string; classifier?: string | null };
    };
  }> | null;
  endUsufruct?: Array<{
    __typename?: 'EndUsufruct';
    owner: { __typename?: 'Party'; id: string; type: PartyType };
    details: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  }> | null;
  liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
  payingUp?: Array<{
    __typename?: 'PayingUp';
    owner: { __typename?: 'Party'; id: string; type: PartyType };
  }> | null;
  pledge?: Array<{
    __typename?: 'Pledge';
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  usufruct?: Array<{
    __typename?: 'Usufruct';
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
};

export type MutationWithDocumentFieldsFragment = {
  __typename?: 'RegisterMutation';
  id: string;
  type: MutationType;
  title?: string | null;
  commentary?: string | null;
  effectiveDate?: any | null;
  acknowledgedDate?: any | null;
  createdOn: any;
  lastUpdatedOn: any;
  seq?: number | null;
  isDraft: boolean;
  editable: boolean;
  dossierNumber?: string | null;
  document?: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  } | null;
  price: { __typename?: 'MutationPrice'; amountEuros: number; exemption?: PriceExemption | null };
  lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
  validationErrors: Array<{
    __typename?: 'ValidationError';
    field?: string | null;
    code: string;
    message?: string | null;
    params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
  }>;
  administration?: Array<{
    __typename?: 'Administration';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AdministrationDetails';
      endsAt?: any | null;
      administrator: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  appointDirector?: Array<{
    __typename?: 'Director';
    id: string;
    title?: string | null;
    authority: DirectorAuthority;
    representationAuthority: RepresentationAuthority;
    appointedOn?: any | null;
    endedOn?: any | null;
    status: DirectorStatus;
    director: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  attachment?: Array<{
    __typename?: 'Attachment';
    type: AttachmentType;
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AttachmentDetails';
      attachedAt?: string | null;
      bailiff: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      requiredBy?: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      }> | null;
    } | null;
  }> | null;
  conversion?: Array<{
    __typename?: 'Conversion';
    action: ConversionAction;
    paid?: boolean | null;
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  endAdministration?: Array<{
    __typename?: 'EndAdministration';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  endAttachment?: Array<{
    __typename?: 'EndAttachment';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'AttachmentDetails';
      attachedAt?: string | null;
      bailiff: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  endDirectorship?: Array<{
    __typename?: 'EndDirectorship';
    directorshipId: string;
    director: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  endPledge?: Array<{
    __typename?: 'EndPledge';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  }> | null;
  endUbo?: Array<{
    __typename?: 'EndUbo';
    ground: UboGround;
    naturalPerson: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  endUsufruct?: Array<{
    __typename?: 'EndUsufruct';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  }> | null;
  incorporation?: Array<{
    __typename?: 'Incorporation';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  issuance?: Array<{
    __typename?: 'Issuance';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
  onboarding?: Array<{
    __typename?: 'Onboarding';
    paid?: boolean | null;
    to: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  payingUp?: Array<{
    __typename?: 'PayingUp';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
  pledge?: Array<{
    __typename?: 'Pledge';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  transfer?: Array<{
    __typename?: 'Transfer';
    to?: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    from: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  ubo?: Array<{
    __typename?: 'Ubo';
    ground: UboGround;
    ownershipRange?: UboOwnershipRange | null;
    naturalPerson: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }> | null;
  usufruct?: Array<{
    __typename?: 'Usufruct';
    owner: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    details?: {
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
  }> | null;
  withdrawal?: Array<{
    __typename?: 'Withdrawal';
    from: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }> | null;
};

export type ShareBatchFieldsFragment = {
  __typename?: 'ShareBatch';
  paid?: boolean | null;
  shareholder: {
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
  modifiedBy: Array<{
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    effectiveDate?: any | null;
  }>;
  acquiredBy: Array<{
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    effectiveDate?: any | null;
  }>;
  pledgeDetails: Array<{
    __typename?: 'DelegationDetails';
    voting: boolean;
    meeting: boolean;
    dividend: boolean;
    createdBy?: {
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    } | null;
    delegatee: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }>;
  usufructDetails: Array<{
    __typename?: 'DelegationDetails';
    voting: boolean;
    meeting: boolean;
    dividend: boolean;
    createdBy?: {
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    } | null;
    delegatee: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }>;
  administrationDetails?: {
    __typename?: 'AdministrationDetails';
    endsAt?: any | null;
    createdBy?: {
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    } | null;
    administrator: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  } | null;
  attachmentDetails?: {
    __typename?: 'AttachmentDetails';
    attachedAt?: string | null;
    createdBy?: {
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    } | null;
    bailiff: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    requiredBy?: Array<{
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    }> | null;
  } | null;
  shareSeries: {
    __typename?: 'ShareSeries';
    from: any;
    to: any;
    shareType: {
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    };
  };
};

export type RegisterSignatureFieldsFragment = {
  __typename?: 'RegisterSignature';
  id: string;
  signedOn: any;
  user: {
    __typename?: 'User';
    id: string;
    email: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  };
};

export type RegisterFieldsFragment = {
  __typename?: 'Register';
  id: string;
  replacement: boolean;
  endedOn?: any | null;
  effectiveDate?: any | null;
  articleOfAssociationUpdatedOn?: any | null;
  trustConditionsUpdatedOn?: any | null;
  entitlement: Entitlement;
  isSigned: boolean;
  lastUpdatedOn: any;
  legalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
  requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
  shareTypes: Array<{
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  }>;
  shareBatches: Array<{
    __typename?: 'ShareBatch';
    paid?: boolean | null;
    shareholder: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    modifiedBy: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    }>;
    acquiredBy: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      effectiveDate?: any | null;
    }>;
    pledgeDetails: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      createdBy?: {
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      } | null;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
    usufructDetails: Array<{
      __typename?: 'DelegationDetails';
      voting: boolean;
      meeting: boolean;
      dividend: boolean;
      createdBy?: {
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      } | null;
      delegatee: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
    administrationDetails?: {
      __typename?: 'AdministrationDetails';
      endsAt?: any | null;
      createdBy?: {
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      } | null;
      administrator: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    } | null;
    attachmentDetails?: {
      __typename?: 'AttachmentDetails';
      attachedAt?: string | null;
      createdBy?: {
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      } | null;
      bailiff: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      requiredBy?: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      }> | null;
    } | null;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
  }>;
  shareholders: Array<{
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      participation?: {
        __typename?: 'Participation';
        comment?: string | null;
        tags: Array<string>;
        participationTypes: Array<ParticipationType>;
        iban?: string | null;
        register: { __typename?: 'Register'; id: string };
        shareBatches: Array<{
          __typename?: 'ShareBatch';
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
            };
          };
        }>;
        meetingRights?: {
          __typename?: 'MeetingRights';
          startDate: any;
          endDate?: any | null;
        } | null;
      } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
      participation?: {
        __typename?: 'Participation';
        comment?: string | null;
        tags: Array<string>;
        participationTypes: Array<ParticipationType>;
        iban?: string | null;
        register: { __typename?: 'Register'; id: string };
        shareBatches: Array<{
          __typename?: 'ShareBatch';
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
            };
          };
        }>;
        meetingRights?: {
          __typename?: 'MeetingRights';
          startDate: any;
          endDate?: any | null;
        } | null;
      } | null;
    } | null;
  }>;
  mutations: Array<{
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    commentary?: string | null;
    effectiveDate?: any | null;
    acknowledgedDate?: any | null;
    createdOn: any;
    lastUpdatedOn: any;
    seq?: number | null;
    isDraft: boolean;
    editable: boolean;
    dossierNumber?: string | null;
    lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
    validationErrors: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }>;
    administration?: Array<{
      __typename?: 'Administration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    appointDirector?: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      appointedOn?: any | null;
      endedOn?: any | null;
      status: DirectorStatus;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    attachment?: Array<{
      __typename?: 'Attachment';
      type: AttachmentType;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
    }> | null;
    conversion?: Array<{
      __typename?: 'Conversion';
      action: ConversionAction;
      paid?: boolean | null;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAdministration?: Array<{
      __typename?: 'EndAdministration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAttachment?: Array<{
      __typename?: 'EndAttachment';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    endDirectorship?: Array<{
      __typename?: 'EndDirectorship';
      directorshipId: string;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endPledge?: Array<{
      __typename?: 'EndPledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    endUbo?: Array<{
      __typename?: 'EndUbo';
      ground: UboGround;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endUsufruct?: Array<{
      __typename?: 'EndUsufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    incorporation?: Array<{
      __typename?: 'Incorporation';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    issuance?: Array<{
      __typename?: 'Issuance';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
    onboarding?: Array<{
      __typename?: 'Onboarding';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    payingUp?: Array<{
      __typename?: 'PayingUp';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    pledge?: Array<{
      __typename?: 'Pledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    transfer?: Array<{
      __typename?: 'Transfer';
      to?: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    ubo?: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    usufruct?: Array<{
      __typename?: 'Usufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    withdrawal?: Array<{
      __typename?: 'Withdrawal';
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
  }>;
  documents: Array<{
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  }>;
  signatures: Array<{
    __typename?: 'RegisterSignature';
    id: string;
    signedOn: any;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
  }>;
};

export type PartyUpdateFieldsFragment = {
  __typename?: 'PartyUpdate';
  id: string;
  field: PartyUpdateField;
  before?: string | null;
  after?: string | null;
  requiresDocument: boolean;
  date?: any | null;
  reason?: string | null;
  party: {
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
  document?: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  } | null;
};

export type AccessRequestsQueryVariables = Exact<{
  registerId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type AccessRequestsQuery = {
  __typename?: 'Query';
  accessRequests?: Array<{
    __typename?: 'AccessRequest';
    id: string;
    requestedAt: any;
    entitlement: Entitlement;
    reason: string;
    register: {
      __typename?: 'Register';
      id: string;
      legalEntity: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
      };
    };
    requestedByGroup: { __typename?: 'Group'; id: string; name: string };
    requestedByUser: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
  }> | null;
};

export type CreateAccessRequestMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  entitlement: Entitlement;
  reason: Scalars['String']['input'];
}>;

export type CreateAccessRequestMutation = {
  __typename?: 'Mutation';
  createAccessRequest: {
    __typename?: 'AccessRequest';
    id: string;
    requestedAt: any;
    entitlement: Entitlement;
    reason: string;
    register: {
      __typename?: 'Register';
      id: string;
      legalEntity: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
      };
    };
    requestedByGroup: { __typename?: 'Group'; id: string; name: string };
    requestedByUser: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
  };
};

export type RemindAccessRequestMutationVariables = Exact<{
  accessRequestId: Scalars['ID']['input'];
  reminder: Scalars['String']['input'];
}>;

export type RemindAccessRequestMutation = {
  __typename?: 'Mutation';
  remindAccessRequest: {
    __typename?: 'AccessRequest';
    id: string;
    requestedAt: any;
    entitlement: Entitlement;
    reason: string;
    register: {
      __typename?: 'Register';
      id: string;
      legalEntity: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
      };
    };
    requestedByGroup: { __typename?: 'Group'; id: string; name: string };
    requestedByUser: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
  };
};

export type DeleteAccessRequestMutationVariables = Exact<{
  accessRequestId: Scalars['ID']['input'];
}>;

export type DeleteAccessRequestMutation = {
  __typename?: 'Mutation';
  deleteAccessRequest: { __typename?: 'AccessRequest'; id: string };
};

export type AccountFieldsFragment = {
  __typename?: 'Account';
  locale: Locale;
  entitlements: Array<AccountEntitlement>;
  notary: boolean;
  hasLicenseAgreement: boolean;
  isAdmin: boolean;
  isUserAdmin: boolean;
  user: {
    __typename?: 'User';
    id: string;
    email: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  };
  group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
};

export type AccountQueryVariables = Exact<{ [key: string]: never }>;

export type AccountQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    locale: Locale;
    entitlements: Array<AccountEntitlement>;
    notary: boolean;
    hasLicenseAgreement: boolean;
    isAdmin: boolean;
    isUserAdmin: boolean;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  } | null;
};

export type UpdateAccountMutationVariables = Exact<{
  account: AccountInput;
}>;

export type UpdateAccountMutation = {
  __typename?: 'Mutation';
  updateAccount: {
    __typename?: 'Account';
    locale: Locale;
    entitlements: Array<AccountEntitlement>;
    notary: boolean;
    hasLicenseAgreement: boolean;
    isAdmin: boolean;
    isUserAdmin: boolean;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  };
};

export type SignupLicenseAgreementMutationVariables = Exact<{
  input: LicenseAgreementInput;
}>;

export type SignupLicenseAgreementMutation = {
  __typename?: 'Mutation';
  signupLicenseAgreement: boolean;
};

export type RegisterAuditTrailQueryVariables = Exact<{
  filter: RegisterAuditTrailFilterInput;
  pagination: PaginationInput;
}>;

export type RegisterAuditTrailQuery = {
  __typename?: 'Query';
  registerAuditTrail?: {
    __typename?: 'RegisterAuditTrailResponse';
    items: Array<{
      __typename?: 'RegisterAuditTrailEvent';
      id: string;
      eventType: AuditTrailEventType;
      timestamp: any;
      details?: string | null;
      params: Array<{
        __typename?: 'AuditTrailParam';
        name: AuditTrailParamName;
        value?: string | null;
      }>;
      register: { __typename?: 'RegisterSummary'; id: string; name: string };
      user?: {
        __typename?: 'ManagementUser';
        user: {
          __typename?: 'User';
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
        group?: { __typename?: 'Group'; name: string } | null;
      } | null;
    }>;
    pagination: { __typename?: 'Pagination'; totalCount: number };
  } | null;
};

export type SearchCompaniesQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;

export type SearchCompaniesQuery = {
  __typename?: 'Query';
  searchCompanies: Array<{
    __typename?: 'CompanySearchResult';
    registryNumber: string;
    companyName: string;
    city: string;
  }>;
};

export type ShareBatchDividendStatementFieldsFragment = {
  __typename?: 'ShareBatch';
  paid?: boolean | null;
  pledgeDetails: Array<{ __typename?: 'DelegationDetails'; dividend: boolean }>;
  usufructDetails: Array<{ __typename?: 'DelegationDetails'; dividend: boolean }>;
  attachmentDetails?: { __typename?: 'AttachmentDetails'; attachedAt?: string | null } | null;
  shareSeries: {
    __typename?: 'ShareSeries';
    from: any;
    to: any;
    shareType: {
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    };
  };
};

export type DividendStatementFieldsFragment = {
  __typename?: 'DividendStatement';
  id: string;
  title: string;
  description: string;
  effectiveDate: any;
  paymentDate: any;
  taxRate: number;
  shouldSync: boolean;
  registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
  shareTypes: Array<{
    __typename?: 'DividendStatementShareType';
    shareType: {
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    };
    amount?: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    } | null;
  }>;
  partyStatements: Array<{
    __typename?: 'DividendStatementParty';
    id: string;
    description?: string | null;
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
    };
    entries: Array<{
      __typename?: 'DividendStatementEntry';
      id: string;
      shareCount: number;
      shareCountFromDelegation: number;
      shareCountDelegated: number;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      shareBatch: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      amountFromDelegation?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      shareBatchFromDelegation: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      amountDelegated?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      shareBatchDelegated: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
    }>;
    totalAmount?: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    } | null;
    taxAmount?: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    } | null;
  }>;
};

export type GetDividendStatementDefaultsQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  effectiveDate: Scalars['Date']['input'];
}>;

export type GetDividendStatementDefaultsQuery = {
  __typename?: 'Query';
  getDividendStatementDefaults: {
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    taxRate: number;
    shouldSync: boolean;
    registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
    shareTypes: Array<{
      __typename?: 'DividendStatementShareType';
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      amount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      id: string;
      description?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      };
      entries: Array<{
        __typename?: 'DividendStatementEntry';
        id: string;
        shareCount: number;
        shareCountFromDelegation: number;
        shareCountDelegated: number;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
        shareBatch: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        totalAmount?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        amountFromDelegation?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchFromDelegation: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        amountDelegated?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchDelegated: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      taxAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  };
};

export type DividendStatementQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DividendStatementQuery = {
  __typename?: 'Query';
  dividendStatement: {
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    taxRate: number;
    shouldSync: boolean;
    registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
    shareTypes: Array<{
      __typename?: 'DividendStatementShareType';
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      amount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      id: string;
      description?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      };
      entries: Array<{
        __typename?: 'DividendStatementEntry';
        id: string;
        shareCount: number;
        shareCountFromDelegation: number;
        shareCountDelegated: number;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
        shareBatch: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        totalAmount?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        amountFromDelegation?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchFromDelegation: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        amountDelegated?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchDelegated: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      taxAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  };
};

export type DividendStatementsQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type DividendStatementsQuery = {
  __typename?: 'Query';
  dividendStatements: Array<{
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    shouldSync: boolean;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  }>;
};

export type ExportDividendStatementPdfQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Locale;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
}>;

export type ExportDividendStatementPdfQuery = {
  __typename?: 'Query';
  exportDividendStatementPdf: boolean;
};

export type ExportDividendStatementPartyPdfQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  partyId: Scalars['ID']['input'];
  locale: Locale;
}>;

export type ExportDividendStatementPartyPdfQuery = {
  __typename?: 'Query';
  exportDividendStatementPartyPdf: any;
};

export type ExportDividendStatementCsvQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Locale;
}>;

export type ExportDividendStatementCsvQuery = {
  __typename?: 'Query';
  exportDividendStatementCsv: any;
};

export type CreateDividendStatementMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  dividendStatement: DividendStatementInput;
}>;

export type CreateDividendStatementMutation = {
  __typename?: 'Mutation';
  createDividendStatement: {
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    taxRate: number;
    shouldSync: boolean;
    registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
    shareTypes: Array<{
      __typename?: 'DividendStatementShareType';
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      amount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      id: string;
      description?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      };
      entries: Array<{
        __typename?: 'DividendStatementEntry';
        id: string;
        shareCount: number;
        shareCountFromDelegation: number;
        shareCountDelegated: number;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
        shareBatch: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        totalAmount?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        amountFromDelegation?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchFromDelegation: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        amountDelegated?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchDelegated: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      taxAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  };
};

export type UpdateDividendStatementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  dividendStatement: DividendStatementInput;
}>;

export type UpdateDividendStatementMutation = {
  __typename?: 'Mutation';
  updateDividendStatement: {
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    taxRate: number;
    shouldSync: boolean;
    registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
    shareTypes: Array<{
      __typename?: 'DividendStatementShareType';
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      amount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      id: string;
      description?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      };
      entries: Array<{
        __typename?: 'DividendStatementEntry';
        id: string;
        shareCount: number;
        shareCountFromDelegation: number;
        shareCountDelegated: number;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
        shareBatch: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        totalAmount?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        amountFromDelegation?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchFromDelegation: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        amountDelegated?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchDelegated: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      taxAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  };
};

export type DeleteDividendStatementMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteDividendStatementMutation = {
  __typename?: 'Mutation';
  deleteDividendStatement: boolean;
};

export type SyncDividendStatementWithRegisterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  effectiveDate: Scalars['Date']['input'];
  save: Scalars['Boolean']['input'];
}>;

export type SyncDividendStatementWithRegisterMutation = {
  __typename?: 'Mutation';
  syncDividendStatementWithRegister: {
    __typename?: 'DividendStatement';
    id: string;
    title: string;
    description: string;
    effectiveDate: any;
    paymentDate: any;
    taxRate: number;
    shouldSync: boolean;
    registerLegalEntity: { __typename?: 'LegalEntity'; isFoundation: boolean };
    shareTypes: Array<{
      __typename?: 'DividendStatementShareType';
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
      amount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
    partyStatements: Array<{
      __typename?: 'DividendStatementParty';
      id: string;
      description?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      };
      entries: Array<{
        __typename?: 'DividendStatementEntry';
        id: string;
        shareCount: number;
        shareCountFromDelegation: number;
        shareCountDelegated: number;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
        shareBatch: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        totalAmount?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        amountFromDelegation?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchFromDelegation: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        amountDelegated?: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        } | null;
        shareBatchDelegated: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
      totalAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
      taxAmount?: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      } | null;
    }>;
  };
};

export type DownloadFileQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DownloadFileQuery = { __typename?: 'Query'; downloadFile: any };

export type CreateDocumentMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  document: DocumentInput;
}>;

export type CreateDocumentMutation = {
  __typename?: 'Mutation';
  createDocument: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  };
};

export type UpdateDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  document: DocumentInput;
}>;

export type UpdateDocumentMutation = {
  __typename?: 'Mutation';
  updateDocument: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  };
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DeleteDocumentMutation = {
  __typename?: 'Mutation';
  deleteDocument: {
    __typename?: 'Document';
    id: string;
    type: DocumentType;
    labels: Array<DocumentLabel>;
    date: any;
    commentary?: string | null;
    canBeRemoved?: boolean | null;
    deedPassed?: {
      __typename?: 'DeedPassed';
      notaryRole: NotaryRole;
      notary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      assignedNotary?: {
        __typename?: 'DeedNotary';
        location: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    } | null;
    mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
    file?: { __typename?: 'File'; name: string; mimeType: string } | null;
  };
};

export type UploadFileMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;

export type UploadFileMutation = {
  __typename?: 'Mutation';
  uploadFile: {
    __typename?: 'File';
    name: string;
    mimeType: string;
    size: number;
    uploadedAt: any;
  };
};

export type DeleteFileMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;

export type DeleteFileMutation = {
  __typename?: 'Mutation';
  deleteFile: {
    __typename?: 'File';
    name: string;
    mimeType: string;
    size: number;
    uploadedAt: any;
  };
};

export type RenameFileMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type RenameFileMutation = {
  __typename?: 'Mutation';
  renameFile: {
    __typename?: 'File';
    name: string;
    mimeType: string;
    size: number;
    uploadedAt: any;
  };
};

export type RegisterEntitlementsQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type RegisterEntitlementsQuery = {
  __typename?: 'Query';
  registerEntitlements: Array<{
    __typename?: 'EntitledEntity';
    id: string;
    name: string;
    email?: string | null;
    type: EntityType;
    entitlement: Entitlement;
    temporaryAccessExpiration?: any | null;
  }>;
};

export type EntitledEntitiesQueryVariables = Exact<{
  pagination: PaginationInput;
}>;

export type EntitledEntitiesQuery = {
  __typename?: 'Query';
  entitledEntities: {
    __typename?: 'EntitledEntitySummaryResponse';
    items: Array<{
      __typename?: 'EntitledEntitySummary';
      id: string;
      name: string;
      email?: string | null;
      type: EntityType;
      managed: boolean;
      registersCount: number;
    }>;
    pagination: {
      __typename?: 'Pagination';
      totalPages: number;
      totalCount: number;
      page: number;
      count: number;
    };
  };
};

export type EntitledEntityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type EntitledEntityQuery = {
  __typename?: 'Query';
  entitledEntity?: {
    __typename?: 'EntitledEntitySummary';
    id: string;
    name: string;
    email?: string | null;
    type: EntityType;
  } | null;
};

export type UpdateRegisterEntitlementsMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  entitledEntities: Array<EntitledEntityInput> | EntitledEntityInput;
}>;

export type UpdateRegisterEntitlementsMutation = {
  __typename?: 'Mutation';
  updateRegisterEntitlements: {
    __typename?: 'UpdateRegisterEntitlementsResponse';
    validationErrors?: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }> | null;
    entitlements?: Array<{
      __typename?: 'EntitledEntity';
      id: string;
      name: string;
      email?: string | null;
      type: EntityType;
      entitlement: Entitlement;
      temporaryAccessExpiration?: any | null;
    }> | null;
    invitations?: Array<{
      __typename?: 'Invitation';
      id: string;
      email: string;
      entitlement: Entitlement;
      status: InvitationStatus;
      created: any;
      validUntil: any;
      accepted?: any | null;
      register: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
      };
      invitedByGroup?: { __typename?: 'Group'; id: string; name: string } | null;
      invitedByUser?: {
        __typename?: 'User';
        id: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    }> | null;
    accessRequests?: Array<{
      __typename?: 'AccessRequest';
      id: string;
      requestedAt: any;
      entitlement: Entitlement;
      reason: string;
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
        };
      };
      requestedByGroup: { __typename?: 'Group'; id: string; name: string };
      requestedByUser: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }> | null;
  };
};

export type UploadIdentityDocumentMutationVariables = Exact<{
  naturalPersonId: Scalars['ID']['input'];
  type: IdentityDocumentType;
  expiryDate: Scalars['Date']['input'];
  file: Scalars['Upload']['input'];
}>;

export type UploadIdentityDocumentMutation = {
  __typename?: 'Mutation';
  uploadIdentityDocument: {
    __typename?: 'IdentityDocument';
    id: string;
    type: IdentityDocumentType;
    expiryDate: any;
    uploadedOn: any;
    uploadedBy: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
    downloadHistory: Array<{
      __typename?: 'IdentityDocumentDownload';
      id: string;
      reason: string;
      downloadedOn: any;
      downloadedBy: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  };
};

export type RequestIdentityDocumentDownloadMutationVariables = Exact<{
  naturalPersonId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;

export type RequestIdentityDocumentDownloadMutation = {
  __typename?: 'Mutation';
  requestIdentityDocumentDownload: any;
};

export type InvitationsQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type InvitationsQuery = {
  __typename?: 'Query';
  invitations: Array<{
    __typename?: 'Invitation';
    id: string;
    email: string;
    entitlement: Entitlement;
    status: InvitationStatus;
    created: any;
    validUntil: any;
    accepted?: any | null;
    register: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      tradeRegisterNumber?: string | null;
    };
    invitedByGroup?: { __typename?: 'Group'; id: string; name: string } | null;
    invitedByUser?: {
      __typename?: 'User';
      id: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  }>;
};

export type RevokeInvitationMutationVariables = Exact<{
  invitationId: Scalars['ID']['input'];
}>;

export type RevokeInvitationMutation = {
  __typename?: 'Mutation';
  revokeInvitation: {
    __typename?: 'Invitation';
    id: string;
    email: string;
    entitlement: Entitlement;
    status: InvitationStatus;
    created: any;
    validUntil: any;
    accepted?: any | null;
    register: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      tradeRegisterNumber?: string | null;
    };
    invitedByGroup?: { __typename?: 'Group'; id: string; name: string } | null;
    invitedByUser?: {
      __typename?: 'User';
      id: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
};

export type LegalEntityQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
}>;

export type LegalEntityQuery = {
  __typename?: 'Query';
  legalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    lastFetchedFromKvkOn?: any | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    entitlement: Entitlement;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    register?: {
      __typename?: 'Register';
      id: string;
      replacement: boolean;
      endedOn?: any | null;
      effectiveDate?: any | null;
      articleOfAssociationUpdatedOn?: any | null;
      trustConditionsUpdatedOn?: any | null;
      entitlement: Entitlement;
      isSigned: boolean;
      lastUpdatedOn: any;
      legalEntity: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        incorporatedOn?: any | null;
        legalForm?: string | null;
        isFoundation: boolean;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        rsinNumber?: string | null;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        correspondenceAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
      };
      requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
      shareTypes: Array<{
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      }>;
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      shareholders: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      }>;
      mutations: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        commentary?: string | null;
        effectiveDate?: any | null;
        acknowledgedDate?: any | null;
        createdOn: any;
        lastUpdatedOn: any;
        seq?: number | null;
        isDraft: boolean;
        editable: boolean;
        dossierNumber?: string | null;
        lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
        validationErrors: Array<{
          __typename?: 'ValidationError';
          field?: string | null;
          code: string;
          message?: string | null;
          params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
        }>;
        administration?: Array<{
          __typename?: 'Administration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        appointDirector?: Array<{
          __typename?: 'Director';
          id: string;
          title?: string | null;
          authority: DirectorAuthority;
          representationAuthority: RepresentationAuthority;
          appointedOn?: any | null;
          endedOn?: any | null;
          status: DirectorStatus;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        attachment?: Array<{
          __typename?: 'Attachment';
          type: AttachmentType;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
        }> | null;
        conversion?: Array<{
          __typename?: 'Conversion';
          action: ConversionAction;
          paid?: boolean | null;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAdministration?: Array<{
          __typename?: 'EndAdministration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAttachment?: Array<{
          __typename?: 'EndAttachment';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        endDirectorship?: Array<{
          __typename?: 'EndDirectorship';
          directorshipId: string;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endPledge?: Array<{
          __typename?: 'EndPledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        endUbo?: Array<{
          __typename?: 'EndUbo';
          ground: UboGround;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endUsufruct?: Array<{
          __typename?: 'EndUsufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        incorporation?: Array<{
          __typename?: 'Incorporation';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        issuance?: Array<{
          __typename?: 'Issuance';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
        onboarding?: Array<{
          __typename?: 'Onboarding';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        payingUp?: Array<{
          __typename?: 'PayingUp';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        pledge?: Array<{
          __typename?: 'Pledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        transfer?: Array<{
          __typename?: 'Transfer';
          to?: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        ubo?: Array<{
          __typename?: 'Ubo';
          ground: UboGround;
          ownershipRange?: UboOwnershipRange | null;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        usufruct?: Array<{
          __typename?: 'Usufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        withdrawal?: Array<{
          __typename?: 'Withdrawal';
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      }>;
      signatures: Array<{
        __typename?: 'RegisterSignature';
        id: string;
        signedOn: any;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    } | null;
    partyUpdates: Array<{
      __typename?: 'PartyUpdate';
      id: string;
      field: PartyUpdateField;
      before?: string | null;
      after?: string | null;
      requiresDocument: boolean;
      date?: any | null;
      reason?: string | null;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      document?: {
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      } | null;
    }>;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type LegalEntityDirectorsQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  status?: InputMaybe<DirectorStatusFilter>;
}>;

export type LegalEntityDirectorsQuery = {
  __typename?: 'Query';
  legalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    directors: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      status: DirectorStatus;
      appointedOn?: any | null;
      endedOn?: any | null;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          name: {
            __typename?: 'Name';
            firstName?: string | null;
            initials?: string | null;
            nickname?: string | null;
            preposition?: string | null;
            lastName: string;
          };
        } | null;
        legalEntity?: { __typename?: 'LegalEntity'; name: string } | null;
      };
    }>;
  };
};

export type LegalEntityUbosQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
}>;

export type LegalEntityUbosQuery = {
  __typename?: 'Query';
  legalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    ubos: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          name: {
            __typename?: 'Name';
            firstName?: string | null;
            initials?: string | null;
            nickname?: string | null;
            preposition?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  };
};

export type KvkLookupQueryVariables = Exact<{
  kvkNumber: Scalars['String']['input'];
}>;

export type KvkLookupQuery = {
  __typename?: 'Query';
  kvkLookup: {
    __typename?: 'LegalEntity';
    id: string;
    lastFetchedFromKvkOn?: any | null;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type ShareholderGraphQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  groupBy: ShareholderGraphGroupBy;
  shareholderGraphType?: InputMaybe<ShareholderGraphType>;
}>;

export type ShareholderGraphQuery = {
  __typename?: 'Query';
  shareholderGraph: {
    __typename?: 'ShareholderGraph';
    nodes: Array<{
      __typename?: 'ShareholderGraphNode';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
    edges: Array<{
      __typename?: 'ShareholderGraphEdge';
      quantity: any;
      percentage: number;
      from: { __typename?: 'Party'; id: string; type: PartyType };
      to: { __typename?: 'Party'; id: string; type: PartyType };
      effectiveIn?: { __typename?: 'LegalEntity'; id: string; name: string } | null;
    }>;
  };
};

export type CreateLegalEntityMutationVariables = Exact<{
  registerId?: InputMaybe<Scalars['ID']['input']>;
  legalEntity: LegalEntityInput;
}>;

export type CreateLegalEntityMutation = {
  __typename?: 'Mutation';
  createLegalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type UpdateLegalEntityMutationVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  legalEntity: LegalEntityInput;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateLegalEntityMutation = {
  __typename?: 'Mutation';
  updateLegalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type AddKvkNumberToLegalEntityMutationVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  kvkNumber: Scalars['String']['input'];
}>;

export type AddKvkNumberToLegalEntityMutation = {
  __typename?: 'Mutation';
  addKvkNumberToLegalEntity: {
    __typename?: 'LegalEntity';
    id: string;
    lastFetchedFromKvkOn?: any | null;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type AddLegalEntityToRegisterMutationVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
}>;

export type AddLegalEntityToRegisterMutation = {
  __typename?: 'Mutation';
  addLegalEntityToRegister: {
    __typename?: 'LegalEntity';
    id: string;
    name: string;
    incorporatedOn?: any | null;
    legalForm?: string | null;
    isFoundation: boolean;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    tradeRegisterNumber?: string | null;
    countryOfRegistration: string;
    rsinNumber?: string | null;
    visitorAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    correspondenceAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
  };
};

export type ManagementUserFieldsFragment = {
  __typename?: 'ManagementUser';
  admin?: boolean | null;
  userAdmin?: boolean | null;
  groupAdmin?: boolean | null;
  archived?: boolean | null;
  temporaryAccessExpiration?: any | null;
  user: {
    __typename?: 'User';
    id: string;
    email: string;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
  };
  group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
};

export type ManagementGroupFieldsFragment = {
  __typename?: 'ManagementGroup';
  registersCount: number;
  remarks?: string | null;
  notary: boolean;
  temporaryAccessExpiration?: any | null;
  subscriptionType: SubscriptionType;
  tradeRegisterNumber?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
};

export type UsersQueryVariables = Exact<{ [key: string]: never }>;

export type UsersQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'ManagementUser';
    admin?: boolean | null;
    userAdmin?: boolean | null;
    groupAdmin?: boolean | null;
    archived?: boolean | null;
    temporaryAccessExpiration?: any | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  }>;
};

export type UsersByGroupQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;

export type UsersByGroupQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'ManagementUser';
    admin?: boolean | null;
    userAdmin?: boolean | null;
    groupAdmin?: boolean | null;
    archived?: boolean | null;
    temporaryAccessExpiration?: any | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  }>;
};

export type GroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GroupsQuery = {
  __typename?: 'Query';
  groups: Array<{
    __typename?: 'ManagementGroup';
    registersCount: number;
    remarks?: string | null;
    notary: boolean;
    temporaryAccessExpiration?: any | null;
    subscriptionType: SubscriptionType;
    tradeRegisterNumber?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
  }>;
};

export type GroupQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;

export type GroupQuery = {
  __typename?: 'Query';
  group?: {
    __typename?: 'ManagementGroup';
    registersCount: number;
    remarks?: string | null;
    notary: boolean;
    temporaryAccessExpiration?: any | null;
    subscriptionType: SubscriptionType;
    tradeRegisterNumber?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
  } | null;
};

export type MutationSummaryQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MutationSummaryQuery = {
  __typename?: 'Query';
  mutationSummary: Array<{
    __typename?: 'MutationSummary';
    mutation: {
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      register: {
        __typename?: 'Register';
        legalEntity: { __typename?: 'LegalEntity'; name: string };
      };
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    };
    group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
  }>;
};

export type CreateGroupMutationVariables = Exact<{
  group: GroupInput;
}>;

export type CreateGroupMutation = {
  __typename?: 'Mutation';
  createGroup: {
    __typename?: 'ManagementGroup';
    registersCount: number;
    remarks?: string | null;
    notary: boolean;
    temporaryAccessExpiration?: any | null;
    subscriptionType: SubscriptionType;
    tradeRegisterNumber?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
  };
};

export type UpdateGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  group: GroupInput;
}>;

export type UpdateGroupMutation = {
  __typename?: 'Mutation';
  updateGroup: {
    __typename?: 'ManagementGroup';
    registersCount: number;
    remarks?: string | null;
    notary: boolean;
    temporaryAccessExpiration?: any | null;
    subscriptionType: SubscriptionType;
    tradeRegisterNumber?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
    group: { __typename?: 'Group'; id: string; name: string; logo?: string | null };
  };
};

export type UploadGroupLogoMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  logo: Scalars['String']['input'];
}>;

export type UploadGroupLogoMutation = {
  __typename?: 'Mutation';
  uploadGroupLogo: { __typename?: 'Group'; id: string; logo?: string | null };
};

export type DeleteGroupLogoMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;

export type DeleteGroupLogoMutation = {
  __typename?: 'Mutation';
  deleteGroupLogo: { __typename?: 'Group'; id: string; logo?: string | null };
};

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: {
    __typename?: 'ManagementUser';
    admin?: boolean | null;
    userAdmin?: boolean | null;
    groupAdmin?: boolean | null;
    archived?: boolean | null;
    temporaryAccessExpiration?: any | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  };
};

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  user: UserInput;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'ManagementUser';
    admin?: boolean | null;
    userAdmin?: boolean | null;
    groupAdmin?: boolean | null;
    archived?: boolean | null;
    temporaryAccessExpiration?: any | null;
    user: {
      __typename?: 'User';
      id: string;
      email: string;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    };
    group?: { __typename?: 'Group'; id: string; name: string; logo?: string | null } | null;
  };
};

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: boolean };

export type JsonRegisterQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type JsonRegisterQuery = { __typename?: 'Query'; jsonRegister: string };

export type DeleteRegisterMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type DeleteRegisterMutation = { __typename?: 'Mutation'; deleteRegister: boolean };

export type DeepDeleteRegisterMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type DeepDeleteRegisterMutation = {
  __typename?: 'Mutation';
  deepDeleteRegister: Array<string>;
};

export type SaveJsonRegisterMutationVariables = Exact<{
  registerJson: Scalars['String']['input'];
}>;

export type SaveJsonRegisterMutation = {
  __typename?: 'Mutation';
  saveJsonRegister: {
    __typename?: 'SaveJsonRegisterResult';
    register: { __typename?: 'Register'; id: string };
  };
};

export type MutationQueryVariables = Exact<{
  mutationId: Scalars['ID']['input'];
}>;

export type MutationQuery = {
  __typename?: 'Query';
  mutation: {
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    commentary?: string | null;
    effectiveDate?: any | null;
    acknowledgedDate?: any | null;
    createdOn: any;
    lastUpdatedOn: any;
    seq?: number | null;
    isDraft: boolean;
    editable: boolean;
    dossierNumber?: string | null;
    register: {
      __typename?: 'Register';
      id: string;
      replacement: boolean;
      endedOn?: any | null;
      effectiveDate?: any | null;
      articleOfAssociationUpdatedOn?: any | null;
      trustConditionsUpdatedOn?: any | null;
      entitlement: Entitlement;
      isSigned: boolean;
      lastUpdatedOn: any;
      legalEntity: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        incorporatedOn?: any | null;
        legalForm?: string | null;
        isFoundation: boolean;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        rsinNumber?: string | null;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        correspondenceAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
      };
      requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
      shareTypes: Array<{
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      }>;
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      shareholders: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      }>;
      mutations: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        commentary?: string | null;
        effectiveDate?: any | null;
        acknowledgedDate?: any | null;
        createdOn: any;
        lastUpdatedOn: any;
        seq?: number | null;
        isDraft: boolean;
        editable: boolean;
        dossierNumber?: string | null;
        lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
        validationErrors: Array<{
          __typename?: 'ValidationError';
          field?: string | null;
          code: string;
          message?: string | null;
          params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
        }>;
        administration?: Array<{
          __typename?: 'Administration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        appointDirector?: Array<{
          __typename?: 'Director';
          id: string;
          title?: string | null;
          authority: DirectorAuthority;
          representationAuthority: RepresentationAuthority;
          appointedOn?: any | null;
          endedOn?: any | null;
          status: DirectorStatus;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        attachment?: Array<{
          __typename?: 'Attachment';
          type: AttachmentType;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
        }> | null;
        conversion?: Array<{
          __typename?: 'Conversion';
          action: ConversionAction;
          paid?: boolean | null;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAdministration?: Array<{
          __typename?: 'EndAdministration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAttachment?: Array<{
          __typename?: 'EndAttachment';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        endDirectorship?: Array<{
          __typename?: 'EndDirectorship';
          directorshipId: string;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endPledge?: Array<{
          __typename?: 'EndPledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        endUbo?: Array<{
          __typename?: 'EndUbo';
          ground: UboGround;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endUsufruct?: Array<{
          __typename?: 'EndUsufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        incorporation?: Array<{
          __typename?: 'Incorporation';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        issuance?: Array<{
          __typename?: 'Issuance';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
        onboarding?: Array<{
          __typename?: 'Onboarding';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        payingUp?: Array<{
          __typename?: 'PayingUp';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        pledge?: Array<{
          __typename?: 'Pledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        transfer?: Array<{
          __typename?: 'Transfer';
          to?: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        ubo?: Array<{
          __typename?: 'Ubo';
          ground: UboGround;
          ownershipRange?: UboOwnershipRange | null;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        usufruct?: Array<{
          __typename?: 'Usufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        withdrawal?: Array<{
          __typename?: 'Withdrawal';
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      }>;
      signatures: Array<{
        __typename?: 'RegisterSignature';
        id: string;
        signedOn: any;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    };
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
    price: { __typename?: 'MutationPrice'; amountEuros: number; exemption?: PriceExemption | null };
    lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
    validationErrors: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }>;
    administration?: Array<{
      __typename?: 'Administration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    appointDirector?: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      appointedOn?: any | null;
      endedOn?: any | null;
      status: DirectorStatus;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    attachment?: Array<{
      __typename?: 'Attachment';
      type: AttachmentType;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
    }> | null;
    conversion?: Array<{
      __typename?: 'Conversion';
      action: ConversionAction;
      paid?: boolean | null;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAdministration?: Array<{
      __typename?: 'EndAdministration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAttachment?: Array<{
      __typename?: 'EndAttachment';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    endDirectorship?: Array<{
      __typename?: 'EndDirectorship';
      directorshipId: string;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endPledge?: Array<{
      __typename?: 'EndPledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    endUbo?: Array<{
      __typename?: 'EndUbo';
      ground: UboGround;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endUsufruct?: Array<{
      __typename?: 'EndUsufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    incorporation?: Array<{
      __typename?: 'Incorporation';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    issuance?: Array<{
      __typename?: 'Issuance';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
    onboarding?: Array<{
      __typename?: 'Onboarding';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    payingUp?: Array<{
      __typename?: 'PayingUp';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    pledge?: Array<{
      __typename?: 'Pledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    transfer?: Array<{
      __typename?: 'Transfer';
      to?: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    ubo?: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    usufruct?: Array<{
      __typename?: 'Usufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    withdrawal?: Array<{
      __typename?: 'Withdrawal';
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
  };
};

export type MutationsQueryVariables = Exact<{
  filter?: InputMaybe<MutationFilterInput>;
  pagination: PaginationInput;
}>;

export type MutationsQuery = {
  __typename?: 'Query';
  mutations: {
    __typename?: 'MutationsResponse';
    items: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      register: {
        __typename?: 'Register';
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    }>;
    pagination: { __typename?: 'Pagination'; totalCount: number };
  };
};

export type CreateMutationVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  mutationType: MutationType;
  mutation?: InputMaybe<RegisterMutationInput>;
}>;

export type CreateMutation = {
  __typename?: 'Mutation';
  createMutation: {
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    commentary?: string | null;
    effectiveDate?: any | null;
    acknowledgedDate?: any | null;
    createdOn: any;
    lastUpdatedOn: any;
    seq?: number | null;
    isDraft: boolean;
    editable: boolean;
    dossierNumber?: string | null;
    register: {
      __typename?: 'Register';
      id: string;
      replacement: boolean;
      endedOn?: any | null;
      effectiveDate?: any | null;
      articleOfAssociationUpdatedOn?: any | null;
      trustConditionsUpdatedOn?: any | null;
      entitlement: Entitlement;
      isSigned: boolean;
      lastUpdatedOn: any;
      legalEntity: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        incorporatedOn?: any | null;
        legalForm?: string | null;
        isFoundation: boolean;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        rsinNumber?: string | null;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        correspondenceAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
      };
      requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
      shareTypes: Array<{
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      }>;
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      shareholders: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      }>;
      mutations: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        commentary?: string | null;
        effectiveDate?: any | null;
        acknowledgedDate?: any | null;
        createdOn: any;
        lastUpdatedOn: any;
        seq?: number | null;
        isDraft: boolean;
        editable: boolean;
        dossierNumber?: string | null;
        lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
        validationErrors: Array<{
          __typename?: 'ValidationError';
          field?: string | null;
          code: string;
          message?: string | null;
          params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
        }>;
        administration?: Array<{
          __typename?: 'Administration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        appointDirector?: Array<{
          __typename?: 'Director';
          id: string;
          title?: string | null;
          authority: DirectorAuthority;
          representationAuthority: RepresentationAuthority;
          appointedOn?: any | null;
          endedOn?: any | null;
          status: DirectorStatus;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        attachment?: Array<{
          __typename?: 'Attachment';
          type: AttachmentType;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
        }> | null;
        conversion?: Array<{
          __typename?: 'Conversion';
          action: ConversionAction;
          paid?: boolean | null;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAdministration?: Array<{
          __typename?: 'EndAdministration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAttachment?: Array<{
          __typename?: 'EndAttachment';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        endDirectorship?: Array<{
          __typename?: 'EndDirectorship';
          directorshipId: string;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endPledge?: Array<{
          __typename?: 'EndPledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        endUbo?: Array<{
          __typename?: 'EndUbo';
          ground: UboGround;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endUsufruct?: Array<{
          __typename?: 'EndUsufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        incorporation?: Array<{
          __typename?: 'Incorporation';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        issuance?: Array<{
          __typename?: 'Issuance';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
        onboarding?: Array<{
          __typename?: 'Onboarding';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        payingUp?: Array<{
          __typename?: 'PayingUp';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        pledge?: Array<{
          __typename?: 'Pledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        transfer?: Array<{
          __typename?: 'Transfer';
          to?: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        ubo?: Array<{
          __typename?: 'Ubo';
          ground: UboGround;
          ownershipRange?: UboOwnershipRange | null;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        usufruct?: Array<{
          __typename?: 'Usufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        withdrawal?: Array<{
          __typename?: 'Withdrawal';
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      }>;
      signatures: Array<{
        __typename?: 'RegisterSignature';
        id: string;
        signedOn: any;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    };
    validationErrors: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }>;
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
    price: { __typename?: 'MutationPrice'; amountEuros: number; exemption?: PriceExemption | null };
    lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
    administration?: Array<{
      __typename?: 'Administration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    appointDirector?: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      appointedOn?: any | null;
      endedOn?: any | null;
      status: DirectorStatus;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    attachment?: Array<{
      __typename?: 'Attachment';
      type: AttachmentType;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
    }> | null;
    conversion?: Array<{
      __typename?: 'Conversion';
      action: ConversionAction;
      paid?: boolean | null;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAdministration?: Array<{
      __typename?: 'EndAdministration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAttachment?: Array<{
      __typename?: 'EndAttachment';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    endDirectorship?: Array<{
      __typename?: 'EndDirectorship';
      directorshipId: string;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endPledge?: Array<{
      __typename?: 'EndPledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    endUbo?: Array<{
      __typename?: 'EndUbo';
      ground: UboGround;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endUsufruct?: Array<{
      __typename?: 'EndUsufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    incorporation?: Array<{
      __typename?: 'Incorporation';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    issuance?: Array<{
      __typename?: 'Issuance';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
    onboarding?: Array<{
      __typename?: 'Onboarding';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    payingUp?: Array<{
      __typename?: 'PayingUp';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    pledge?: Array<{
      __typename?: 'Pledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    transfer?: Array<{
      __typename?: 'Transfer';
      to?: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    ubo?: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    usufruct?: Array<{
      __typename?: 'Usufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    withdrawal?: Array<{
      __typename?: 'Withdrawal';
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
  };
};

export type UpdateMutationVariables = Exact<{
  mutationId: Scalars['ID']['input'];
  mutation: RegisterMutationInput;
}>;

export type UpdateMutation = {
  __typename?: 'Mutation';
  updateMutation: {
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    commentary?: string | null;
    effectiveDate?: any | null;
    acknowledgedDate?: any | null;
    createdOn: any;
    lastUpdatedOn: any;
    seq?: number | null;
    isDraft: boolean;
    editable: boolean;
    dossierNumber?: string | null;
    register: {
      __typename?: 'Register';
      id: string;
      replacement: boolean;
      endedOn?: any | null;
      effectiveDate?: any | null;
      articleOfAssociationUpdatedOn?: any | null;
      trustConditionsUpdatedOn?: any | null;
      entitlement: Entitlement;
      isSigned: boolean;
      lastUpdatedOn: any;
      legalEntity: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        incorporatedOn?: any | null;
        legalForm?: string | null;
        isFoundation: boolean;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        rsinNumber?: string | null;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        correspondenceAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
      };
      requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
      shareTypes: Array<{
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      }>;
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      shareholders: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      }>;
      mutations: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        commentary?: string | null;
        effectiveDate?: any | null;
        acknowledgedDate?: any | null;
        createdOn: any;
        lastUpdatedOn: any;
        seq?: number | null;
        isDraft: boolean;
        editable: boolean;
        dossierNumber?: string | null;
        lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
        validationErrors: Array<{
          __typename?: 'ValidationError';
          field?: string | null;
          code: string;
          message?: string | null;
          params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
        }>;
        administration?: Array<{
          __typename?: 'Administration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        appointDirector?: Array<{
          __typename?: 'Director';
          id: string;
          title?: string | null;
          authority: DirectorAuthority;
          representationAuthority: RepresentationAuthority;
          appointedOn?: any | null;
          endedOn?: any | null;
          status: DirectorStatus;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        attachment?: Array<{
          __typename?: 'Attachment';
          type: AttachmentType;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
        }> | null;
        conversion?: Array<{
          __typename?: 'Conversion';
          action: ConversionAction;
          paid?: boolean | null;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAdministration?: Array<{
          __typename?: 'EndAdministration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAttachment?: Array<{
          __typename?: 'EndAttachment';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        endDirectorship?: Array<{
          __typename?: 'EndDirectorship';
          directorshipId: string;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endPledge?: Array<{
          __typename?: 'EndPledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        endUbo?: Array<{
          __typename?: 'EndUbo';
          ground: UboGround;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endUsufruct?: Array<{
          __typename?: 'EndUsufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        incorporation?: Array<{
          __typename?: 'Incorporation';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        issuance?: Array<{
          __typename?: 'Issuance';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
        onboarding?: Array<{
          __typename?: 'Onboarding';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        payingUp?: Array<{
          __typename?: 'PayingUp';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        pledge?: Array<{
          __typename?: 'Pledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        transfer?: Array<{
          __typename?: 'Transfer';
          to?: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        ubo?: Array<{
          __typename?: 'Ubo';
          ground: UboGround;
          ownershipRange?: UboOwnershipRange | null;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        usufruct?: Array<{
          __typename?: 'Usufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        withdrawal?: Array<{
          __typename?: 'Withdrawal';
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      }>;
      signatures: Array<{
        __typename?: 'RegisterSignature';
        id: string;
        signedOn: any;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    };
    validationErrors: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }>;
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
    price: { __typename?: 'MutationPrice'; amountEuros: number; exemption?: PriceExemption | null };
    lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
    administration?: Array<{
      __typename?: 'Administration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    appointDirector?: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      appointedOn?: any | null;
      endedOn?: any | null;
      status: DirectorStatus;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    attachment?: Array<{
      __typename?: 'Attachment';
      type: AttachmentType;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
    }> | null;
    conversion?: Array<{
      __typename?: 'Conversion';
      action: ConversionAction;
      paid?: boolean | null;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAdministration?: Array<{
      __typename?: 'EndAdministration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAttachment?: Array<{
      __typename?: 'EndAttachment';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    endDirectorship?: Array<{
      __typename?: 'EndDirectorship';
      directorshipId: string;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endPledge?: Array<{
      __typename?: 'EndPledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    endUbo?: Array<{
      __typename?: 'EndUbo';
      ground: UboGround;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endUsufruct?: Array<{
      __typename?: 'EndUsufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    incorporation?: Array<{
      __typename?: 'Incorporation';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    issuance?: Array<{
      __typename?: 'Issuance';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
    onboarding?: Array<{
      __typename?: 'Onboarding';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    payingUp?: Array<{
      __typename?: 'PayingUp';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    pledge?: Array<{
      __typename?: 'Pledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    transfer?: Array<{
      __typename?: 'Transfer';
      to?: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    ubo?: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    usufruct?: Array<{
      __typename?: 'Usufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    withdrawal?: Array<{
      __typename?: 'Withdrawal';
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
  };
};

export type DeleteMutationVariables = Exact<{
  mutationId: Scalars['ID']['input'];
}>;

export type DeleteMutation = {
  __typename?: 'Mutation';
  deleteMutation?: {
    __typename?: 'RegisterMutation';
    id: string;
    type: MutationType;
    title?: string | null;
    commentary?: string | null;
    effectiveDate?: any | null;
    acknowledgedDate?: any | null;
    createdOn: any;
    lastUpdatedOn: any;
    seq?: number | null;
    isDraft: boolean;
    editable: boolean;
    dossierNumber?: string | null;
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
    price: { __typename?: 'MutationPrice'; amountEuros: number; exemption?: PriceExemption | null };
    lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
    validationErrors: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }>;
    administration?: Array<{
      __typename?: 'Administration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    appointDirector?: Array<{
      __typename?: 'Director';
      id: string;
      title?: string | null;
      authority: DirectorAuthority;
      representationAuthority: RepresentationAuthority;
      appointedOn?: any | null;
      endedOn?: any | null;
      status: DirectorStatus;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    attachment?: Array<{
      __typename?: 'Attachment';
      type: AttachmentType;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
    }> | null;
    conversion?: Array<{
      __typename?: 'Conversion';
      action: ConversionAction;
      paid?: boolean | null;
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAdministration?: Array<{
      __typename?: 'EndAdministration';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    endAttachment?: Array<{
      __typename?: 'EndAttachment';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    endDirectorship?: Array<{
      __typename?: 'EndDirectorship';
      directorshipId: string;
      director: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endPledge?: Array<{
      __typename?: 'EndPledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    endUbo?: Array<{
      __typename?: 'EndUbo';
      ground: UboGround;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    endUsufruct?: Array<{
      __typename?: 'EndUsufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
    }> | null;
    incorporation?: Array<{
      __typename?: 'Incorporation';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    issuance?: Array<{
      __typename?: 'Issuance';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
    onboarding?: Array<{
      __typename?: 'Onboarding';
      paid?: boolean | null;
      to: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    payingUp?: Array<{
      __typename?: 'PayingUp';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
    pledge?: Array<{
      __typename?: 'Pledge';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    transfer?: Array<{
      __typename?: 'Transfer';
      to?: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    ubo?: Array<{
      __typename?: 'Ubo';
      ground: UboGround;
      ownershipRange?: UboOwnershipRange | null;
      naturalPerson: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }> | null;
    usufruct?: Array<{
      __typename?: 'Usufruct';
      owner: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      details?: {
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
    }> | null;
    withdrawal?: Array<{
      __typename?: 'Withdrawal';
      from: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }> | null;
  } | null;
};

export type MutationPriceQueryVariables = Exact<{
  legalEntityId: Scalars['ID']['input'];
  mutationType: MutationType;
  effectiveDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type MutationPriceQuery = {
  __typename?: 'Query';
  mutationPrice: {
    __typename?: 'MutationPrice';
    amountEuros: number;
    exemption?: PriceExemption | null;
  };
};

export type NaturalPersonQueryVariables = Exact<{
  naturalPersonId: Scalars['ID']['input'];
}>;

export type NaturalPersonQuery = {
  __typename?: 'Query';
  naturalPerson: {
    __typename?: 'NaturalPerson';
    entitlement: Entitlement;
    id: string;
    tag?: string | null;
    dateOfBirth?: any | null;
    dateOfDecease?: any | null;
    placeOfBirth?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    participation?: {
      __typename?: 'Participation';
      comment?: string | null;
      tags: Array<string>;
      participationTypes: Array<ParticipationType>;
      iban?: string | null;
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
          };
        };
      }>;
      meetingRights?: { __typename?: 'MeetingRights'; startDate: any; endDate?: any | null } | null;
    } | null;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
    postalAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    identityDocument?: {
      __typename?: 'IdentityDocument';
      id: string;
      type: IdentityDocumentType;
      expiryDate: any;
      uploadedOn: any;
      uploadedBy: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
      file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
      downloadHistory: Array<{
        __typename?: 'IdentityDocumentDownload';
        id: string;
        reason: string;
        downloadedOn: any;
        downloadedBy: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    } | null;
  };
};

export type CreateNaturalPersonMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  naturalPerson: NaturalPersonInput;
}>;

export type CreateNaturalPersonMutation = {
  __typename?: 'Mutation';
  createNaturalPerson: {
    __typename?: 'NaturalPerson';
    id: string;
    tag?: string | null;
    dateOfBirth?: any | null;
    dateOfDecease?: any | null;
    placeOfBirth?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
    postalAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    identityDocument?: {
      __typename?: 'IdentityDocument';
      id: string;
      type: IdentityDocumentType;
      expiryDate: any;
      uploadedOn: any;
      uploadedBy: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
      file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
      downloadHistory: Array<{
        __typename?: 'IdentityDocumentDownload';
        id: string;
        reason: string;
        downloadedOn: any;
        downloadedBy: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    } | null;
  };
};

export type UpdateNaturalPersonMutationVariables = Exact<{
  naturalPersonId: Scalars['ID']['input'];
  naturalPerson: NaturalPersonInput;
}>;

export type UpdateNaturalPersonMutation = {
  __typename?: 'Mutation';
  updateNaturalPerson: {
    __typename?: 'NaturalPerson';
    id: string;
    tag?: string | null;
    dateOfBirth?: any | null;
    dateOfDecease?: any | null;
    placeOfBirth?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
    name: {
      __typename?: 'Name';
      preposition?: string | null;
      initials?: string | null;
      firstName?: string | null;
      nickname?: string | null;
      lastName: string;
    };
    postalAddress?: {
      __typename?: 'PostalAddress';
      streetName?: string | null;
      streetNumber?: string | null;
      streetNumberAddition?: string | null;
      postalCode?: string | null;
      postOfficeBoxNumber?: string | null;
      city?: string | null;
      countryCode?: string | null;
      streetHouseNumber?: string | null;
      postalCodeCity?: string | null;
      region?: string | null;
    } | null;
    identityDocument?: {
      __typename?: 'IdentityDocument';
      id: string;
      type: IdentityDocumentType;
      expiryDate: any;
      uploadedOn: any;
      uploadedBy: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
      file: { __typename?: 'File'; name: string; mimeType: string; size: number; uploadedAt: any };
      downloadHistory: Array<{
        __typename?: 'IdentityDocumentDownload';
        id: string;
        reason: string;
        downloadedOn: any;
        downloadedBy: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    } | null;
  };
};

export type NotaryFieldsFragment = {
  __typename?: 'Notary';
  id: string;
  type: NotaryType;
  initials: string;
  prefix?: string | null;
  firstName?: string | null;
  lastName: string;
  location: string;
  email?: string | null;
  active: boolean;
  group?: { __typename?: 'Group'; id: string; name: string } | null;
};

export type NotariesQueryVariables = Exact<{ [key: string]: never }>;

export type NotariesQuery = {
  __typename?: 'Query';
  notaries: Array<{
    __typename?: 'Notary';
    id: string;
    type: NotaryType;
    initials: string;
    prefix?: string | null;
    firstName?: string | null;
    lastName: string;
    location: string;
    email?: string | null;
    active: boolean;
    group?: { __typename?: 'Group'; id: string; name: string } | null;
  }>;
};

export type CreateNotaryMutationVariables = Exact<{
  input: CreateNotaryInput;
}>;

export type CreateNotaryMutation = {
  __typename?: 'Mutation';
  createNotary: {
    __typename?: 'Notary';
    id: string;
    type: NotaryType;
    initials: string;
    prefix?: string | null;
    firstName?: string | null;
    lastName: string;
    location: string;
    email?: string | null;
    active: boolean;
    group?: { __typename?: 'Group'; id: string; name: string } | null;
  };
};

export type UpdateNotaryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateNotaryInput;
}>;

export type UpdateNotaryMutation = {
  __typename?: 'Mutation';
  updateNotary: {
    __typename?: 'Notary';
    id: string;
    type: NotaryType;
    initials: string;
    prefix?: string | null;
    firstName?: string | null;
    lastName: string;
    location: string;
    email?: string | null;
    active: boolean;
    group?: { __typename?: 'Group'; id: string; name: string } | null;
  };
};

export type DeleteNotaryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteNotaryMutation = { __typename?: 'Mutation'; deleteNotary: boolean };

export type SetNotaryActiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;

export type SetNotaryActiveMutation = {
  __typename?: 'Mutation';
  setNotaryActive: {
    __typename?: 'Notary';
    id: string;
    type: NotaryType;
    initials: string;
    prefix?: string | null;
    firstName?: string | null;
    lastName: string;
    location: string;
    email?: string | null;
    active: boolean;
    group?: { __typename?: 'Group'; id: string; name: string } | null;
  };
};

export type UpdateParticipationMutationVariables = Exact<{
  partyId: Scalars['ID']['input'];
  participationInput: ParticipationInput;
}>;

export type UpdateParticipationMutation = {
  __typename?: 'Mutation';
  updateParticipation: {
    __typename?: 'ParticipationResponse';
    validationErrors?: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }> | null;
    party?: { __typename?: 'Party'; id: string } | null;
  };
};

export type DeleteParticipationMutationVariables = Exact<{
  partyId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
}>;

export type DeleteParticipationMutation = {
  __typename?: 'Mutation';
  deleteParticipation: {
    __typename?: 'ParticipationResponse';
    validationErrors?: Array<{
      __typename?: 'ValidationError';
      field?: string | null;
      code: string;
      message?: string | null;
      params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
    }> | null;
    party?: { __typename?: 'Party'; id: string } | null;
  };
};

export type PartyDashboardQueryVariables = Exact<{
  filter?: InputMaybe<PartySearchFilterInput>;
  pagination: PaginationInput;
}>;

export type PartyDashboardQuery = {
  __typename?: 'Query';
  partySearch: {
    __typename?: 'PartySearchResponse';
    items: Array<{
      __typename?: 'Party';
      legalEntity?: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        incorporatedOn?: any | null;
        entitlement: Entitlement;
        otherEntitledCount?: number | null;
        register?: {
          __typename?: 'Register';
          id: string;
          isSigned: boolean;
          replacement: boolean;
          endedOn?: any | null;
          signatures: Array<{ __typename?: 'RegisterSignature'; id: string }>;
        } | null;
      } | null;
    }>;
    pagination: {
      __typename?: 'Pagination';
      totalPages: number;
      totalCount: number;
      page: number;
      count: number;
    };
  };
};

export type PartySearchQueryVariables = Exact<{
  filter?: InputMaybe<PartySearchFilterInput>;
  pagination: PaginationInput;
}>;

export type PartySearchQuery = {
  __typename?: 'Query';
  partySearch: {
    __typename?: 'PartySearchResponse';
    items: Array<{
      __typename?: 'Party';
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        id: string;
        dateOfBirth?: any | null;
        placeOfBirth?: string | null;
        tag?: string | null;
        postalAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
      legalEntity?: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        register?: {
          __typename?: 'Register';
          id: string;
          entitlement: Entitlement;
          requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
        } | null;
      } | null;
    }>;
    pagination: {
      __typename?: 'Pagination';
      totalPages: number;
      totalCount: number;
      page: number;
      count: number;
    };
  };
};

export type GroupRegistersQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;

export type GroupRegistersQuery = {
  __typename?: 'Query';
  partySearch: {
    __typename?: 'PartySearchResponse';
    items: Array<{
      __typename?: 'Party';
      legalEntity?: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        register?: {
          __typename?: 'Register';
          id: string;
          isSigned: boolean;
          entitlement: Entitlement;
          signatures: Array<{ __typename?: 'RegisterSignature'; id: string }>;
        } | null;
      } | null;
    }>;
    pagination: {
      __typename?: 'Pagination';
      totalPages: number;
      totalCount: number;
      page: number;
      count: number;
    };
  };
};

export type EntitledEntityRegistersQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;

export type EntitledEntityRegistersQuery = {
  __typename?: 'Query';
  partySearch: {
    __typename?: 'PartySearchResponse';
    items: Array<{
      __typename?: 'Party';
      legalEntity?: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        register?: { __typename?: 'Register'; id: string; isSigned: boolean } | null;
      } | null;
    }>;
    pagination: {
      __typename?: 'Pagination';
      totalPages: number;
      totalCount: number;
      page: number;
      count: number;
    };
  };
};

export type KvkUpdatesQueryVariables = Exact<{
  partyId: Scalars['ID']['input'];
}>;

export type KvkUpdatesQuery = {
  __typename?: 'Query';
  kvkUpdates: Array<{
    __typename?: 'PartyUpdate';
    id: string;
    field: PartyUpdateField;
    before?: string | null;
    after?: string | null;
    requiresDocument: boolean;
    date?: any | null;
    reason?: string | null;
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
  }>;
};

export type SavePartyUpdatesMutationVariables = Exact<{
  partyUpdates: Array<PartyUpdateInput> | PartyUpdateInput;
  document?: InputMaybe<DocumentInput>;
}>;

export type SavePartyUpdatesMutation = {
  __typename?: 'Mutation';
  savePartyUpdates: Array<{
    __typename?: 'PartyUpdate';
    id: string;
    field: PartyUpdateField;
    before?: string | null;
    after?: string | null;
    requiresDocument: boolean;
    date?: any | null;
    reason?: string | null;
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    document?: {
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    } | null;
  }>;
};

export type PostalAddressLookupQueryVariables = Exact<{
  postalCode: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
}>;

export type PostalAddressLookupQuery = {
  __typename?: 'Query';
  postalAddressLookup: {
    __typename?: 'PostalAddress';
    streetName?: string | null;
    streetNumber?: string | null;
    streetNumberAddition?: string | null;
    postalCode?: string | null;
    postOfficeBoxNumber?: string | null;
    city?: string | null;
    countryCode?: string | null;
    streetHouseNumber?: string | null;
    postalCodeCity?: string | null;
    region?: string | null;
  };
};

export type PpuMutationQueryVariables = Exact<{
  filter?: InputMaybe<PpuFilterInput>;
}>;

export type PpuMutationQuery = {
  __typename?: 'Query';
  ppuMutation: {
    __typename?: 'PpuMutationResponse';
    totalCount: number;
    totalSpentEuros: number;
    items: Array<{
      __typename?: 'PpuMutation';
      description?: string | null;
      amountEuros: number;
      created?: any | null;
      legalEntity?: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        tradeRegisterNumber?: string | null;
      } | null;
    }>;
  };
};

export type PpuMutationExcelQueryVariables = Exact<{
  filter?: InputMaybe<PpuFilterInput>;
  pagination: PaginationInput;
}>;

export type PpuMutationExcelQuery = { __typename?: 'Query'; ppuMutationExcel: any };

export type RegisterQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  atDate?: InputMaybe<Scalars['Date']['input']>;
  mutationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisterQuery = {
  __typename?: 'Query';
  register: {
    __typename?: 'Register';
    id: string;
    replacement: boolean;
    endedOn?: any | null;
    effectiveDate?: any | null;
    articleOfAssociationUpdatedOn?: any | null;
    trustConditionsUpdatedOn?: any | null;
    entitlement: Entitlement;
    isSigned: boolean;
    lastUpdatedOn: any;
    legalEntity: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      incorporatedOn?: any | null;
      legalForm?: string | null;
      isFoundation: boolean;
      phoneNumber?: string | null;
      emailAddress?: string | null;
      tradeRegisterNumber?: string | null;
      countryOfRegistration: string;
      rsinNumber?: string | null;
      visitorAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
      correspondenceAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
    };
    requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
    shareTypes: Array<{
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    }>;
    shareBatches: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    shareholders: Array<{
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
    }>;
    mutations: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    }>;
    signatures: Array<{
      __typename?: 'RegisterSignature';
      id: string;
      signedOn: any;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  };
};

export type RegisterDistributionChartQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  groupBy: DistributionChartGroupBy;
  filterBy?: InputMaybe<DistributionChartFilterBy>;
}>;

export type RegisterDistributionChartQuery = {
  __typename?: 'Query';
  registerDistributionChart: {
    __typename?: 'DistributionChart';
    pieces: Array<{
      __typename?: 'DistributionChartPiece';
      quantity: any;
      quantityPercentage: number;
      amountPercentage: number;
      amount: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
  };
};

export type PartyMutationHistoryFieldsFragment = {
  __typename?: 'PartyMutationHistory';
  party: {
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
  partyUpdateHistory: Array<{
    __typename?: 'PartyUpdateHistory';
    date: any;
    updateFields: Array<PartyUpdateField>;
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
  }>;
  mutations: Array<{
    __typename?: 'PartyMutation';
    mutation: {
      __typename?: 'RegisterMutation';
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      document?: {
        __typename?: 'Document';
        date: any;
        commentary?: string | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
      } | null;
      administration?: Array<{
        __typename?: 'Administration';
        owner: { __typename?: 'Party'; id: string; type: PartyType };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: { __typename?: 'Party'; id: string; type: PartyType };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: { __typename?: 'Party'; id: string; type: PartyType };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            name: string;
            classifier?: string | null;
          };
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: { __typename?: 'Party'; id: string; type: PartyType };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: { __typename?: 'Party'; id: string; type: PartyType };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
    };
    delta: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    result: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    shareTypeUpdate: Array<{
      __typename?: 'ShareTypeUpdate';
      before: {
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      };
      after: {
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      };
    }>;
  }>;
};

export type RegisterOfShareholdersQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  locale: Locale;
}>;

export type RegisterOfShareholdersQuery = {
  __typename?: 'Query';
  registerOfShareholders?: {
    __typename?: 'RegisterOfShareholders';
    locale: string;
    register: {
      __typename?: 'Register';
      id: string;
      replacement: boolean;
      endedOn?: any | null;
      effectiveDate?: any | null;
      articleOfAssociationUpdatedOn?: any | null;
      trustConditionsUpdatedOn?: any | null;
      entitlement: Entitlement;
      isSigned: boolean;
      lastUpdatedOn: any;
      legalEntity: {
        __typename?: 'LegalEntity';
        id: string;
        name: string;
        incorporatedOn?: any | null;
        legalForm?: string | null;
        isFoundation: boolean;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        tradeRegisterNumber?: string | null;
        countryOfRegistration: string;
        rsinNumber?: string | null;
        visitorAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
        correspondenceAddress?: {
          __typename?: 'PostalAddress';
          streetName?: string | null;
          streetNumber?: string | null;
          streetNumberAddition?: string | null;
          postalCode?: string | null;
          postOfficeBoxNumber?: string | null;
          city?: string | null;
          countryCode?: string | null;
          streetHouseNumber?: string | null;
          postalCodeCity?: string | null;
          region?: string | null;
        } | null;
      };
      requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
      shareTypes: Array<{
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      }>;
      shareBatches: Array<{
        __typename?: 'ShareBatch';
        paid?: boolean | null;
        shareholder: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        modifiedBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        acquiredBy: Array<{
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        }>;
        pledgeDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        usufructDetails: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
        administrationDetails?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
        attachmentDetails?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          createdBy?: {
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          } | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }>;
      shareholders: Array<{
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
          participation?: {
            __typename?: 'Participation';
            comment?: string | null;
            tags: Array<string>;
            participationTypes: Array<ParticipationType>;
            iban?: string | null;
            register: { __typename?: 'Register'; id: string };
            shareBatches: Array<{
              __typename?: 'ShareBatch';
              shareSeries: {
                __typename?: 'ShareSeries';
                from: any;
                to: any;
                shareType: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                };
              };
            }>;
            meetingRights?: {
              __typename?: 'MeetingRights';
              startDate: any;
              endDate?: any | null;
            } | null;
          } | null;
        } | null;
      }>;
      mutations: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        commentary?: string | null;
        effectiveDate?: any | null;
        acknowledgedDate?: any | null;
        createdOn: any;
        lastUpdatedOn: any;
        seq?: number | null;
        isDraft: boolean;
        editable: boolean;
        dossierNumber?: string | null;
        lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
        validationErrors: Array<{
          __typename?: 'ValidationError';
          field?: string | null;
          code: string;
          message?: string | null;
          params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
        }>;
        administration?: Array<{
          __typename?: 'Administration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        appointDirector?: Array<{
          __typename?: 'Director';
          id: string;
          title?: string | null;
          authority: DirectorAuthority;
          representationAuthority: RepresentationAuthority;
          appointedOn?: any | null;
          endedOn?: any | null;
          status: DirectorStatus;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        attachment?: Array<{
          __typename?: 'Attachment';
          type: AttachmentType;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
        }> | null;
        conversion?: Array<{
          __typename?: 'Conversion';
          action: ConversionAction;
          paid?: boolean | null;
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAdministration?: Array<{
          __typename?: 'EndAdministration';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        endAttachment?: Array<{
          __typename?: 'EndAttachment';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        endDirectorship?: Array<{
          __typename?: 'EndDirectorship';
          directorshipId: string;
          director: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endPledge?: Array<{
          __typename?: 'EndPledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        endUbo?: Array<{
          __typename?: 'EndUbo';
          ground: UboGround;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        endUsufruct?: Array<{
          __typename?: 'EndUsufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
        }> | null;
        incorporation?: Array<{
          __typename?: 'Incorporation';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        issuance?: Array<{
          __typename?: 'Issuance';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
        onboarding?: Array<{
          __typename?: 'Onboarding';
          paid?: boolean | null;
          to: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        payingUp?: Array<{
          __typename?: 'PayingUp';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
        pledge?: Array<{
          __typename?: 'Pledge';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        transfer?: Array<{
          __typename?: 'Transfer';
          to?: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        ubo?: Array<{
          __typename?: 'Ubo';
          ground: UboGround;
          ownershipRange?: UboOwnershipRange | null;
          naturalPerson: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }> | null;
        usufruct?: Array<{
          __typename?: 'Usufruct';
          owner: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
          details?: {
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
        }> | null;
        withdrawal?: Array<{
          __typename?: 'Withdrawal';
          from: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }> | null;
      }>;
      documents: Array<{
        __typename?: 'Document';
        id: string;
        type: DocumentType;
        labels: Array<DocumentLabel>;
        date: any;
        commentary?: string | null;
        canBeRemoved?: boolean | null;
        deedPassed?: {
          __typename?: 'DeedPassed';
          notaryRole: NotaryRole;
          notary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
          assignedNotary?: {
            __typename?: 'DeedNotary';
            location: string;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
        file?: { __typename?: 'File'; name: string; mimeType: string } | null;
      }>;
      signatures: Array<{
        __typename?: 'RegisterSignature';
        id: string;
        signedOn: any;
        user: {
          __typename?: 'User';
          id: string;
          email: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        };
      }>;
    };
    partyUpdateHistory: Array<{
      __typename?: 'PartyUpdateHistory';
      date: any;
      updateFields: Array<PartyUpdateField>;
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
    }>;
    capitalHistory?: {
      __typename?: 'CapitalHistory';
      authorized: Array<{
        __typename?: 'Capital';
        date: any;
        shares: Array<{
          __typename?: 'CapitalShare';
          amount: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        }>;
      }>;
      issued: Array<{
        __typename?: 'Capital';
        date: any;
        shares: Array<{
          __typename?: 'CapitalShare';
          amount: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        }>;
      }>;
      paid: Array<{
        __typename?: 'Capital';
        date: any;
        shares: Array<{
          __typename?: 'CapitalShare';
          amount: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        }>;
      }>;
      unpaid: Array<{
        __typename?: 'Capital';
        date: any;
        shares: Array<{
          __typename?: 'CapitalShare';
          amount: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        }>;
      }>;
    } | null;
    partyMutationHistory: Array<{
      __typename?: 'PartyMutationHistory';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      partyUpdateHistory: Array<{
        __typename?: 'PartyUpdateHistory';
        date: any;
        updateFields: Array<PartyUpdateField>;
        party: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      mutations: Array<{
        __typename?: 'PartyMutation';
        mutation: {
          __typename?: 'RegisterMutation';
          type: MutationType;
          title?: string | null;
          commentary?: string | null;
          effectiveDate?: any | null;
          acknowledgedDate?: any | null;
          document?: {
            __typename?: 'Document';
            date: any;
            commentary?: string | null;
            deedPassed?: {
              __typename?: 'DeedPassed';
              notaryRole: NotaryRole;
              notary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
              assignedNotary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            } | null;
          } | null;
          administration?: Array<{
            __typename?: 'Administration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details?: {
              __typename?: 'AdministrationDetails';
              endsAt?: any | null;
              administrator: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          conversion?: Array<{
            __typename?: 'Conversion';
            action: ConversionAction;
            paid?: boolean | null;
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endAdministration?: Array<{
            __typename?: 'EndAdministration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endPledge?: Array<{
            __typename?: 'EndPledge';
            owner: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                name: string;
                classifier?: string | null;
              };
            };
          }> | null;
          endUsufruct?: Array<{
            __typename?: 'EndUsufruct';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details: Array<{
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            }>;
          }> | null;
          liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
          payingUp?: Array<{
            __typename?: 'PayingUp';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          pledge?: Array<{
            __typename?: 'Pledge';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          usufruct?: Array<{
            __typename?: 'Usufruct';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
        };
        delta: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        result: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        shareTypeUpdate: Array<{
          __typename?: 'ShareTypeUpdate';
          before: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
          after: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
        }>;
      }>;
    }>;
    pledgeeMutationHistory: Array<{
      __typename?: 'PartyMutationHistory';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      partyUpdateHistory: Array<{
        __typename?: 'PartyUpdateHistory';
        date: any;
        updateFields: Array<PartyUpdateField>;
        party: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      mutations: Array<{
        __typename?: 'PartyMutation';
        mutation: {
          __typename?: 'RegisterMutation';
          type: MutationType;
          title?: string | null;
          commentary?: string | null;
          effectiveDate?: any | null;
          acknowledgedDate?: any | null;
          document?: {
            __typename?: 'Document';
            date: any;
            commentary?: string | null;
            deedPassed?: {
              __typename?: 'DeedPassed';
              notaryRole: NotaryRole;
              notary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
              assignedNotary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            } | null;
          } | null;
          administration?: Array<{
            __typename?: 'Administration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details?: {
              __typename?: 'AdministrationDetails';
              endsAt?: any | null;
              administrator: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          conversion?: Array<{
            __typename?: 'Conversion';
            action: ConversionAction;
            paid?: boolean | null;
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endAdministration?: Array<{
            __typename?: 'EndAdministration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endPledge?: Array<{
            __typename?: 'EndPledge';
            owner: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                name: string;
                classifier?: string | null;
              };
            };
          }> | null;
          endUsufruct?: Array<{
            __typename?: 'EndUsufruct';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details: Array<{
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            }>;
          }> | null;
          liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
          payingUp?: Array<{
            __typename?: 'PayingUp';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          pledge?: Array<{
            __typename?: 'Pledge';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          usufruct?: Array<{
            __typename?: 'Usufruct';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
        };
        delta: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        result: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        shareTypeUpdate: Array<{
          __typename?: 'ShareTypeUpdate';
          before: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
          after: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
        }>;
      }>;
    }>;
    usufructuaryMutationHistory: Array<{
      __typename?: 'PartyMutationHistory';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      partyUpdateHistory: Array<{
        __typename?: 'PartyUpdateHistory';
        date: any;
        updateFields: Array<PartyUpdateField>;
        party: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      mutations: Array<{
        __typename?: 'PartyMutation';
        mutation: {
          __typename?: 'RegisterMutation';
          type: MutationType;
          title?: string | null;
          commentary?: string | null;
          effectiveDate?: any | null;
          acknowledgedDate?: any | null;
          document?: {
            __typename?: 'Document';
            date: any;
            commentary?: string | null;
            deedPassed?: {
              __typename?: 'DeedPassed';
              notaryRole: NotaryRole;
              notary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
              assignedNotary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            } | null;
          } | null;
          administration?: Array<{
            __typename?: 'Administration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details?: {
              __typename?: 'AdministrationDetails';
              endsAt?: any | null;
              administrator: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          conversion?: Array<{
            __typename?: 'Conversion';
            action: ConversionAction;
            paid?: boolean | null;
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endAdministration?: Array<{
            __typename?: 'EndAdministration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endPledge?: Array<{
            __typename?: 'EndPledge';
            owner: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                name: string;
                classifier?: string | null;
              };
            };
          }> | null;
          endUsufruct?: Array<{
            __typename?: 'EndUsufruct';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details: Array<{
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            }>;
          }> | null;
          liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
          payingUp?: Array<{
            __typename?: 'PayingUp';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          pledge?: Array<{
            __typename?: 'Pledge';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          usufruct?: Array<{
            __typename?: 'Usufruct';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
        };
        delta: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        result: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        shareTypeUpdate: Array<{
          __typename?: 'ShareTypeUpdate';
          before: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
          after: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
        }>;
      }>;
    }>;
    guardianMutationHistory: Array<{
      __typename?: 'PartyMutationHistory';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      partyUpdateHistory: Array<{
        __typename?: 'PartyUpdateHistory';
        date: any;
        updateFields: Array<PartyUpdateField>;
        party: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      mutations: Array<{
        __typename?: 'PartyMutation';
        mutation: {
          __typename?: 'RegisterMutation';
          type: MutationType;
          title?: string | null;
          commentary?: string | null;
          effectiveDate?: any | null;
          acknowledgedDate?: any | null;
          document?: {
            __typename?: 'Document';
            date: any;
            commentary?: string | null;
            deedPassed?: {
              __typename?: 'DeedPassed';
              notaryRole: NotaryRole;
              notary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
              assignedNotary?: {
                __typename?: 'DeedNotary';
                location: string;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            } | null;
          } | null;
          administration?: Array<{
            __typename?: 'Administration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details?: {
              __typename?: 'AdministrationDetails';
              endsAt?: any | null;
              administrator: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          conversion?: Array<{
            __typename?: 'Conversion';
            action: ConversionAction;
            paid?: boolean | null;
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endAdministration?: Array<{
            __typename?: 'EndAdministration';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          endPledge?: Array<{
            __typename?: 'EndPledge';
            owner: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                name: string;
                classifier?: string | null;
              };
            };
          }> | null;
          endUsufruct?: Array<{
            __typename?: 'EndUsufruct';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
            details: Array<{
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            }>;
          }> | null;
          liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
          payingUp?: Array<{
            __typename?: 'PayingUp';
            owner: { __typename?: 'Party'; id: string; type: PartyType };
          }> | null;
          pledge?: Array<{
            __typename?: 'Pledge';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
          usufruct?: Array<{
            __typename?: 'Usufruct';
            details?: {
              __typename?: 'DelegationDetails';
              voting: boolean;
              meeting: boolean;
              dividend: boolean;
              delegatee: {
                __typename?: 'Party';
                id: string;
                type: PartyType;
                legalEntity?: {
                  __typename?: 'LegalEntity';
                  name: string;
                  tradeRegisterNumber?: string | null;
                  isFoundation: boolean;
                  register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
                } | null;
                naturalPerson?: {
                  __typename?: 'NaturalPerson';
                  tag?: string | null;
                  dateOfBirth?: any | null;
                  dateOfDecease?: any | null;
                  name: {
                    __typename?: 'Name';
                    preposition?: string | null;
                    initials?: string | null;
                    firstName?: string | null;
                    nickname?: string | null;
                    lastName: string;
                  };
                } | null;
              };
            } | null;
          }> | null;
        };
        delta: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        result: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
        shareTypeUpdate: Array<{
          __typename?: 'ShareTypeUpdate';
          before: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
          after: {
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          };
        }>;
      }>;
    }>;
    partyAttachmentStates: Array<{
      __typename?: 'PartyAttachmentState';
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      attachments: Array<{
        __typename?: 'PartyAttachment';
        attachedAt: any;
        type: AttachmentType;
        requiredBy: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }>;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: Array<{
          __typename?: 'ShareBatch';
          paid?: boolean | null;
          shareholder: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          modifiedBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          acquiredBy: Array<{
            __typename?: 'RegisterMutation';
            id: string;
            type: MutationType;
            title?: string | null;
            effectiveDate?: any | null;
          }>;
          pledgeDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          usufructDetails: Array<{
            __typename?: 'DelegationDetails';
            voting: boolean;
            meeting: boolean;
            dividend: boolean;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            delegatee: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          }>;
          administrationDetails?: {
            __typename?: 'AdministrationDetails';
            endsAt?: any | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            administrator: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
          } | null;
          attachmentDetails?: {
            __typename?: 'AttachmentDetails';
            attachedAt?: string | null;
            createdBy?: {
              __typename?: 'RegisterMutation';
              id: string;
              type: MutationType;
              title?: string | null;
              effectiveDate?: any | null;
            } | null;
            bailiff: {
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            };
            requiredBy?: Array<{
              __typename?: 'Party';
              id: string;
              type: PartyType;
              legalEntity?: {
                __typename?: 'LegalEntity';
                name: string;
                tradeRegisterNumber?: string | null;
                isFoundation: boolean;
                register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
              } | null;
              naturalPerson?: {
                __typename?: 'NaturalPerson';
                tag?: string | null;
                dateOfBirth?: any | null;
                dateOfDecease?: any | null;
                name: {
                  __typename?: 'Name';
                  preposition?: string | null;
                  initials?: string | null;
                  firstName?: string | null;
                  nickname?: string | null;
                  lastName: string;
                };
              } | null;
            }> | null;
          } | null;
          shareSeries: {
            __typename?: 'ShareSeries';
            from: any;
            to: any;
            shareType: {
              __typename?: 'ShareType';
              id: string;
              versionId: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              certificatesPerShare?: number | null;
              endedOn?: any | null;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
              register: { __typename?: 'Register'; id: string };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              versions: Array<{
                __typename?: 'ShareTypeVersion';
                id: string;
                name: string;
                voting: boolean;
                dividend: boolean;
                meeting: boolean;
                certificatesPerShare?: number | null;
                classifier?: string | null;
                authorizedCapitalAmount: any;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                underlyingShareType?: {
                  __typename?: 'ShareType';
                  id: string;
                  classifier?: string | null;
                  name: string;
                  nominalValue: {
                    __typename?: 'Money';
                    currencyCode: string;
                    units: any;
                    cents: any;
                    precision: number;
                  };
                  register: {
                    __typename?: 'Register';
                    id: string;
                    legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                  };
                } | null;
                createdInMutation?: {
                  __typename?: 'RegisterMutation';
                  id: string;
                  effectiveDate?: any | null;
                } | null;
              }>;
            };
          };
        }>;
      }>;
    }>;
  } | null;
};

export type ExportRegisterOfShareholdersQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  locale: Locale;
  sign?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExportRegisterOfShareholdersQuery = {
  __typename?: 'Query';
  exportRegisterOfShareholders: any;
};

export type ExportShareholderCsvQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  locale: Locale;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExportShareholderCsvQuery = { __typename?: 'Query'; exportShareholderCsv: any };

export type ExportShareholderExcelQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  locale: Locale;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ExportShareholderExcelQuery = { __typename?: 'Query'; exportShareholderExcel: any };

export type ExportShareholderExtractQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
  partyId: Scalars['ID']['input'];
  locale: Locale;
}>;

export type ExportShareholderExtractQuery = { __typename?: 'Query'; exportShareholderExtract: any };

export type RecalculateRegisterMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type RecalculateRegisterMutation = {
  __typename?: 'Mutation';
  recalculateRegister: {
    __typename?: 'Register';
    id: string;
    replacement: boolean;
    endedOn?: any | null;
    effectiveDate?: any | null;
    articleOfAssociationUpdatedOn?: any | null;
    trustConditionsUpdatedOn?: any | null;
    entitlement: Entitlement;
    isSigned: boolean;
    lastUpdatedOn: any;
    legalEntity: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      incorporatedOn?: any | null;
      legalForm?: string | null;
      isFoundation: boolean;
      phoneNumber?: string | null;
      emailAddress?: string | null;
      tradeRegisterNumber?: string | null;
      countryOfRegistration: string;
      rsinNumber?: string | null;
      visitorAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
      correspondenceAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
    };
    requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
    shareTypes: Array<{
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    }>;
    shareBatches: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    shareholders: Array<{
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
    }>;
    mutations: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    }>;
    signatures: Array<{
      __typename?: 'RegisterSignature';
      id: string;
      signedOn: any;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  };
};

export type UpdateRegisterMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  register: RegisterInput;
}>;

export type UpdateRegisterMutation = {
  __typename?: 'Mutation';
  updateRegister: { __typename?: 'Register'; replacement: boolean };
};

export type SignRegisterMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type SignRegisterMutation = {
  __typename?: 'Mutation';
  signRegister: {
    __typename?: 'Register';
    id: string;
    replacement: boolean;
    endedOn?: any | null;
    effectiveDate?: any | null;
    articleOfAssociationUpdatedOn?: any | null;
    trustConditionsUpdatedOn?: any | null;
    entitlement: Entitlement;
    isSigned: boolean;
    lastUpdatedOn: any;
    legalEntity: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      incorporatedOn?: any | null;
      legalForm?: string | null;
      isFoundation: boolean;
      phoneNumber?: string | null;
      emailAddress?: string | null;
      tradeRegisterNumber?: string | null;
      countryOfRegistration: string;
      rsinNumber?: string | null;
      visitorAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
      correspondenceAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
    };
    requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
    shareTypes: Array<{
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    }>;
    shareBatches: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    shareholders: Array<{
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
    }>;
    mutations: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    }>;
    signatures: Array<{
      __typename?: 'RegisterSignature';
      id: string;
      signedOn: any;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  };
};

export type UnsignRegisterMutationVariables = Exact<{
  registerSignatureId: Scalars['ID']['input'];
}>;

export type UnsignRegisterMutation = {
  __typename?: 'Mutation';
  unsignRegister: {
    __typename?: 'Register';
    id: string;
    replacement: boolean;
    endedOn?: any | null;
    effectiveDate?: any | null;
    articleOfAssociationUpdatedOn?: any | null;
    trustConditionsUpdatedOn?: any | null;
    entitlement: Entitlement;
    isSigned: boolean;
    lastUpdatedOn: any;
    legalEntity: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      incorporatedOn?: any | null;
      legalForm?: string | null;
      isFoundation: boolean;
      phoneNumber?: string | null;
      emailAddress?: string | null;
      tradeRegisterNumber?: string | null;
      countryOfRegistration: string;
      rsinNumber?: string | null;
      visitorAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
      correspondenceAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
    };
    requestForAccess?: { __typename?: 'AccessRequest'; id: string } | null;
    shareTypes: Array<{
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    }>;
    shareBatches: Array<{
      __typename?: 'ShareBatch';
      paid?: boolean | null;
      shareholder: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      modifiedBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      acquiredBy: Array<{
        __typename?: 'RegisterMutation';
        id: string;
        type: MutationType;
        title?: string | null;
        effectiveDate?: any | null;
      }>;
      pledgeDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      usufructDetails: Array<{
        __typename?: 'DelegationDetails';
        voting: boolean;
        meeting: boolean;
        dividend: boolean;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        delegatee: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }>;
      administrationDetails?: {
        __typename?: 'AdministrationDetails';
        endsAt?: any | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        administrator: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      } | null;
      attachmentDetails?: {
        __typename?: 'AttachmentDetails';
        attachedAt?: string | null;
        createdBy?: {
          __typename?: 'RegisterMutation';
          id: string;
          type: MutationType;
          title?: string | null;
          effectiveDate?: any | null;
        } | null;
        bailiff: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        requiredBy?: Array<{
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        }> | null;
      } | null;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
    }>;
    shareholders: Array<{
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
        participation?: {
          __typename?: 'Participation';
          comment?: string | null;
          tags: Array<string>;
          participationTypes: Array<ParticipationType>;
          iban?: string | null;
          register: { __typename?: 'Register'; id: string };
          shareBatches: Array<{
            __typename?: 'ShareBatch';
            shareSeries: {
              __typename?: 'ShareSeries';
              from: any;
              to: any;
              shareType: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
              };
            };
          }>;
          meetingRights?: {
            __typename?: 'MeetingRights';
            startDate: any;
            endDate?: any | null;
          } | null;
        } | null;
      } | null;
    }>;
    mutations: Array<{
      __typename?: 'RegisterMutation';
      id: string;
      type: MutationType;
      title?: string | null;
      commentary?: string | null;
      effectiveDate?: any | null;
      acknowledgedDate?: any | null;
      createdOn: any;
      lastUpdatedOn: any;
      seq?: number | null;
      isDraft: boolean;
      editable: boolean;
      dossierNumber?: string | null;
      lastUpdatedBy: { __typename?: 'User'; id: string; email: string };
      validationErrors: Array<{
        __typename?: 'ValidationError';
        field?: string | null;
        code: string;
        message?: string | null;
        params: Array<{ __typename?: 'ValidationErrorParam'; name: string; value: string }>;
      }>;
      administration?: Array<{
        __typename?: 'Administration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AdministrationDetails';
          endsAt?: any | null;
          administrator: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      appointDirector?: Array<{
        __typename?: 'Director';
        id: string;
        title?: string | null;
        authority: DirectorAuthority;
        representationAuthority: RepresentationAuthority;
        appointedOn?: any | null;
        endedOn?: any | null;
        status: DirectorStatus;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      attachment?: Array<{
        __typename?: 'Attachment';
        type: AttachmentType;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
          requiredBy?: Array<{
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          }> | null;
        } | null;
      }> | null;
      conversion?: Array<{
        __typename?: 'Conversion';
        action: ConversionAction;
        paid?: boolean | null;
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAdministration?: Array<{
        __typename?: 'EndAdministration';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      endAttachment?: Array<{
        __typename?: 'EndAttachment';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'AttachmentDetails';
          attachedAt?: string | null;
          bailiff: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      endDirectorship?: Array<{
        __typename?: 'EndDirectorship';
        directorshipId: string;
        director: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endPledge?: Array<{
        __typename?: 'EndPledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      endUbo?: Array<{
        __typename?: 'EndUbo';
        ground: UboGround;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      endUsufruct?: Array<{
        __typename?: 'EndUsufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details: Array<{
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        }>;
      }> | null;
      incorporation?: Array<{
        __typename?: 'Incorporation';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      issuance?: Array<{
        __typename?: 'Issuance';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      liquidation?: { __typename?: 'Liquidation'; reason?: string | null } | null;
      onboarding?: Array<{
        __typename?: 'Onboarding';
        paid?: boolean | null;
        to: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      payingUp?: Array<{
        __typename?: 'PayingUp';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
      pledge?: Array<{
        __typename?: 'Pledge';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      transfer?: Array<{
        __typename?: 'Transfer';
        to?: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        } | null;
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      ubo?: Array<{
        __typename?: 'Ubo';
        ground: UboGround;
        ownershipRange?: UboOwnershipRange | null;
        naturalPerson: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
      }> | null;
      usufruct?: Array<{
        __typename?: 'Usufruct';
        owner: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
        details?: {
          __typename?: 'DelegationDetails';
          voting: boolean;
          meeting: boolean;
          dividend: boolean;
          delegatee: {
            __typename?: 'Party';
            id: string;
            type: PartyType;
            legalEntity?: {
              __typename?: 'LegalEntity';
              name: string;
              tradeRegisterNumber?: string | null;
              isFoundation: boolean;
              register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
            } | null;
            naturalPerson?: {
              __typename?: 'NaturalPerson';
              tag?: string | null;
              dateOfBirth?: any | null;
              dateOfDecease?: any | null;
              name: {
                __typename?: 'Name';
                preposition?: string | null;
                initials?: string | null;
                firstName?: string | null;
                nickname?: string | null;
                lastName: string;
              };
            } | null;
          };
        } | null;
      }> | null;
      withdrawal?: Array<{
        __typename?: 'Withdrawal';
        from: {
          __typename?: 'Party';
          id: string;
          type: PartyType;
          legalEntity?: {
            __typename?: 'LegalEntity';
            name: string;
            tradeRegisterNumber?: string | null;
            isFoundation: boolean;
            register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
          } | null;
          naturalPerson?: {
            __typename?: 'NaturalPerson';
            tag?: string | null;
            dateOfBirth?: any | null;
            dateOfDecease?: any | null;
            name: {
              __typename?: 'Name';
              preposition?: string | null;
              initials?: string | null;
              firstName?: string | null;
              nickname?: string | null;
              lastName: string;
            };
          } | null;
        };
        shareSeries: {
          __typename?: 'ShareSeries';
          from: any;
          to: any;
          shareType: {
            __typename?: 'ShareType';
            id: string;
            versionId: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            certificatesPerShare?: number | null;
            endedOn?: any | null;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
            register: { __typename?: 'Register'; id: string };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            versions: Array<{
              __typename?: 'ShareTypeVersion';
              id: string;
              name: string;
              voting: boolean;
              dividend: boolean;
              meeting: boolean;
              certificatesPerShare?: number | null;
              classifier?: string | null;
              authorizedCapitalAmount: any;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              underlyingShareType?: {
                __typename?: 'ShareType';
                id: string;
                classifier?: string | null;
                name: string;
                nominalValue: {
                  __typename?: 'Money';
                  currencyCode: string;
                  units: any;
                  cents: any;
                  precision: number;
                };
                register: {
                  __typename?: 'Register';
                  id: string;
                  legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
                };
              } | null;
              createdInMutation?: {
                __typename?: 'RegisterMutation';
                id: string;
                effectiveDate?: any | null;
              } | null;
            }>;
          };
        };
      }> | null;
    }>;
    documents: Array<{
      __typename?: 'Document';
      id: string;
      type: DocumentType;
      labels: Array<DocumentLabel>;
      date: any;
      commentary?: string | null;
      canBeRemoved?: boolean | null;
      deedPassed?: {
        __typename?: 'DeedPassed';
        notaryRole: NotaryRole;
        notary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
        assignedNotary?: {
          __typename?: 'DeedNotary';
          location: string;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      } | null;
      mutation?: { __typename?: 'RegisterMutation'; id: string; type: MutationType } | null;
      file?: { __typename?: 'File'; name: string; mimeType: string } | null;
    }>;
    signatures: Array<{
      __typename?: 'RegisterSignature';
      id: string;
      signedOn: any;
      user: {
        __typename?: 'User';
        id: string;
        email: string;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      };
    }>;
  };
};

export type ReleasesQueryVariables = Exact<{
  locale?: InputMaybe<Locale>;
}>;

export type ReleasesQuery = {
  __typename?: 'Query';
  releases: Array<{
    __typename?: 'Release';
    id: string;
    locale: Locale;
    date?: any | null;
    title?: string | null;
    media?: string | null;
    content?: string | null;
  }>;
};

export type ShareGroupEntryFieldsFragment = {
  __typename?: 'ShareGroupEntry';
  id: string;
  isValid: boolean;
  shareSeries: {
    __typename?: 'ShareSeries';
    from: any;
    to: any;
    shareType: {
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    };
  };
  party: {
    __typename?: 'Party';
    id: string;
    type: PartyType;
    legalEntity?: {
      __typename?: 'LegalEntity';
      name: string;
      tradeRegisterNumber?: string | null;
      isFoundation: boolean;
      register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
    } | null;
    naturalPerson?: {
      __typename?: 'NaturalPerson';
      tag?: string | null;
      dateOfBirth?: any | null;
      dateOfDecease?: any | null;
      name: {
        __typename?: 'Name';
        preposition?: string | null;
        initials?: string | null;
        firstName?: string | null;
        nickname?: string | null;
        lastName: string;
      };
    } | null;
  };
  shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
};

export type ShareGroupFieldsFragment = {
  __typename?: 'ShareGroup';
  id: string;
  name: string;
  registerId: string;
  entries: Array<{
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  }>;
};

export type ShareGroupsQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type ShareGroupsQuery = {
  __typename?: 'Query';
  shareGroups: Array<{
    __typename?: 'ShareGroup';
    id: string;
    name: string;
    registerId: string;
    entries: Array<{
      __typename?: 'ShareGroupEntry';
      id: string;
      isValid: boolean;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
    }>;
  }>;
};

export type ShareGroupEntriesQueryVariables = Exact<{
  registerId: Scalars['ID']['input'];
}>;

export type ShareGroupEntriesQuery = {
  __typename?: 'Query';
  shareGroupEntries: Array<{
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  }>;
};

export type CreateShareGroupMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  shareGroupName: Scalars['String']['input'];
}>;

export type CreateShareGroupMutation = {
  __typename?: 'Mutation';
  createShareGroup: {
    __typename?: 'ShareGroup';
    id: string;
    name: string;
    registerId: string;
    entries: Array<{
      __typename?: 'ShareGroupEntry';
      id: string;
      isValid: boolean;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
    }>;
  };
};

export type UpdateShareGroupMutationVariables = Exact<{
  shareGroupId: Scalars['ID']['input'];
  shareGroupName: Scalars['String']['input'];
}>;

export type UpdateShareGroupMutation = {
  __typename?: 'Mutation';
  updateShareGroup: {
    __typename?: 'ShareGroup';
    id: string;
    name: string;
    registerId: string;
    entries: Array<{
      __typename?: 'ShareGroupEntry';
      id: string;
      isValid: boolean;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
    }>;
  };
};

export type DeleteShareGroupMutationVariables = Exact<{
  shareGroupId: Scalars['ID']['input'];
}>;

export type DeleteShareGroupMutation = {
  __typename?: 'Mutation';
  deleteShareGroup: {
    __typename?: 'ShareGroup';
    id: string;
    name: string;
    registerId: string;
    entries: Array<{
      __typename?: 'ShareGroupEntry';
      id: string;
      isValid: boolean;
      shareSeries: {
        __typename?: 'ShareSeries';
        from: any;
        to: any;
        shareType: {
          __typename?: 'ShareType';
          id: string;
          versionId: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          certificatesPerShare?: number | null;
          endedOn?: any | null;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
          register: { __typename?: 'Register'; id: string };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          versions: Array<{
            __typename?: 'ShareTypeVersion';
            id: string;
            name: string;
            voting: boolean;
            dividend: boolean;
            meeting: boolean;
            certificatesPerShare?: number | null;
            classifier?: string | null;
            authorizedCapitalAmount: any;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            underlyingShareType?: {
              __typename?: 'ShareType';
              id: string;
              classifier?: string | null;
              name: string;
              nominalValue: {
                __typename?: 'Money';
                currencyCode: string;
                units: any;
                cents: any;
                precision: number;
              };
              register: {
                __typename?: 'Register';
                id: string;
                legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
              };
            } | null;
            createdInMutation?: {
              __typename?: 'RegisterMutation';
              id: string;
              effectiveDate?: any | null;
            } | null;
          }>;
        };
      };
      party: {
        __typename?: 'Party';
        id: string;
        type: PartyType;
        legalEntity?: {
          __typename?: 'LegalEntity';
          name: string;
          tradeRegisterNumber?: string | null;
          isFoundation: boolean;
          register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
        } | null;
        naturalPerson?: {
          __typename?: 'NaturalPerson';
          tag?: string | null;
          dateOfBirth?: any | null;
          dateOfDecease?: any | null;
          name: {
            __typename?: 'Name';
            preposition?: string | null;
            initials?: string | null;
            firstName?: string | null;
            nickname?: string | null;
            lastName: string;
          };
        } | null;
      };
      shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
    }>;
  };
};

export type CreateShareGroupEntryMutationVariables = Exact<{
  shareGroupEntryInput: ShareGroupEntryInput;
}>;

export type CreateShareGroupEntryMutation = {
  __typename?: 'Mutation';
  createShareGroupEntry: {
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  };
};

export type UpdateShareGroupEntryMutationVariables = Exact<{
  shareGroupEntryId: Scalars['ID']['input'];
  shareGroupEntryInput: ShareGroupEntryInput;
}>;

export type UpdateShareGroupEntryMutation = {
  __typename?: 'Mutation';
  updateShareGroupEntry: {
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  };
};

export type DeleteShareGroupEntryMutationVariables = Exact<{
  shareGroupEntryId: Scalars['ID']['input'];
}>;

export type DeleteShareGroupEntryMutation = {
  __typename?: 'Mutation';
  deleteShareGroupEntry: {
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  };
};

export type AddAllSharesToShareGroupMutationVariables = Exact<{
  partyId: Scalars['ID']['input'];
  shareGroupId: Scalars['ID']['input'];
}>;

export type AddAllSharesToShareGroupMutation = {
  __typename?: 'Mutation';
  addAllSharesToShareGroup: Array<{
    __typename?: 'ShareGroupEntry';
    id: string;
    isValid: boolean;
    shareSeries: {
      __typename?: 'ShareSeries';
      from: any;
      to: any;
      shareType: {
        __typename?: 'ShareType';
        id: string;
        versionId: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        certificatesPerShare?: number | null;
        endedOn?: any | null;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
        register: { __typename?: 'Register'; id: string };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        versions: Array<{
          __typename?: 'ShareTypeVersion';
          id: string;
          name: string;
          voting: boolean;
          dividend: boolean;
          meeting: boolean;
          certificatesPerShare?: number | null;
          classifier?: string | null;
          authorizedCapitalAmount: any;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          underlyingShareType?: {
            __typename?: 'ShareType';
            id: string;
            classifier?: string | null;
            name: string;
            nominalValue: {
              __typename?: 'Money';
              currencyCode: string;
              units: any;
              cents: any;
              precision: number;
            };
            register: {
              __typename?: 'Register';
              id: string;
              legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
            };
          } | null;
          createdInMutation?: {
            __typename?: 'RegisterMutation';
            id: string;
            effectiveDate?: any | null;
          } | null;
        }>;
      };
    };
    party: {
      __typename?: 'Party';
      id: string;
      type: PartyType;
      legalEntity?: {
        __typename?: 'LegalEntity';
        name: string;
        tradeRegisterNumber?: string | null;
        isFoundation: boolean;
        register?: { __typename?: 'Register'; id: string; endedOn?: any | null } | null;
      } | null;
      naturalPerson?: {
        __typename?: 'NaturalPerson';
        tag?: string | null;
        dateOfBirth?: any | null;
        dateOfDecease?: any | null;
        name: {
          __typename?: 'Name';
          preposition?: string | null;
          initials?: string | null;
          firstName?: string | null;
          nickname?: string | null;
          lastName: string;
        };
      } | null;
    };
    shareGroup: { __typename?: 'ShareGroup'; id: string; name: string };
  }>;
};

export type AvailableShareTypesForCertificationQueryVariables = Exact<{
  stakId: Scalars['ID']['input'];
}>;

export type AvailableShareTypesForCertificationQuery = {
  __typename?: 'Query';
  availableShareTypesForCertification: Array<{
    __typename?: 'CertifiableShareType';
    legalEntity: {
      __typename?: 'LegalEntity';
      id: string;
      name: string;
      incorporatedOn?: any | null;
      legalForm?: string | null;
      isFoundation: boolean;
      phoneNumber?: string | null;
      emailAddress?: string | null;
      tradeRegisterNumber?: string | null;
      countryOfRegistration: string;
      rsinNumber?: string | null;
      visitorAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
      correspondenceAddress?: {
        __typename?: 'PostalAddress';
        streetName?: string | null;
        streetNumber?: string | null;
        streetNumberAddition?: string | null;
        postalCode?: string | null;
        postOfficeBoxNumber?: string | null;
        city?: string | null;
        countryCode?: string | null;
        streetHouseNumber?: string | null;
        postalCodeCity?: string | null;
        region?: string | null;
      } | null;
    };
    shareType: {
      __typename?: 'ShareType';
      id: string;
      versionId: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      certificatesPerShare?: number | null;
      endedOn?: any | null;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
      register: { __typename?: 'Register'; id: string };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      versions: Array<{
        __typename?: 'ShareTypeVersion';
        id: string;
        name: string;
        voting: boolean;
        dividend: boolean;
        meeting: boolean;
        certificatesPerShare?: number | null;
        classifier?: string | null;
        authorizedCapitalAmount: any;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        underlyingShareType?: {
          __typename?: 'ShareType';
          id: string;
          classifier?: string | null;
          name: string;
          nominalValue: {
            __typename?: 'Money';
            currencyCode: string;
            units: any;
            cents: any;
            precision: number;
          };
          register: {
            __typename?: 'Register';
            id: string;
            legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
          };
        } | null;
        createdInMutation?: {
          __typename?: 'RegisterMutation';
          id: string;
          effectiveDate?: any | null;
        } | null;
      }>;
    };
  }>;
};

export type CreateShareTypeMutationVariables = Exact<{
  registerId: Scalars['ID']['input'];
  shareType: ShareTypeInput;
}>;

export type CreateShareTypeMutation = {
  __typename?: 'Mutation';
  createShareType: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export type UpdateShareTypeMutationVariables = Exact<{
  shareTypeId: Scalars['ID']['input'];
  shareType: ShareTypeInput;
}>;

export type UpdateShareTypeMutation = {
  __typename?: 'Mutation';
  updateShareType: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export type CorrectShareTypeVersionMutationVariables = Exact<{
  shareTypeVersionId: Scalars['ID']['input'];
  shareType: ShareTypeInput;
}>;

export type CorrectShareTypeVersionMutation = {
  __typename?: 'Mutation';
  correctShareTypeVersion: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export type DeleteShareTypeVersionMutationVariables = Exact<{
  shareTypeVersionId: Scalars['ID']['input'];
}>;

export type DeleteShareTypeVersionMutation = {
  __typename?: 'Mutation';
  deleteShareTypeVersion: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export type DeleteShareTypeMutationVariables = Exact<{
  shareTypeId: Scalars['ID']['input'];
}>;

export type DeleteShareTypeMutation = {
  __typename?: 'Mutation';
  deleteShareType: {
    __typename?: 'ShareType';
    id: string;
    versionId: string;
    name: string;
    voting: boolean;
    dividend: boolean;
    meeting: boolean;
    classifier?: string | null;
    authorizedCapitalAmount: any;
    certificatesPerShare?: number | null;
    endedOn?: any | null;
    nominalValue: {
      __typename?: 'Money';
      currencyCode: string;
      units: any;
      cents: any;
      precision: number;
    };
    createdInMutation?: { __typename?: 'RegisterMutation'; id: string } | null;
    register: { __typename?: 'Register'; id: string };
    underlyingShareType?: {
      __typename?: 'ShareType';
      id: string;
      classifier?: string | null;
      name: string;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      register: {
        __typename?: 'Register';
        id: string;
        legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
      };
    } | null;
    versions: Array<{
      __typename?: 'ShareTypeVersion';
      id: string;
      name: string;
      voting: boolean;
      dividend: boolean;
      meeting: boolean;
      certificatesPerShare?: number | null;
      classifier?: string | null;
      authorizedCapitalAmount: any;
      nominalValue: {
        __typename?: 'Money';
        currencyCode: string;
        units: any;
        cents: any;
        precision: number;
      };
      underlyingShareType?: {
        __typename?: 'ShareType';
        id: string;
        classifier?: string | null;
        name: string;
        nominalValue: {
          __typename?: 'Money';
          currencyCode: string;
          units: any;
          cents: any;
          precision: number;
        };
        register: {
          __typename?: 'Register';
          id: string;
          legalEntity: { __typename?: 'LegalEntity'; id: string; name: string };
        };
      } | null;
      createdInMutation?: {
        __typename?: 'RegisterMutation';
        id: string;
        effectiveDate?: any | null;
      } | null;
    }>;
  };
};

export const EntitledEntityFieldsFragmentDoc = gql`
  fragment EntitledEntityFields on EntitledEntity {
    id
    name
    email
    type
    entitlement
    temporaryAccessExpiration
  }
`;
export const NameFieldsFragmentDoc = gql`
  fragment NameFields on Name {
    preposition
    initials
    firstName
    nickname
    lastName
  }
`;
export const AccessRequestFieldsFragmentDoc = gql`
  fragment AccessRequestFields on AccessRequest {
    id
    register {
      id
      legalEntity {
        name
        tradeRegisterNumber
      }
    }
    requestedAt
    requestedByGroup {
      id
      name
    }
    requestedByUser {
      id
      email
      name {
        ...NameFields
      }
    }
    entitlement
    reason
  }
  ${NameFieldsFragmentDoc}
`;
export const InvitationFieldsFragmentDoc = gql`
  fragment InvitationFields on Invitation {
    id
    email
    register {
      id
      name
      tradeRegisterNumber
    }
    invitedByGroup {
      id
      name
    }
    invitedByUser {
      id
      name {
        ...NameFields
      }
    }
    entitlement
    status
    created
    validUntil
    accepted
  }
  ${NameFieldsFragmentDoc}
`;
export const PostalAddressFieldsFragmentDoc = gql`
  fragment PostalAddressFields on PostalAddress {
    streetName
    streetNumber
    streetNumberAddition
    postalCode
    postOfficeBoxNumber
    city
    countryCode
    streetHouseNumber
    postalCodeCity
    region
  }
`;
export const IdentityDocumentFieldsFragmentDoc = gql`
  fragment IdentityDocumentFields on IdentityDocument {
    id
    type
    expiryDate
    uploadedOn
    uploadedBy {
      id
      email
      name {
        ...NameFields
      }
    }
    file {
      name
      mimeType
      size
      uploadedAt
    }
    downloadHistory {
      id
      reason
      downloadedOn
      downloadedBy {
        id
        email
        name {
          ...NameFields
        }
      }
    }
  }
  ${NameFieldsFragmentDoc}
`;
export const NaturalPersonFieldsFragmentDoc = gql`
  fragment NaturalPersonFields on NaturalPerson {
    id
    name {
      ...NameFields
    }
    tag
    dateOfBirth
    dateOfDecease
    placeOfBirth
    postalAddress {
      ...PostalAddressFields
    }
    identityDocument {
      ...IdentityDocumentFields
    }
    phoneNumber
    emailAddress
  }
  ${NameFieldsFragmentDoc}
  ${PostalAddressFieldsFragmentDoc}
  ${IdentityDocumentFieldsFragmentDoc}
`;
export const ValidationErrorsFieldsFragmentDoc = gql`
  fragment ValidationErrorsFields on ValidationError {
    field
    code
    message
    params {
      name
      value
    }
  }
`;
export const PartyFieldsFragmentDoc = gql`
  fragment PartyFields on Party {
    id
    type
    legalEntity {
      name
      tradeRegisterNumber
      isFoundation
      register {
        id
        endedOn
      }
    }
    naturalPerson {
      name {
        ...NameFields
      }
      tag
      dateOfBirth
      dateOfDecease
    }
  }
  ${NameFieldsFragmentDoc}
`;
export const ShareTypeVersionFieldsFragmentDoc = gql`
  fragment ShareTypeVersionFields on ShareTypeVersion {
    id
    name
    voting
    dividend
    meeting
    nominalValue {
      currencyCode
      units
      cents
      precision
    }
    certificatesPerShare
    underlyingShareType {
      id
      nominalValue {
        currencyCode
        units
        cents
        precision
      }
      classifier
      name
      register {
        id
        legalEntity {
          id
          name
        }
      }
    }
    classifier
    authorizedCapitalAmount
    createdInMutation {
      id
      effectiveDate
    }
  }
`;
export const ShareTypeFieldsFragmentDoc = gql`
  fragment ShareTypeFields on ShareType {
    id
    versionId
    name
    voting
    dividend
    meeting
    nominalValue {
      currencyCode
      units
      cents
      precision
    }
    classifier
    authorizedCapitalAmount
    createdInMutation {
      id
    }
    register {
      id
    }
    certificatesPerShare
    underlyingShareType {
      id
      nominalValue {
        currencyCode
        units
        cents
        precision
      }
      classifier
      name
      register {
        id
        legalEntity {
          id
          name
        }
      }
    }
    endedOn
    versions {
      ...ShareTypeVersionFields
    }
  }
  ${ShareTypeVersionFieldsFragmentDoc}
`;
export const ShareSeriesFieldsFragmentDoc = gql`
  fragment ShareSeriesFields on ShareSeries {
    from
    to
    shareType {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export const DelegationDetailsFieldsFragmentDoc = gql`
  fragment DelegationDetailsFields on DelegationDetails {
    delegatee {
      ...PartyFields
    }
    voting
    meeting
    dividend
  }
  ${PartyFieldsFragmentDoc}
`;
export const MutationFieldsFragmentDoc = gql`
  fragment MutationFields on RegisterMutation {
    id
    type
    title
    commentary
    effectiveDate
    acknowledgedDate
    createdOn
    lastUpdatedOn
    lastUpdatedBy {
      id
      email
    }
    seq
    isDraft
    editable
    dossierNumber
    validationErrors {
      ...ValidationErrorsFields
    }
    administration {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        administrator {
          ...PartyFields
        }
        endsAt
      }
    }
    appointDirector {
      id
      title
      authority
      representationAuthority
      appointedOn
      endedOn
      status
      director {
        ...PartyFields
      }
    }
    attachment {
      owner {
        ...PartyFields
      }
      type
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        bailiff {
          ...PartyFields
        }
        requiredBy {
          ...PartyFields
        }
        attachedAt
      }
    }
    conversion {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      action
      paid
    }
    endAdministration {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
    }
    endAttachment {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        bailiff {
          ...PartyFields
        }
        attachedAt
      }
    }
    endDirectorship {
      directorshipId
      director {
        ...PartyFields
      }
    }
    endPledge {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        ...DelegationDetailsFields
      }
    }
    endUbo {
      ground
      naturalPerson {
        ...PartyFields
      }
    }
    endUsufruct {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        ...DelegationDetailsFields
      }
    }
    incorporation {
      to {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      paid
    }
    issuance {
      to {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      paid
    }
    liquidation {
      reason
    }
    onboarding {
      to {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      paid
    }
    payingUp {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
    }
    pledge {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        ...DelegationDetailsFields
      }
    }
    transfer {
      to {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      from {
        ...PartyFields
      }
    }
    ubo {
      ground
      ownershipRange
      naturalPerson {
        ...PartyFields
      }
    }
    usufruct {
      owner {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
      details {
        ...DelegationDetailsFields
      }
    }
    withdrawal {
      from {
        ...PartyFields
      }
      shareSeries {
        ...ShareSeriesFields
      }
    }
  }
  ${ValidationErrorsFieldsFragmentDoc}
  ${PartyFieldsFragmentDoc}
  ${ShareSeriesFieldsFragmentDoc}
  ${DelegationDetailsFieldsFragmentDoc}
`;
export const DeedNotaryFieldsFragmentDoc = gql`
  fragment DeedNotaryFields on DeedNotary {
    name {
      ...NameFields
    }
    location
  }
  ${NameFieldsFragmentDoc}
`;
export const DocumentFieldsFragmentDoc = gql`
  fragment DocumentFields on Document {
    id
    type
    labels
    date
    commentary
    deedPassed {
      notary {
        ...DeedNotaryFields
      }
      notaryRole
      assignedNotary {
        ...DeedNotaryFields
      }
    }
    mutation {
      id
      type
    }
    file {
      name
      mimeType
    }
    canBeRemoved
  }
  ${DeedNotaryFieldsFragmentDoc}
`;
export const MutationWithDocumentFieldsFragmentDoc = gql`
  fragment MutationWithDocumentFields on RegisterMutation {
    ...MutationFields
    document {
      ...DocumentFields
    }
    price {
      amountEuros
      exemption
    }
  }
  ${MutationFieldsFragmentDoc}
  ${DocumentFieldsFragmentDoc}
`;
export const LegalEntityFieldsFragmentDoc = gql`
  fragment LegalEntityFields on LegalEntity {
    id
    name
    incorporatedOn
    legalForm
    isFoundation
    phoneNumber
    emailAddress
    tradeRegisterNumber
    countryOfRegistration
    rsinNumber
    visitorAddress {
      ...PostalAddressFields
    }
    correspondenceAddress {
      ...PostalAddressFields
    }
  }
  ${PostalAddressFieldsFragmentDoc}
`;
export const ShareBatchFieldsFragmentDoc = gql`
  fragment ShareBatchFields on ShareBatch {
    paid
    shareholder {
      ...PartyFields
    }
    modifiedBy {
      id
      type
      title
      effectiveDate
    }
    acquiredBy {
      id
      type
      title
      effectiveDate
    }
    pledgeDetails {
      createdBy {
        id
        type
        title
        effectiveDate
      }
      delegatee {
        ...PartyFields
      }
      voting
      meeting
      dividend
    }
    usufructDetails {
      createdBy {
        id
        type
        title
        effectiveDate
      }
      delegatee {
        ...PartyFields
      }
      voting
      meeting
      dividend
    }
    administrationDetails {
      createdBy {
        id
        type
        title
        effectiveDate
      }
      administrator {
        ...PartyFields
      }
      endsAt
    }
    attachmentDetails {
      createdBy {
        id
        type
        title
        effectiveDate
      }
      bailiff {
        ...PartyFields
      }
      requiredBy {
        ...PartyFields
      }
      attachedAt
    }
    shareSeries {
      ...ShareSeriesFields
    }
  }
  ${PartyFieldsFragmentDoc}
  ${ShareSeriesFieldsFragmentDoc}
`;
export const ParticipationsFieldsFragmentDoc = gql`
  fragment ParticipationsFields on Participation {
    register {
      id
    }
    shareBatches {
      shareSeries {
        from
        to
        shareType {
          id
          nominalValue {
            currencyCode
            units
            cents
            precision
          }
          classifier
          name
        }
      }
    }
    comment
    tags
    participationTypes
    meetingRights {
      startDate
      endDate
    }
    iban
  }
`;
export const PartyWithParticipationsFieldsFragmentDoc = gql`
  fragment PartyWithParticipationsFields on Party {
    id
    type
    legalEntity {
      name
      tradeRegisterNumber
      isFoundation
      participation {
        ...ParticipationsFields
      }
    }
    naturalPerson {
      name {
        ...NameFields
      }
      tag
      dateOfBirth
      dateOfDecease
      participation {
        ...ParticipationsFields
      }
    }
  }
  ${ParticipationsFieldsFragmentDoc}
  ${NameFieldsFragmentDoc}
`;
export const RegisterSignatureFieldsFragmentDoc = gql`
  fragment RegisterSignatureFields on RegisterSignature {
    id
    user {
      id
      email
      name {
        ...NameFields
      }
    }
    signedOn
  }
  ${NameFieldsFragmentDoc}
`;
export const RegisterFieldsFragmentDoc = gql`
  fragment RegisterFields on Register {
    id
    legalEntity {
      ...LegalEntityFields
    }
    replacement
    endedOn
    effectiveDate
    articleOfAssociationUpdatedOn
    trustConditionsUpdatedOn
    requestForAccess {
      id
    }
    shareTypes {
      ...ShareTypeFields
    }
    shareBatches {
      ...ShareBatchFields
    }
    shareholders {
      ...PartyWithParticipationsFields
    }
    mutations {
      ...MutationFields
    }
    documents {
      ...DocumentFields
    }
    entitlement
    isSigned
    signatures {
      ...RegisterSignatureFields
    }
    lastUpdatedOn
  }
  ${LegalEntityFieldsFragmentDoc}
  ${ShareTypeFieldsFragmentDoc}
  ${ShareBatchFieldsFragmentDoc}
  ${PartyWithParticipationsFieldsFragmentDoc}
  ${MutationFieldsFragmentDoc}
  ${DocumentFieldsFragmentDoc}
  ${RegisterSignatureFieldsFragmentDoc}
`;
export const PartyUpdateFieldsFragmentDoc = gql`
  fragment PartyUpdateFields on PartyUpdate {
    id
    party {
      ...PartyFields
    }
    field
    before
    after
    requiresDocument
    date
    document {
      ...DocumentFields
    }
    reason
  }
  ${PartyFieldsFragmentDoc}
  ${DocumentFieldsFragmentDoc}
`;
export const AccountFieldsFragmentDoc = gql`
  fragment AccountFields on Account {
    user {
      id
      email
      name {
        ...NameFields
      }
    }
    locale
    entitlements
    notary
    group {
      id
      name
      logo
    }
    hasLicenseAgreement
    isAdmin
    isUserAdmin
  }
  ${NameFieldsFragmentDoc}
`;
export const ShareBatchDividendStatementFieldsFragmentDoc = gql`
  fragment ShareBatchDividendStatementFields on ShareBatch {
    paid
    pledgeDetails {
      dividend
    }
    usufructDetails {
      dividend
    }
    attachmentDetails {
      attachedAt
    }
    shareSeries {
      ...ShareSeriesFields
    }
  }
  ${ShareSeriesFieldsFragmentDoc}
`;
export const MoneyFieldsFragmentDoc = gql`
  fragment MoneyFields on Money {
    currencyCode
    units
    cents
    precision
  }
`;
export const DividendStatementFieldsFragmentDoc = gql`
  fragment DividendStatementFields on DividendStatement {
    id
    title
    description
    effectiveDate
    paymentDate
    taxRate
    registerLegalEntity {
      isFoundation
    }
    shareTypes {
      shareType {
        ...ShareTypeFields
      }
      amount {
        ...MoneyFields
      }
    }
    partyStatements {
      id
      party {
        ...PartyWithParticipationsFields
      }
      entries {
        id
        shareType {
          ...ShareTypeFields
        }
        shareBatch {
          ...ShareBatchFields
        }
        totalAmount {
          ...MoneyFields
        }
        shareCount
        amountFromDelegation {
          ...MoneyFields
        }
        shareCountFromDelegation
        shareBatchFromDelegation {
          ...ShareBatchFields
        }
        amountDelegated {
          ...MoneyFields
        }
        shareCountDelegated
        shareBatchDelegated {
          ...ShareBatchFields
        }
      }
      totalAmount {
        currencyCode
        units
        cents
        precision
      }
      taxAmount {
        currencyCode
        units
        cents
        precision
      }
      description
    }
    shouldSync
  }
  ${ShareTypeFieldsFragmentDoc}
  ${MoneyFieldsFragmentDoc}
  ${PartyWithParticipationsFieldsFragmentDoc}
  ${ShareBatchFieldsFragmentDoc}
`;
export const ManagementUserFieldsFragmentDoc = gql`
  fragment ManagementUserFields on ManagementUser {
    user {
      id
      email
      name {
        ...NameFields
      }
    }
    admin
    userAdmin
    groupAdmin
    archived
    group {
      id
      name
      logo
    }
    temporaryAccessExpiration
  }
  ${NameFieldsFragmentDoc}
`;
export const ManagementGroupFieldsFragmentDoc = gql`
  fragment ManagementGroupFields on ManagementGroup {
    group {
      id
      name
      logo
    }
    registersCount
    remarks
    notary
    temporaryAccessExpiration
    subscriptionType
    tradeRegisterNumber
    phoneNumber
    email
  }
`;
export const NotaryFieldsFragmentDoc = gql`
  fragment NotaryFields on Notary {
    id
    type
    initials
    prefix
    firstName
    lastName
    location
    email
    group {
      id
      name
    }
    active
  }
`;
export const ExportMutationFieldsFragmentDoc = gql`
  fragment ExportMutationFields on RegisterMutation {
    type
    title
    commentary
    effectiveDate
    acknowledgedDate
    document {
      date
      commentary
      deedPassed {
        notary {
          ...DeedNotaryFields
        }
        notaryRole
        assignedNotary {
          ...DeedNotaryFields
        }
      }
    }
    administration {
      owner {
        id
        type
      }
      details {
        administrator {
          ...PartyFields
        }
        endsAt
      }
    }
    conversion {
      owner {
        id
        type
      }
      action
      paid
    }
    endAdministration {
      owner {
        id
        type
      }
    }
    endPledge {
      owner {
        ...PartyFields
      }
      shareSeries {
        from
        to
        shareType {
          id
          name
          classifier
        }
      }
    }
    endUsufruct {
      owner {
        id
        type
      }
      details {
        ...DelegationDetailsFields
      }
    }
    liquidation {
      reason
    }
    payingUp {
      owner {
        id
        type
      }
    }
    pledge {
      details {
        ...DelegationDetailsFields
      }
    }
    usufruct {
      details {
        ...DelegationDetailsFields
      }
    }
  }
  ${DeedNotaryFieldsFragmentDoc}
  ${PartyFieldsFragmentDoc}
  ${DelegationDetailsFieldsFragmentDoc}
`;
export const PartyMutationHistoryFieldsFragmentDoc = gql`
  fragment PartyMutationHistoryFields on PartyMutationHistory {
    party {
      ...PartyFields
    }
    partyUpdateHistory {
      date
      party {
        ...PartyFields
      }
      updateFields
    }
    mutations {
      mutation {
        ...ExportMutationFields
      }
      delta {
        ...ShareBatchFields
      }
      result {
        ...ShareBatchFields
      }
      shareTypeUpdate {
        before {
          ...ShareTypeVersionFields
        }
        after {
          ...ShareTypeVersionFields
        }
      }
    }
  }
  ${PartyFieldsFragmentDoc}
  ${ExportMutationFieldsFragmentDoc}
  ${ShareBatchFieldsFragmentDoc}
  ${ShareTypeVersionFieldsFragmentDoc}
`;
export const ShareGroupEntryFieldsFragmentDoc = gql`
  fragment ShareGroupEntryFields on ShareGroupEntry {
    id
    shareSeries {
      ...ShareSeriesFields
    }
    party {
      ...PartyFields
    }
    isValid
    shareGroup {
      id
      name
    }
  }
  ${ShareSeriesFieldsFragmentDoc}
  ${PartyFieldsFragmentDoc}
`;
export const ShareGroupFieldsFragmentDoc = gql`
  fragment ShareGroupFields on ShareGroup {
    id
    name
    registerId
    entries {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;
export const AccessRequestsDocument = gql`
  query AccessRequests($registerId: ID) {
    accessRequests(registerId: $registerId) {
      ...AccessRequestFields
    }
  }
  ${AccessRequestFieldsFragmentDoc}
`;

/**
 * __useAccessRequestsQuery__
 *
 * To run a query within a React component, call `useAccessRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessRequestsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useAccessRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<AccessRequestsQuery, AccessRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccessRequestsQuery, AccessRequestsQueryVariables>(
    AccessRequestsDocument,
    options,
  );
}
export function useAccessRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccessRequestsQuery, AccessRequestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccessRequestsQuery, AccessRequestsQueryVariables>(
    AccessRequestsDocument,
    options,
  );
}
// @ts-ignore
export function useAccessRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AccessRequestsQuery, AccessRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AccessRequestsQuery, AccessRequestsQueryVariables>;
export function useAccessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AccessRequestsQuery, AccessRequestsQueryVariables>,
): Apollo.UseSuspenseQueryResult<AccessRequestsQuery | undefined, AccessRequestsQueryVariables>;
export function useAccessRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AccessRequestsQuery, AccessRequestsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccessRequestsQuery, AccessRequestsQueryVariables>(
    AccessRequestsDocument,
    options,
  );
}
export type AccessRequestsQueryHookResult = ReturnType<typeof useAccessRequestsQuery>;
export type AccessRequestsLazyQueryHookResult = ReturnType<typeof useAccessRequestsLazyQuery>;
export type AccessRequestsSuspenseQueryHookResult = ReturnType<
  typeof useAccessRequestsSuspenseQuery
>;
export type AccessRequestsQueryResult = Apollo.QueryResult<
  AccessRequestsQuery,
  AccessRequestsQueryVariables
>;
export const CreateAccessRequestDocument = gql`
  mutation CreateAccessRequest($registerId: ID!, $entitlement: Entitlement!, $reason: String!) {
    createAccessRequest(registerId: $registerId, entitlement: $entitlement, reason: $reason) {
      ...AccessRequestFields
    }
  }
  ${AccessRequestFieldsFragmentDoc}
`;
export type CreateAccessRequestMutationFn = Apollo.MutationFunction<
  CreateAccessRequestMutation,
  CreateAccessRequestMutationVariables
>;

/**
 * __useCreateAccessRequestMutation__
 *
 * To run a mutation, you first call `useCreateAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessRequestMutation, { data, loading, error }] = useCreateAccessRequestMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      entitlement: // value for 'entitlement'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateAccessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccessRequestMutation,
    CreateAccessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateAccessRequestMutation, CreateAccessRequestMutationVariables>(
    CreateAccessRequestDocument,
    options,
  );
}
export type CreateAccessRequestMutationHookResult = ReturnType<
  typeof useCreateAccessRequestMutation
>;
export type CreateAccessRequestMutationResult = Apollo.MutationResult<CreateAccessRequestMutation>;
export type CreateAccessRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateAccessRequestMutation,
  CreateAccessRequestMutationVariables
>;
export const RemindAccessRequestDocument = gql`
  mutation RemindAccessRequest($accessRequestId: ID!, $reminder: String!) {
    remindAccessRequest(accessRequestId: $accessRequestId, reminder: $reminder) {
      ...AccessRequestFields
    }
  }
  ${AccessRequestFieldsFragmentDoc}
`;
export type RemindAccessRequestMutationFn = Apollo.MutationFunction<
  RemindAccessRequestMutation,
  RemindAccessRequestMutationVariables
>;

/**
 * __useRemindAccessRequestMutation__
 *
 * To run a mutation, you first call `useRemindAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindAccessRequestMutation, { data, loading, error }] = useRemindAccessRequestMutation({
 *   variables: {
 *      accessRequestId: // value for 'accessRequestId'
 *      reminder: // value for 'reminder'
 *   },
 * });
 */
export function useRemindAccessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemindAccessRequestMutation,
    RemindAccessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemindAccessRequestMutation, RemindAccessRequestMutationVariables>(
    RemindAccessRequestDocument,
    options,
  );
}
export type RemindAccessRequestMutationHookResult = ReturnType<
  typeof useRemindAccessRequestMutation
>;
export type RemindAccessRequestMutationResult = Apollo.MutationResult<RemindAccessRequestMutation>;
export type RemindAccessRequestMutationOptions = Apollo.BaseMutationOptions<
  RemindAccessRequestMutation,
  RemindAccessRequestMutationVariables
>;
export const DeleteAccessRequestDocument = gql`
  mutation DeleteAccessRequest($accessRequestId: ID!) {
    deleteAccessRequest(accessRequestId: $accessRequestId) {
      id
    }
  }
`;
export type DeleteAccessRequestMutationFn = Apollo.MutationFunction<
  DeleteAccessRequestMutation,
  DeleteAccessRequestMutationVariables
>;

/**
 * __useDeleteAccessRequestMutation__
 *
 * To run a mutation, you first call `useDeleteAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccessRequestMutation, { data, loading, error }] = useDeleteAccessRequestMutation({
 *   variables: {
 *      accessRequestId: // value for 'accessRequestId'
 *   },
 * });
 */
export function useDeleteAccessRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAccessRequestMutation,
    DeleteAccessRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAccessRequestMutation, DeleteAccessRequestMutationVariables>(
    DeleteAccessRequestDocument,
    options,
  );
}
export type DeleteAccessRequestMutationHookResult = ReturnType<
  typeof useDeleteAccessRequestMutation
>;
export type DeleteAccessRequestMutationResult = Apollo.MutationResult<DeleteAccessRequestMutation>;
export type DeleteAccessRequestMutationOptions = Apollo.BaseMutationOptions<
  DeleteAccessRequestMutation,
  DeleteAccessRequestMutationVariables
>;
export const AccountDocument = gql`
  query Account {
    account {
      ...AccountFields
    }
  }
  ${AccountFieldsFragmentDoc}
`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountQuery(
  baseOptions?: Apollo.QueryHookOptions<AccountQuery, AccountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
}
export function useAccountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
}
// @ts-ignore
export function useAccountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<AccountQuery, AccountQueryVariables>;
export function useAccountSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>,
): Apollo.UseSuspenseQueryResult<AccountQuery | undefined, AccountQueryVariables>;
export function useAccountSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountQuery, AccountQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
}
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountSuspenseQueryHookResult = ReturnType<typeof useAccountSuspenseQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export const UpdateAccountDocument = gql`
  mutation UpdateAccount($account: AccountInput!) {
    updateAccount(account: $account) {
      ...AccountFields
    }
  }
  ${AccountFieldsFragmentDoc}
`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useUpdateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(
    UpdateAccountDocument,
    options,
  );
}
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<
  UpdateAccountMutation,
  UpdateAccountMutationVariables
>;
export const SignupLicenseAgreementDocument = gql`
  mutation SignupLicenseAgreement($input: LicenseAgreementInput!) {
    signupLicenseAgreement(input: $input)
  }
`;
export type SignupLicenseAgreementMutationFn = Apollo.MutationFunction<
  SignupLicenseAgreementMutation,
  SignupLicenseAgreementMutationVariables
>;

/**
 * __useSignupLicenseAgreementMutation__
 *
 * To run a mutation, you first call `useSignupLicenseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupLicenseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupLicenseAgreementMutation, { data, loading, error }] = useSignupLicenseAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupLicenseAgreementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignupLicenseAgreementMutation,
    SignupLicenseAgreementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignupLicenseAgreementMutation,
    SignupLicenseAgreementMutationVariables
  >(SignupLicenseAgreementDocument, options);
}
export type SignupLicenseAgreementMutationHookResult = ReturnType<
  typeof useSignupLicenseAgreementMutation
>;
export type SignupLicenseAgreementMutationResult =
  Apollo.MutationResult<SignupLicenseAgreementMutation>;
export type SignupLicenseAgreementMutationOptions = Apollo.BaseMutationOptions<
  SignupLicenseAgreementMutation,
  SignupLicenseAgreementMutationVariables
>;
export const RegisterAuditTrailDocument = gql`
  query RegisterAuditTrail($filter: RegisterAuditTrailFilterInput!, $pagination: PaginationInput!) {
    registerAuditTrail(filter: $filter, pagination: $pagination) {
      items {
        id
        eventType
        timestamp
        details
        params {
          name
          value
        }
        register {
          id
          name
        }
        user {
          user {
            name {
              ...NameFields
            }
            email
          }
          group {
            name
          }
        }
      }
      pagination {
        totalCount
      }
    }
  }
  ${NameFieldsFragmentDoc}
`;

/**
 * __useRegisterAuditTrailQuery__
 *
 * To run a query within a React component, call `useRegisterAuditTrailQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterAuditTrailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterAuditTrailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useRegisterAuditTrailQuery(
  baseOptions: Apollo.QueryHookOptions<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables> &
    ({ variables: RegisterAuditTrailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>(
    RegisterAuditTrailDocument,
    options,
  );
}
export function useRegisterAuditTrailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterAuditTrailQuery,
    RegisterAuditTrailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>(
    RegisterAuditTrailDocument,
    options,
  );
}
// @ts-ignore
export function useRegisterAuditTrailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegisterAuditTrailQuery,
    RegisterAuditTrailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>;
export function useRegisterAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  RegisterAuditTrailQuery | undefined,
  RegisterAuditTrailQueryVariables
>;
export function useRegisterAuditTrailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegisterAuditTrailQuery, RegisterAuditTrailQueryVariables>(
    RegisterAuditTrailDocument,
    options,
  );
}
export type RegisterAuditTrailQueryHookResult = ReturnType<typeof useRegisterAuditTrailQuery>;
export type RegisterAuditTrailLazyQueryHookResult = ReturnType<
  typeof useRegisterAuditTrailLazyQuery
>;
export type RegisterAuditTrailSuspenseQueryHookResult = ReturnType<
  typeof useRegisterAuditTrailSuspenseQuery
>;
export type RegisterAuditTrailQueryResult = Apollo.QueryResult<
  RegisterAuditTrailQuery,
  RegisterAuditTrailQueryVariables
>;
export const SearchCompaniesDocument = gql`
  query SearchCompanies($searchTerm: String!) {
    searchCompanies(searchTerm: $searchTerm) {
      registryNumber
      companyName
      city
    }
  }
`;

/**
 * __useSearchCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCompaniesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useSearchCompaniesQuery(
  baseOptions: Apollo.QueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables> &
    ({ variables: SearchCompaniesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(
    SearchCompaniesDocument,
    options,
  );
}
export function useSearchCompaniesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(
    SearchCompaniesDocument,
    options,
  );
}
// @ts-ignore
export function useSearchCompaniesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchCompaniesQuery,
    SearchCompaniesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<SearchCompaniesQuery, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>,
): Apollo.UseSuspenseQueryResult<SearchCompaniesQuery | undefined, SearchCompaniesQueryVariables>;
export function useSearchCompaniesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SearchCompaniesQuery, SearchCompaniesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<SearchCompaniesQuery, SearchCompaniesQueryVariables>(
    SearchCompaniesDocument,
    options,
  );
}
export type SearchCompaniesQueryHookResult = ReturnType<typeof useSearchCompaniesQuery>;
export type SearchCompaniesLazyQueryHookResult = ReturnType<typeof useSearchCompaniesLazyQuery>;
export type SearchCompaniesSuspenseQueryHookResult = ReturnType<
  typeof useSearchCompaniesSuspenseQuery
>;
export type SearchCompaniesQueryResult = Apollo.QueryResult<
  SearchCompaniesQuery,
  SearchCompaniesQueryVariables
>;
export const GetDividendStatementDefaultsDocument = gql`
  query GetDividendStatementDefaults($registerId: ID!, $effectiveDate: Date!) {
    getDividendStatementDefaults(registerId: $registerId, effectiveDate: $effectiveDate) {
      ...DividendStatementFields
    }
  }
  ${DividendStatementFieldsFragmentDoc}
`;

/**
 * __useGetDividendStatementDefaultsQuery__
 *
 * To run a query within a React component, call `useGetDividendStatementDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDividendStatementDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDividendStatementDefaultsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useGetDividendStatementDefaultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  > &
    ({ variables: GetDividendStatementDefaultsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  >(GetDividendStatementDefaultsDocument, options);
}
export function useGetDividendStatementDefaultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  >(GetDividendStatementDefaultsDocument, options);
}
// @ts-ignore
export function useGetDividendStatementDefaultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetDividendStatementDefaultsQuery,
  GetDividendStatementDefaultsQueryVariables
>;
export function useGetDividendStatementDefaultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDividendStatementDefaultsQuery,
        GetDividendStatementDefaultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetDividendStatementDefaultsQuery | undefined,
  GetDividendStatementDefaultsQueryVariables
>;
export function useGetDividendStatementDefaultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDividendStatementDefaultsQuery,
        GetDividendStatementDefaultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDividendStatementDefaultsQuery,
    GetDividendStatementDefaultsQueryVariables
  >(GetDividendStatementDefaultsDocument, options);
}
export type GetDividendStatementDefaultsQueryHookResult = ReturnType<
  typeof useGetDividendStatementDefaultsQuery
>;
export type GetDividendStatementDefaultsLazyQueryHookResult = ReturnType<
  typeof useGetDividendStatementDefaultsLazyQuery
>;
export type GetDividendStatementDefaultsSuspenseQueryHookResult = ReturnType<
  typeof useGetDividendStatementDefaultsSuspenseQuery
>;
export type GetDividendStatementDefaultsQueryResult = Apollo.QueryResult<
  GetDividendStatementDefaultsQuery,
  GetDividendStatementDefaultsQueryVariables
>;
export const DividendStatementDocument = gql`
  query DividendStatement($id: ID!) {
    dividendStatement(id: $id) {
      ...DividendStatementFields
    }
  }
  ${DividendStatementFieldsFragmentDoc}
`;

/**
 * __useDividendStatementQuery__
 *
 * To run a query within a React component, call `useDividendStatementQuery` and pass it any options that fit your needs.
 * When your component renders, `useDividendStatementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendStatementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDividendStatementQuery(
  baseOptions: Apollo.QueryHookOptions<DividendStatementQuery, DividendStatementQueryVariables> &
    ({ variables: DividendStatementQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DividendStatementQuery, DividendStatementQueryVariables>(
    DividendStatementDocument,
    options,
  );
}
export function useDividendStatementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DividendStatementQuery,
    DividendStatementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DividendStatementQuery, DividendStatementQueryVariables>(
    DividendStatementDocument,
    options,
  );
}
// @ts-ignore
export function useDividendStatementSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DividendStatementQuery,
    DividendStatementQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DividendStatementQuery, DividendStatementQueryVariables>;
export function useDividendStatementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DividendStatementQuery, DividendStatementQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DividendStatementQuery | undefined,
  DividendStatementQueryVariables
>;
export function useDividendStatementSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DividendStatementQuery, DividendStatementQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DividendStatementQuery, DividendStatementQueryVariables>(
    DividendStatementDocument,
    options,
  );
}
export type DividendStatementQueryHookResult = ReturnType<typeof useDividendStatementQuery>;
export type DividendStatementLazyQueryHookResult = ReturnType<typeof useDividendStatementLazyQuery>;
export type DividendStatementSuspenseQueryHookResult = ReturnType<
  typeof useDividendStatementSuspenseQuery
>;
export type DividendStatementQueryResult = Apollo.QueryResult<
  DividendStatementQuery,
  DividendStatementQueryVariables
>;
export const DividendStatementsDocument = gql`
  query DividendStatements($registerId: ID!) {
    dividendStatements(registerId: $registerId) {
      id
      title
      description
      effectiveDate
      paymentDate
      partyStatements {
        totalAmount {
          ...MoneyFields
        }
      }
      shouldSync
    }
  }
  ${MoneyFieldsFragmentDoc}
`;

/**
 * __useDividendStatementsQuery__
 *
 * To run a query within a React component, call `useDividendStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDividendStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDividendStatementsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useDividendStatementsQuery(
  baseOptions: Apollo.QueryHookOptions<DividendStatementsQuery, DividendStatementsQueryVariables> &
    ({ variables: DividendStatementsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DividendStatementsQuery, DividendStatementsQueryVariables>(
    DividendStatementsDocument,
    options,
  );
}
export function useDividendStatementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DividendStatementsQuery,
    DividendStatementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DividendStatementsQuery, DividendStatementsQueryVariables>(
    DividendStatementsDocument,
    options,
  );
}
// @ts-ignore
export function useDividendStatementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DividendStatementsQuery,
    DividendStatementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<DividendStatementsQuery, DividendStatementsQueryVariables>;
export function useDividendStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DividendStatementsQuery, DividendStatementsQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  DividendStatementsQuery | undefined,
  DividendStatementsQueryVariables
>;
export function useDividendStatementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DividendStatementsQuery, DividendStatementsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DividendStatementsQuery, DividendStatementsQueryVariables>(
    DividendStatementsDocument,
    options,
  );
}
export type DividendStatementsQueryHookResult = ReturnType<typeof useDividendStatementsQuery>;
export type DividendStatementsLazyQueryHookResult = ReturnType<
  typeof useDividendStatementsLazyQuery
>;
export type DividendStatementsSuspenseQueryHookResult = ReturnType<
  typeof useDividendStatementsSuspenseQuery
>;
export type DividendStatementsQueryResult = Apollo.QueryResult<
  DividendStatementsQuery,
  DividendStatementsQueryVariables
>;
export const ExportDividendStatementPdfDocument = gql`
  query ExportDividendStatementPdf($id: ID!, $locale: Locale!, $recipientEmail: String) {
    exportDividendStatementPdf(id: $id, locale: $locale, recipientEmail: $recipientEmail)
  }
`;

/**
 * __useExportDividendStatementPdfQuery__
 *
 * To run a query within a React component, call `useExportDividendStatementPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDividendStatementPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDividendStatementPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *      recipientEmail: // value for 'recipientEmail'
 *   },
 * });
 */
export function useExportDividendStatementPdfQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportDividendStatementPdfQuery,
    ExportDividendStatementPdfQueryVariables
  > &
    ({ variables: ExportDividendStatementPdfQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportDividendStatementPdfQuery, ExportDividendStatementPdfQueryVariables>(
    ExportDividendStatementPdfDocument,
    options,
  );
}
export function useExportDividendStatementPdfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportDividendStatementPdfQuery,
    ExportDividendStatementPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportDividendStatementPdfQuery,
    ExportDividendStatementPdfQueryVariables
  >(ExportDividendStatementPdfDocument, options);
}
// @ts-ignore
export function useExportDividendStatementPdfSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportDividendStatementPdfQuery,
    ExportDividendStatementPdfQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementPdfQuery,
  ExportDividendStatementPdfQueryVariables
>;
export function useExportDividendStatementPdfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementPdfQuery,
        ExportDividendStatementPdfQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementPdfQuery | undefined,
  ExportDividendStatementPdfQueryVariables
>;
export function useExportDividendStatementPdfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementPdfQuery,
        ExportDividendStatementPdfQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportDividendStatementPdfQuery,
    ExportDividendStatementPdfQueryVariables
  >(ExportDividendStatementPdfDocument, options);
}
export type ExportDividendStatementPdfQueryHookResult = ReturnType<
  typeof useExportDividendStatementPdfQuery
>;
export type ExportDividendStatementPdfLazyQueryHookResult = ReturnType<
  typeof useExportDividendStatementPdfLazyQuery
>;
export type ExportDividendStatementPdfSuspenseQueryHookResult = ReturnType<
  typeof useExportDividendStatementPdfSuspenseQuery
>;
export type ExportDividendStatementPdfQueryResult = Apollo.QueryResult<
  ExportDividendStatementPdfQuery,
  ExportDividendStatementPdfQueryVariables
>;
export const ExportDividendStatementPartyPdfDocument = gql`
  query ExportDividendStatementPartyPdf($id: ID!, $partyId: ID!, $locale: Locale!) {
    exportDividendStatementPartyPdf(id: $id, partyId: $partyId, locale: $locale)
  }
`;

/**
 * __useExportDividendStatementPartyPdfQuery__
 *
 * To run a query within a React component, call `useExportDividendStatementPartyPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDividendStatementPartyPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDividendStatementPartyPdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *      partyId: // value for 'partyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useExportDividendStatementPartyPdfQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  > &
    (
      | { variables: ExportDividendStatementPartyPdfQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  >(ExportDividendStatementPartyPdfDocument, options);
}
export function useExportDividendStatementPartyPdfLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  >(ExportDividendStatementPartyPdfDocument, options);
}
// @ts-ignore
export function useExportDividendStatementPartyPdfSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementPartyPdfQuery,
  ExportDividendStatementPartyPdfQueryVariables
>;
export function useExportDividendStatementPartyPdfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementPartyPdfQuery,
        ExportDividendStatementPartyPdfQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementPartyPdfQuery | undefined,
  ExportDividendStatementPartyPdfQueryVariables
>;
export function useExportDividendStatementPartyPdfSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementPartyPdfQuery,
        ExportDividendStatementPartyPdfQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportDividendStatementPartyPdfQuery,
    ExportDividendStatementPartyPdfQueryVariables
  >(ExportDividendStatementPartyPdfDocument, options);
}
export type ExportDividendStatementPartyPdfQueryHookResult = ReturnType<
  typeof useExportDividendStatementPartyPdfQuery
>;
export type ExportDividendStatementPartyPdfLazyQueryHookResult = ReturnType<
  typeof useExportDividendStatementPartyPdfLazyQuery
>;
export type ExportDividendStatementPartyPdfSuspenseQueryHookResult = ReturnType<
  typeof useExportDividendStatementPartyPdfSuspenseQuery
>;
export type ExportDividendStatementPartyPdfQueryResult = Apollo.QueryResult<
  ExportDividendStatementPartyPdfQuery,
  ExportDividendStatementPartyPdfQueryVariables
>;
export const ExportDividendStatementCsvDocument = gql`
  query ExportDividendStatementCsv($id: ID!, $locale: Locale!) {
    exportDividendStatementCsv(id: $id, locale: $locale)
  }
`;

/**
 * __useExportDividendStatementCsvQuery__
 *
 * To run a query within a React component, call `useExportDividendStatementCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportDividendStatementCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportDividendStatementCsvQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useExportDividendStatementCsvQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportDividendStatementCsvQuery,
    ExportDividendStatementCsvQueryVariables
  > &
    ({ variables: ExportDividendStatementCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportDividendStatementCsvQuery, ExportDividendStatementCsvQueryVariables>(
    ExportDividendStatementCsvDocument,
    options,
  );
}
export function useExportDividendStatementCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportDividendStatementCsvQuery,
    ExportDividendStatementCsvQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportDividendStatementCsvQuery,
    ExportDividendStatementCsvQueryVariables
  >(ExportDividendStatementCsvDocument, options);
}
// @ts-ignore
export function useExportDividendStatementCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportDividendStatementCsvQuery,
    ExportDividendStatementCsvQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementCsvQuery,
  ExportDividendStatementCsvQueryVariables
>;
export function useExportDividendStatementCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementCsvQuery,
        ExportDividendStatementCsvQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportDividendStatementCsvQuery | undefined,
  ExportDividendStatementCsvQueryVariables
>;
export function useExportDividendStatementCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportDividendStatementCsvQuery,
        ExportDividendStatementCsvQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportDividendStatementCsvQuery,
    ExportDividendStatementCsvQueryVariables
  >(ExportDividendStatementCsvDocument, options);
}
export type ExportDividendStatementCsvQueryHookResult = ReturnType<
  typeof useExportDividendStatementCsvQuery
>;
export type ExportDividendStatementCsvLazyQueryHookResult = ReturnType<
  typeof useExportDividendStatementCsvLazyQuery
>;
export type ExportDividendStatementCsvSuspenseQueryHookResult = ReturnType<
  typeof useExportDividendStatementCsvSuspenseQuery
>;
export type ExportDividendStatementCsvQueryResult = Apollo.QueryResult<
  ExportDividendStatementCsvQuery,
  ExportDividendStatementCsvQueryVariables
>;
export const CreateDividendStatementDocument = gql`
  mutation CreateDividendStatement($registerId: ID!, $dividendStatement: DividendStatementInput!) {
    createDividendStatement(registerId: $registerId, dividendStatement: $dividendStatement) {
      ...DividendStatementFields
    }
  }
  ${DividendStatementFieldsFragmentDoc}
`;
export type CreateDividendStatementMutationFn = Apollo.MutationFunction<
  CreateDividendStatementMutation,
  CreateDividendStatementMutationVariables
>;

/**
 * __useCreateDividendStatementMutation__
 *
 * To run a mutation, you first call `useCreateDividendStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDividendStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDividendStatementMutation, { data, loading, error }] = useCreateDividendStatementMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      dividendStatement: // value for 'dividendStatement'
 *   },
 * });
 */
export function useCreateDividendStatementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDividendStatementMutation,
    CreateDividendStatementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDividendStatementMutation,
    CreateDividendStatementMutationVariables
  >(CreateDividendStatementDocument, options);
}
export type CreateDividendStatementMutationHookResult = ReturnType<
  typeof useCreateDividendStatementMutation
>;
export type CreateDividendStatementMutationResult =
  Apollo.MutationResult<CreateDividendStatementMutation>;
export type CreateDividendStatementMutationOptions = Apollo.BaseMutationOptions<
  CreateDividendStatementMutation,
  CreateDividendStatementMutationVariables
>;
export const UpdateDividendStatementDocument = gql`
  mutation UpdateDividendStatement($id: ID!, $dividendStatement: DividendStatementInput!) {
    updateDividendStatement(id: $id, dividendStatement: $dividendStatement) {
      ...DividendStatementFields
    }
  }
  ${DividendStatementFieldsFragmentDoc}
`;
export type UpdateDividendStatementMutationFn = Apollo.MutationFunction<
  UpdateDividendStatementMutation,
  UpdateDividendStatementMutationVariables
>;

/**
 * __useUpdateDividendStatementMutation__
 *
 * To run a mutation, you first call `useUpdateDividendStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDividendStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDividendStatementMutation, { data, loading, error }] = useUpdateDividendStatementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dividendStatement: // value for 'dividendStatement'
 *   },
 * });
 */
export function useUpdateDividendStatementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDividendStatementMutation,
    UpdateDividendStatementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDividendStatementMutation,
    UpdateDividendStatementMutationVariables
  >(UpdateDividendStatementDocument, options);
}
export type UpdateDividendStatementMutationHookResult = ReturnType<
  typeof useUpdateDividendStatementMutation
>;
export type UpdateDividendStatementMutationResult =
  Apollo.MutationResult<UpdateDividendStatementMutation>;
export type UpdateDividendStatementMutationOptions = Apollo.BaseMutationOptions<
  UpdateDividendStatementMutation,
  UpdateDividendStatementMutationVariables
>;
export const DeleteDividendStatementDocument = gql`
  mutation DeleteDividendStatement($id: ID!) {
    deleteDividendStatement(id: $id)
  }
`;
export type DeleteDividendStatementMutationFn = Apollo.MutationFunction<
  DeleteDividendStatementMutation,
  DeleteDividendStatementMutationVariables
>;

/**
 * __useDeleteDividendStatementMutation__
 *
 * To run a mutation, you first call `useDeleteDividendStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDividendStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDividendStatementMutation, { data, loading, error }] = useDeleteDividendStatementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDividendStatementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDividendStatementMutation,
    DeleteDividendStatementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDividendStatementMutation,
    DeleteDividendStatementMutationVariables
  >(DeleteDividendStatementDocument, options);
}
export type DeleteDividendStatementMutationHookResult = ReturnType<
  typeof useDeleteDividendStatementMutation
>;
export type DeleteDividendStatementMutationResult =
  Apollo.MutationResult<DeleteDividendStatementMutation>;
export type DeleteDividendStatementMutationOptions = Apollo.BaseMutationOptions<
  DeleteDividendStatementMutation,
  DeleteDividendStatementMutationVariables
>;
export const SyncDividendStatementWithRegisterDocument = gql`
  mutation SyncDividendStatementWithRegister($id: ID!, $effectiveDate: Date!, $save: Boolean!) {
    syncDividendStatementWithRegister(id: $id, effectiveDate: $effectiveDate, save: $save) {
      ...DividendStatementFields
    }
  }
  ${DividendStatementFieldsFragmentDoc}
`;
export type SyncDividendStatementWithRegisterMutationFn = Apollo.MutationFunction<
  SyncDividendStatementWithRegisterMutation,
  SyncDividendStatementWithRegisterMutationVariables
>;

/**
 * __useSyncDividendStatementWithRegisterMutation__
 *
 * To run a mutation, you first call `useSyncDividendStatementWithRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDividendStatementWithRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDividendStatementWithRegisterMutation, { data, loading, error }] = useSyncDividendStatementWithRegisterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      effectiveDate: // value for 'effectiveDate'
 *      save: // value for 'save'
 *   },
 * });
 */
export function useSyncDividendStatementWithRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncDividendStatementWithRegisterMutation,
    SyncDividendStatementWithRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncDividendStatementWithRegisterMutation,
    SyncDividendStatementWithRegisterMutationVariables
  >(SyncDividendStatementWithRegisterDocument, options);
}
export type SyncDividendStatementWithRegisterMutationHookResult = ReturnType<
  typeof useSyncDividendStatementWithRegisterMutation
>;
export type SyncDividendStatementWithRegisterMutationResult =
  Apollo.MutationResult<SyncDividendStatementWithRegisterMutation>;
export type SyncDividendStatementWithRegisterMutationOptions = Apollo.BaseMutationOptions<
  SyncDividendStatementWithRegisterMutation,
  SyncDividendStatementWithRegisterMutationVariables
>;
export const DownloadFileDocument = gql`
  query DownloadFile($documentId: ID!) {
    downloadFile(documentId: $documentId)
  }
`;

/**
 * __useDownloadFileQuery__
 *
 * To run a query within a React component, call `useDownloadFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFileQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDownloadFileQuery(
  baseOptions: Apollo.QueryHookOptions<DownloadFileQuery, DownloadFileQueryVariables> &
    ({ variables: DownloadFileQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownloadFileQuery, DownloadFileQueryVariables>(
    DownloadFileDocument,
    options,
  );
}
export function useDownloadFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<DownloadFileQuery, DownloadFileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DownloadFileQuery, DownloadFileQueryVariables>(
    DownloadFileDocument,
    options,
  );
}
// @ts-ignore
export function useDownloadFileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<DownloadFileQuery, DownloadFileQueryVariables>,
): Apollo.UseSuspenseQueryResult<DownloadFileQuery, DownloadFileQueryVariables>;
export function useDownloadFileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DownloadFileQuery, DownloadFileQueryVariables>,
): Apollo.UseSuspenseQueryResult<DownloadFileQuery | undefined, DownloadFileQueryVariables>;
export function useDownloadFileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DownloadFileQuery, DownloadFileQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<DownloadFileQuery, DownloadFileQueryVariables>(
    DownloadFileDocument,
    options,
  );
}
export type DownloadFileQueryHookResult = ReturnType<typeof useDownloadFileQuery>;
export type DownloadFileLazyQueryHookResult = ReturnType<typeof useDownloadFileLazyQuery>;
export type DownloadFileSuspenseQueryHookResult = ReturnType<typeof useDownloadFileSuspenseQuery>;
export type DownloadFileQueryResult = Apollo.QueryResult<
  DownloadFileQuery,
  DownloadFileQueryVariables
>;
export const CreateDocumentDocument = gql`
  mutation CreateDocument($registerId: ID!, $document: DocumentInput!) {
    createDocument(registerId: $registerId, document: $document) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(
    CreateDocumentDocument,
    options,
  );
}
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const UpdateDocumentDocument = gql`
  mutation UpdateDocument($documentId: ID!, $document: DocumentInput!) {
    updateDocument(documentId: $documentId, document: $document) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useUpdateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(
    UpdateDocumentDocument,
    options,
  );
}
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<
  UpdateDocumentMutation,
  UpdateDocumentMutationVariables
>;
export const DeleteDocumentDocument = gql`
  mutation DeleteDocument($documentId: ID!) {
    deleteDocument(documentId: $documentId) {
      ...DocumentFields
    }
  }
  ${DocumentFieldsFragmentDoc}
`;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    options,
  );
}
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<
  DeleteDocumentMutation,
  DeleteDocumentMutationVariables
>;
export const UploadFileDocument = gql`
  mutation UploadFile($documentId: ID!, $file: Upload!) {
    uploadFile(documentId: $documentId, file: $file) {
      name
      mimeType
      size
      uploadedAt
    }
  }
`;
export type UploadFileMutationFn = Apollo.MutationFunction<
  UploadFileMutation,
  UploadFileMutationVariables
>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(
  baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(
    UploadFileDocument,
    options,
  );
}
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<
  UploadFileMutation,
  UploadFileMutationVariables
>;
export const DeleteFileDocument = gql`
  mutation DeleteFile($documentId: ID!) {
    deleteFile(documentId: $documentId) {
      name
      mimeType
      size
      uploadedAt
    }
  }
`;
export type DeleteFileMutationFn = Apollo.MutationFunction<
  DeleteFileMutation,
  DeleteFileMutationVariables
>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteFileMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(
    DeleteFileDocument,
    options,
  );
}
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<
  DeleteFileMutation,
  DeleteFileMutationVariables
>;
export const RenameFileDocument = gql`
  mutation RenameFile($documentId: ID!, $fileName: String!) {
    renameFile(documentId: $documentId, fileName: $fileName) {
      name
      mimeType
      size
      uploadedAt
    }
  }
`;
export type RenameFileMutationFn = Apollo.MutationFunction<
  RenameFileMutation,
  RenameFileMutationVariables
>;

/**
 * __useRenameFileMutation__
 *
 * To run a mutation, you first call `useRenameFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFileMutation, { data, loading, error }] = useRenameFileMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useRenameFileMutation(
  baseOptions?: Apollo.MutationHookOptions<RenameFileMutation, RenameFileMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenameFileMutation, RenameFileMutationVariables>(
    RenameFileDocument,
    options,
  );
}
export type RenameFileMutationHookResult = ReturnType<typeof useRenameFileMutation>;
export type RenameFileMutationResult = Apollo.MutationResult<RenameFileMutation>;
export type RenameFileMutationOptions = Apollo.BaseMutationOptions<
  RenameFileMutation,
  RenameFileMutationVariables
>;
export const RegisterEntitlementsDocument = gql`
  query RegisterEntitlements($registerId: ID!) {
    registerEntitlements(registerId: $registerId) {
      ...EntitledEntityFields
    }
  }
  ${EntitledEntityFieldsFragmentDoc}
`;

/**
 * __useRegisterEntitlementsQuery__
 *
 * To run a query within a React component, call `useRegisterEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterEntitlementsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useRegisterEntitlementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterEntitlementsQuery,
    RegisterEntitlementsQueryVariables
  > &
    ({ variables: RegisterEntitlementsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterEntitlementsQuery, RegisterEntitlementsQueryVariables>(
    RegisterEntitlementsDocument,
    options,
  );
}
export function useRegisterEntitlementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterEntitlementsQuery,
    RegisterEntitlementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegisterEntitlementsQuery, RegisterEntitlementsQueryVariables>(
    RegisterEntitlementsDocument,
    options,
  );
}
// @ts-ignore
export function useRegisterEntitlementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegisterEntitlementsQuery,
    RegisterEntitlementsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RegisterEntitlementsQuery, RegisterEntitlementsQueryVariables>;
export function useRegisterEntitlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterEntitlementsQuery,
        RegisterEntitlementsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RegisterEntitlementsQuery | undefined,
  RegisterEntitlementsQueryVariables
>;
export function useRegisterEntitlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterEntitlementsQuery,
        RegisterEntitlementsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegisterEntitlementsQuery, RegisterEntitlementsQueryVariables>(
    RegisterEntitlementsDocument,
    options,
  );
}
export type RegisterEntitlementsQueryHookResult = ReturnType<typeof useRegisterEntitlementsQuery>;
export type RegisterEntitlementsLazyQueryHookResult = ReturnType<
  typeof useRegisterEntitlementsLazyQuery
>;
export type RegisterEntitlementsSuspenseQueryHookResult = ReturnType<
  typeof useRegisterEntitlementsSuspenseQuery
>;
export type RegisterEntitlementsQueryResult = Apollo.QueryResult<
  RegisterEntitlementsQuery,
  RegisterEntitlementsQueryVariables
>;
export const EntitledEntitiesDocument = gql`
  query EntitledEntities($pagination: PaginationInput!) {
    entitledEntities(pagination: $pagination) {
      items {
        id
        name
        email
        type
        managed
        registersCount
      }
      pagination {
        totalPages
        totalCount
        page
        count
      }
    }
  }
`;

/**
 * __useEntitledEntitiesQuery__
 *
 * To run a query within a React component, call `useEntitledEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledEntitiesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useEntitledEntitiesQuery(
  baseOptions: Apollo.QueryHookOptions<EntitledEntitiesQuery, EntitledEntitiesQueryVariables> &
    ({ variables: EntitledEntitiesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>(
    EntitledEntitiesDocument,
    options,
  );
}
export function useEntitledEntitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>(
    EntitledEntitiesDocument,
    options,
  );
}
// @ts-ignore
export function useEntitledEntitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntitledEntitiesQuery,
    EntitledEntitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>;
export function useEntitledEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>,
): Apollo.UseSuspenseQueryResult<EntitledEntitiesQuery | undefined, EntitledEntitiesQueryVariables>;
export function useEntitledEntitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntitledEntitiesQuery, EntitledEntitiesQueryVariables>(
    EntitledEntitiesDocument,
    options,
  );
}
export type EntitledEntitiesQueryHookResult = ReturnType<typeof useEntitledEntitiesQuery>;
export type EntitledEntitiesLazyQueryHookResult = ReturnType<typeof useEntitledEntitiesLazyQuery>;
export type EntitledEntitiesSuspenseQueryHookResult = ReturnType<
  typeof useEntitledEntitiesSuspenseQuery
>;
export type EntitledEntitiesQueryResult = Apollo.QueryResult<
  EntitledEntitiesQuery,
  EntitledEntitiesQueryVariables
>;
export const EntitledEntityDocument = gql`
  query EntitledEntity($id: ID!) {
    entitledEntity(id: $id) {
      id
      name
      email
      type
    }
  }
`;

/**
 * __useEntitledEntityQuery__
 *
 * To run a query within a React component, call `useEntitledEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntitledEntityQuery(
  baseOptions: Apollo.QueryHookOptions<EntitledEntityQuery, EntitledEntityQueryVariables> &
    ({ variables: EntitledEntityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntitledEntityQuery, EntitledEntityQueryVariables>(
    EntitledEntityDocument,
    options,
  );
}
export function useEntitledEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<EntitledEntityQuery, EntitledEntityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntitledEntityQuery, EntitledEntityQueryVariables>(
    EntitledEntityDocument,
    options,
  );
}
// @ts-ignore
export function useEntitledEntitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<EntitledEntityQuery, EntitledEntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<EntitledEntityQuery, EntitledEntityQueryVariables>;
export function useEntitledEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitledEntityQuery, EntitledEntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<EntitledEntityQuery | undefined, EntitledEntityQueryVariables>;
export function useEntitledEntitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<EntitledEntityQuery, EntitledEntityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<EntitledEntityQuery, EntitledEntityQueryVariables>(
    EntitledEntityDocument,
    options,
  );
}
export type EntitledEntityQueryHookResult = ReturnType<typeof useEntitledEntityQuery>;
export type EntitledEntityLazyQueryHookResult = ReturnType<typeof useEntitledEntityLazyQuery>;
export type EntitledEntitySuspenseQueryHookResult = ReturnType<
  typeof useEntitledEntitySuspenseQuery
>;
export type EntitledEntityQueryResult = Apollo.QueryResult<
  EntitledEntityQuery,
  EntitledEntityQueryVariables
>;
export const UpdateRegisterEntitlementsDocument = gql`
  mutation UpdateRegisterEntitlements(
    $registerId: ID!
    $entitledEntities: [EntitledEntityInput!]!
  ) {
    updateRegisterEntitlements(registerId: $registerId, entitledEntities: $entitledEntities) {
      validationErrors {
        ...ValidationErrorsFields
      }
      entitlements {
        ...EntitledEntityFields
      }
      invitations {
        ...InvitationFields
      }
      accessRequests {
        ...AccessRequestFields
      }
    }
  }
  ${ValidationErrorsFieldsFragmentDoc}
  ${EntitledEntityFieldsFragmentDoc}
  ${InvitationFieldsFragmentDoc}
  ${AccessRequestFieldsFragmentDoc}
`;
export type UpdateRegisterEntitlementsMutationFn = Apollo.MutationFunction<
  UpdateRegisterEntitlementsMutation,
  UpdateRegisterEntitlementsMutationVariables
>;

/**
 * __useUpdateRegisterEntitlementsMutation__
 *
 * To run a mutation, you first call `useUpdateRegisterEntitlementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisterEntitlementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisterEntitlementsMutation, { data, loading, error }] = useUpdateRegisterEntitlementsMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      entitledEntities: // value for 'entitledEntities'
 *   },
 * });
 */
export function useUpdateRegisterEntitlementsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRegisterEntitlementsMutation,
    UpdateRegisterEntitlementsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateRegisterEntitlementsMutation,
    UpdateRegisterEntitlementsMutationVariables
  >(UpdateRegisterEntitlementsDocument, options);
}
export type UpdateRegisterEntitlementsMutationHookResult = ReturnType<
  typeof useUpdateRegisterEntitlementsMutation
>;
export type UpdateRegisterEntitlementsMutationResult =
  Apollo.MutationResult<UpdateRegisterEntitlementsMutation>;
export type UpdateRegisterEntitlementsMutationOptions = Apollo.BaseMutationOptions<
  UpdateRegisterEntitlementsMutation,
  UpdateRegisterEntitlementsMutationVariables
>;
export const UploadIdentityDocumentDocument = gql`
  mutation UploadIdentityDocument(
    $naturalPersonId: ID!
    $type: IdentityDocumentType!
    $expiryDate: Date!
    $file: Upload!
  ) {
    uploadIdentityDocument(
      naturalPersonId: $naturalPersonId
      type: $type
      expiryDate: $expiryDate
      file: $file
    ) {
      ...IdentityDocumentFields
    }
  }
  ${IdentityDocumentFieldsFragmentDoc}
`;
export type UploadIdentityDocumentMutationFn = Apollo.MutationFunction<
  UploadIdentityDocumentMutation,
  UploadIdentityDocumentMutationVariables
>;

/**
 * __useUploadIdentityDocumentMutation__
 *
 * To run a mutation, you first call `useUploadIdentityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIdentityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIdentityDocumentMutation, { data, loading, error }] = useUploadIdentityDocumentMutation({
 *   variables: {
 *      naturalPersonId: // value for 'naturalPersonId'
 *      type: // value for 'type'
 *      expiryDate: // value for 'expiryDate'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadIdentityDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadIdentityDocumentMutation,
    UploadIdentityDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadIdentityDocumentMutation,
    UploadIdentityDocumentMutationVariables
  >(UploadIdentityDocumentDocument, options);
}
export type UploadIdentityDocumentMutationHookResult = ReturnType<
  typeof useUploadIdentityDocumentMutation
>;
export type UploadIdentityDocumentMutationResult =
  Apollo.MutationResult<UploadIdentityDocumentMutation>;
export type UploadIdentityDocumentMutationOptions = Apollo.BaseMutationOptions<
  UploadIdentityDocumentMutation,
  UploadIdentityDocumentMutationVariables
>;
export const RequestIdentityDocumentDownloadDocument = gql`
  mutation RequestIdentityDocumentDownload($naturalPersonId: ID!, $reason: String!) {
    requestIdentityDocumentDownload(naturalPersonId: $naturalPersonId, reason: $reason)
  }
`;
export type RequestIdentityDocumentDownloadMutationFn = Apollo.MutationFunction<
  RequestIdentityDocumentDownloadMutation,
  RequestIdentityDocumentDownloadMutationVariables
>;

/**
 * __useRequestIdentityDocumentDownloadMutation__
 *
 * To run a mutation, you first call `useRequestIdentityDocumentDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIdentityDocumentDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIdentityDocumentDownloadMutation, { data, loading, error }] = useRequestIdentityDocumentDownloadMutation({
 *   variables: {
 *      naturalPersonId: // value for 'naturalPersonId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestIdentityDocumentDownloadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestIdentityDocumentDownloadMutation,
    RequestIdentityDocumentDownloadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestIdentityDocumentDownloadMutation,
    RequestIdentityDocumentDownloadMutationVariables
  >(RequestIdentityDocumentDownloadDocument, options);
}
export type RequestIdentityDocumentDownloadMutationHookResult = ReturnType<
  typeof useRequestIdentityDocumentDownloadMutation
>;
export type RequestIdentityDocumentDownloadMutationResult =
  Apollo.MutationResult<RequestIdentityDocumentDownloadMutation>;
export type RequestIdentityDocumentDownloadMutationOptions = Apollo.BaseMutationOptions<
  RequestIdentityDocumentDownloadMutation,
  RequestIdentityDocumentDownloadMutationVariables
>;
export const InvitationsDocument = gql`
  query Invitations($registerId: ID!) {
    invitations(registerId: $registerId) {
      ...InvitationFields
    }
  }
  ${InvitationFieldsFragmentDoc}
`;

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<InvitationsQuery, InvitationsQueryVariables> &
    ({ variables: InvitationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(InvitationsDocument, options);
}
export function useInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options,
  );
}
// @ts-ignore
export function useInvitationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<InvitationsQuery, InvitationsQueryVariables>;
export function useInvitationsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<InvitationsQuery | undefined, InvitationsQueryVariables>;
export function useInvitationsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvitationsQuery, InvitationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options,
  );
}
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>;
export type InvitationsLazyQueryHookResult = ReturnType<typeof useInvitationsLazyQuery>;
export type InvitationsSuspenseQueryHookResult = ReturnType<typeof useInvitationsSuspenseQuery>;
export type InvitationsQueryResult = Apollo.QueryResult<
  InvitationsQuery,
  InvitationsQueryVariables
>;
export const RevokeInvitationDocument = gql`
  mutation RevokeInvitation($invitationId: ID!) {
    revokeInvitation(invitationId: $invitationId) {
      ...InvitationFields
    }
  }
  ${InvitationFieldsFragmentDoc}
`;
export type RevokeInvitationMutationFn = Apollo.MutationFunction<
  RevokeInvitationMutation,
  RevokeInvitationMutationVariables
>;

/**
 * __useRevokeInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeInvitationMutation, { data, loading, error }] = useRevokeInvitationMutation({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useRevokeInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeInvitationMutation,
    RevokeInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RevokeInvitationMutation, RevokeInvitationMutationVariables>(
    RevokeInvitationDocument,
    options,
  );
}
export type RevokeInvitationMutationHookResult = ReturnType<typeof useRevokeInvitationMutation>;
export type RevokeInvitationMutationResult = Apollo.MutationResult<RevokeInvitationMutation>;
export type RevokeInvitationMutationOptions = Apollo.BaseMutationOptions<
  RevokeInvitationMutation,
  RevokeInvitationMutationVariables
>;
export const LegalEntityDocument = gql`
  query LegalEntity($legalEntityId: ID!) {
    legalEntity(legalEntityId: $legalEntityId) {
      id
      ...LegalEntityFields
      lastFetchedFromKvkOn
      phoneNumber
      emailAddress
      register {
        ...RegisterFields
      }
      entitlement
      partyUpdates {
        ...PartyUpdateFields
      }
    }
  }
  ${LegalEntityFieldsFragmentDoc}
  ${RegisterFieldsFragmentDoc}
  ${PartyUpdateFieldsFragmentDoc}
`;

/**
 * __useLegalEntityQuery__
 *
 * To run a query within a React component, call `useLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalEntityQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useLegalEntityQuery(
  baseOptions: Apollo.QueryHookOptions<LegalEntityQuery, LegalEntityQueryVariables> &
    ({ variables: LegalEntityQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LegalEntityQuery, LegalEntityQueryVariables>(LegalEntityDocument, options);
}
export function useLegalEntityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LegalEntityQuery, LegalEntityQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LegalEntityQuery, LegalEntityQueryVariables>(
    LegalEntityDocument,
    options,
  );
}
// @ts-ignore
export function useLegalEntitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LegalEntityQuery, LegalEntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<LegalEntityQuery, LegalEntityQueryVariables>;
export function useLegalEntitySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalEntityQuery, LegalEntityQueryVariables>,
): Apollo.UseSuspenseQueryResult<LegalEntityQuery | undefined, LegalEntityQueryVariables>;
export function useLegalEntitySuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LegalEntityQuery, LegalEntityQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LegalEntityQuery, LegalEntityQueryVariables>(
    LegalEntityDocument,
    options,
  );
}
export type LegalEntityQueryHookResult = ReturnType<typeof useLegalEntityQuery>;
export type LegalEntityLazyQueryHookResult = ReturnType<typeof useLegalEntityLazyQuery>;
export type LegalEntitySuspenseQueryHookResult = ReturnType<typeof useLegalEntitySuspenseQuery>;
export type LegalEntityQueryResult = Apollo.QueryResult<
  LegalEntityQuery,
  LegalEntityQueryVariables
>;
export const LegalEntityDirectorsDocument = gql`
  query LegalEntityDirectors($legalEntityId: ID!, $status: DirectorStatusFilter) {
    legalEntity(legalEntityId: $legalEntityId) {
      id
      directors(status: $status) {
        id
        title
        authority
        representationAuthority
        status
        appointedOn
        endedOn
        director {
          id
          type
          naturalPerson {
            name {
              firstName
              initials
              nickname
              preposition
              lastName
            }
          }
          legalEntity {
            name
          }
        }
      }
    }
  }
`;

/**
 * __useLegalEntityDirectorsQuery__
 *
 * To run a query within a React component, call `useLegalEntityDirectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntityDirectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalEntityDirectorsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useLegalEntityDirectorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    LegalEntityDirectorsQuery,
    LegalEntityDirectorsQueryVariables
  > &
    ({ variables: LegalEntityDirectorsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LegalEntityDirectorsQuery, LegalEntityDirectorsQueryVariables>(
    LegalEntityDirectorsDocument,
    options,
  );
}
export function useLegalEntityDirectorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LegalEntityDirectorsQuery,
    LegalEntityDirectorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LegalEntityDirectorsQuery, LegalEntityDirectorsQueryVariables>(
    LegalEntityDirectorsDocument,
    options,
  );
}
// @ts-ignore
export function useLegalEntityDirectorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LegalEntityDirectorsQuery,
    LegalEntityDirectorsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LegalEntityDirectorsQuery, LegalEntityDirectorsQueryVariables>;
export function useLegalEntityDirectorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LegalEntityDirectorsQuery,
        LegalEntityDirectorsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LegalEntityDirectorsQuery | undefined,
  LegalEntityDirectorsQueryVariables
>;
export function useLegalEntityDirectorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LegalEntityDirectorsQuery,
        LegalEntityDirectorsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LegalEntityDirectorsQuery, LegalEntityDirectorsQueryVariables>(
    LegalEntityDirectorsDocument,
    options,
  );
}
export type LegalEntityDirectorsQueryHookResult = ReturnType<typeof useLegalEntityDirectorsQuery>;
export type LegalEntityDirectorsLazyQueryHookResult = ReturnType<
  typeof useLegalEntityDirectorsLazyQuery
>;
export type LegalEntityDirectorsSuspenseQueryHookResult = ReturnType<
  typeof useLegalEntityDirectorsSuspenseQuery
>;
export type LegalEntityDirectorsQueryResult = Apollo.QueryResult<
  LegalEntityDirectorsQuery,
  LegalEntityDirectorsQueryVariables
>;
export const LegalEntityUbosDocument = gql`
  query LegalEntityUbos($legalEntityId: ID!) {
    legalEntity(legalEntityId: $legalEntityId) {
      id
      ubos {
        ground
        ownershipRange
        naturalPerson {
          id
          type
          naturalPerson {
            name {
              firstName
              initials
              nickname
              preposition
              lastName
            }
          }
        }
      }
    }
  }
`;

/**
 * __useLegalEntityUbosQuery__
 *
 * To run a query within a React component, call `useLegalEntityUbosQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalEntityUbosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalEntityUbosQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useLegalEntityUbosQuery(
  baseOptions: Apollo.QueryHookOptions<LegalEntityUbosQuery, LegalEntityUbosQueryVariables> &
    ({ variables: LegalEntityUbosQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>(
    LegalEntityUbosDocument,
    options,
  );
}
export function useLegalEntityUbosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>(
    LegalEntityUbosDocument,
    options,
  );
}
// @ts-ignore
export function useLegalEntityUbosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LegalEntityUbosQuery,
    LegalEntityUbosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>;
export function useLegalEntityUbosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>,
): Apollo.UseSuspenseQueryResult<LegalEntityUbosQuery | undefined, LegalEntityUbosQueryVariables>;
export function useLegalEntityUbosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LegalEntityUbosQuery, LegalEntityUbosQueryVariables>(
    LegalEntityUbosDocument,
    options,
  );
}
export type LegalEntityUbosQueryHookResult = ReturnType<typeof useLegalEntityUbosQuery>;
export type LegalEntityUbosLazyQueryHookResult = ReturnType<typeof useLegalEntityUbosLazyQuery>;
export type LegalEntityUbosSuspenseQueryHookResult = ReturnType<
  typeof useLegalEntityUbosSuspenseQuery
>;
export type LegalEntityUbosQueryResult = Apollo.QueryResult<
  LegalEntityUbosQuery,
  LegalEntityUbosQueryVariables
>;
export const KvkLookupDocument = gql`
  query KvkLookup($kvkNumber: String!) {
    kvkLookup(kvkNumber: $kvkNumber) {
      id
      ...LegalEntityFields
      lastFetchedFromKvkOn
    }
  }
  ${LegalEntityFieldsFragmentDoc}
`;

/**
 * __useKvkLookupQuery__
 *
 * To run a query within a React component, call `useKvkLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useKvkLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKvkLookupQuery({
 *   variables: {
 *      kvkNumber: // value for 'kvkNumber'
 *   },
 * });
 */
export function useKvkLookupQuery(
  baseOptions: Apollo.QueryHookOptions<KvkLookupQuery, KvkLookupQueryVariables> &
    ({ variables: KvkLookupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<KvkLookupQuery, KvkLookupQueryVariables>(KvkLookupDocument, options);
}
export function useKvkLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KvkLookupQuery, KvkLookupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<KvkLookupQuery, KvkLookupQueryVariables>(KvkLookupDocument, options);
}
// @ts-ignore
export function useKvkLookupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<KvkLookupQuery, KvkLookupQueryVariables>,
): Apollo.UseSuspenseQueryResult<KvkLookupQuery, KvkLookupQueryVariables>;
export function useKvkLookupSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KvkLookupQuery, KvkLookupQueryVariables>,
): Apollo.UseSuspenseQueryResult<KvkLookupQuery | undefined, KvkLookupQueryVariables>;
export function useKvkLookupSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KvkLookupQuery, KvkLookupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<KvkLookupQuery, KvkLookupQueryVariables>(
    KvkLookupDocument,
    options,
  );
}
export type KvkLookupQueryHookResult = ReturnType<typeof useKvkLookupQuery>;
export type KvkLookupLazyQueryHookResult = ReturnType<typeof useKvkLookupLazyQuery>;
export type KvkLookupSuspenseQueryHookResult = ReturnType<typeof useKvkLookupSuspenseQuery>;
export type KvkLookupQueryResult = Apollo.QueryResult<KvkLookupQuery, KvkLookupQueryVariables>;
export const ShareholderGraphDocument = gql`
  query ShareholderGraph(
    $legalEntityId: ID!
    $groupBy: ShareholderGraphGroupBy!
    $shareholderGraphType: ShareholderGraphType
  ) {
    shareholderGraph(
      legalEntityId: $legalEntityId
      groupBy: $groupBy
      shareholderGraphType: $shareholderGraphType
    ) {
      nodes {
        party {
          ...PartyFields
        }
      }
      edges {
        from {
          id
          type
        }
        to {
          id
          type
        }
        quantity
        percentage
        effectiveIn {
          id
          name
        }
      }
    }
  }
  ${PartyFieldsFragmentDoc}
`;

/**
 * __useShareholderGraphQuery__
 *
 * To run a query within a React component, call `useShareholderGraphQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareholderGraphQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareholderGraphQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      groupBy: // value for 'groupBy'
 *      shareholderGraphType: // value for 'shareholderGraphType'
 *   },
 * });
 */
export function useShareholderGraphQuery(
  baseOptions: Apollo.QueryHookOptions<ShareholderGraphQuery, ShareholderGraphQueryVariables> &
    ({ variables: ShareholderGraphQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShareholderGraphQuery, ShareholderGraphQueryVariables>(
    ShareholderGraphDocument,
    options,
  );
}
export function useShareholderGraphLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShareholderGraphQuery, ShareholderGraphQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShareholderGraphQuery, ShareholderGraphQueryVariables>(
    ShareholderGraphDocument,
    options,
  );
}
// @ts-ignore
export function useShareholderGraphSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShareholderGraphQuery,
    ShareholderGraphQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ShareholderGraphQuery, ShareholderGraphQueryVariables>;
export function useShareholderGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShareholderGraphQuery, ShareholderGraphQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShareholderGraphQuery | undefined, ShareholderGraphQueryVariables>;
export function useShareholderGraphSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShareholderGraphQuery, ShareholderGraphQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShareholderGraphQuery, ShareholderGraphQueryVariables>(
    ShareholderGraphDocument,
    options,
  );
}
export type ShareholderGraphQueryHookResult = ReturnType<typeof useShareholderGraphQuery>;
export type ShareholderGraphLazyQueryHookResult = ReturnType<typeof useShareholderGraphLazyQuery>;
export type ShareholderGraphSuspenseQueryHookResult = ReturnType<
  typeof useShareholderGraphSuspenseQuery
>;
export type ShareholderGraphQueryResult = Apollo.QueryResult<
  ShareholderGraphQuery,
  ShareholderGraphQueryVariables
>;
export const CreateLegalEntityDocument = gql`
  mutation CreateLegalEntity($registerId: ID, $legalEntity: LegalEntityInput!) {
    createLegalEntity(registerId: $registerId, legalEntity: $legalEntity) {
      id
      ...LegalEntityFields
      phoneNumber
      emailAddress
    }
  }
  ${LegalEntityFieldsFragmentDoc}
`;
export type CreateLegalEntityMutationFn = Apollo.MutationFunction<
  CreateLegalEntityMutation,
  CreateLegalEntityMutationVariables
>;

/**
 * __useCreateLegalEntityMutation__
 *
 * To run a mutation, you first call `useCreateLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegalEntityMutation, { data, loading, error }] = useCreateLegalEntityMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      legalEntity: // value for 'legalEntity'
 *   },
 * });
 */
export function useCreateLegalEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLegalEntityMutation,
    CreateLegalEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLegalEntityMutation, CreateLegalEntityMutationVariables>(
    CreateLegalEntityDocument,
    options,
  );
}
export type CreateLegalEntityMutationHookResult = ReturnType<typeof useCreateLegalEntityMutation>;
export type CreateLegalEntityMutationResult = Apollo.MutationResult<CreateLegalEntityMutation>;
export type CreateLegalEntityMutationOptions = Apollo.BaseMutationOptions<
  CreateLegalEntityMutation,
  CreateLegalEntityMutationVariables
>;
export const UpdateLegalEntityDocument = gql`
  mutation UpdateLegalEntity(
    $legalEntityId: ID!
    $legalEntity: LegalEntityInput!
    $effectiveDate: Date
    $reason: String
  ) {
    updateLegalEntity(
      legalEntityId: $legalEntityId
      legalEntity: $legalEntity
      effectiveDate: $effectiveDate
      reason: $reason
    ) {
      id
      ...LegalEntityFields
      phoneNumber
      emailAddress
    }
  }
  ${LegalEntityFieldsFragmentDoc}
`;
export type UpdateLegalEntityMutationFn = Apollo.MutationFunction<
  UpdateLegalEntityMutation,
  UpdateLegalEntityMutationVariables
>;

/**
 * __useUpdateLegalEntityMutation__
 *
 * To run a mutation, you first call `useUpdateLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalEntityMutation, { data, loading, error }] = useUpdateLegalEntityMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      legalEntity: // value for 'legalEntity'
 *      effectiveDate: // value for 'effectiveDate'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateLegalEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLegalEntityMutation,
    UpdateLegalEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLegalEntityMutation, UpdateLegalEntityMutationVariables>(
    UpdateLegalEntityDocument,
    options,
  );
}
export type UpdateLegalEntityMutationHookResult = ReturnType<typeof useUpdateLegalEntityMutation>;
export type UpdateLegalEntityMutationResult = Apollo.MutationResult<UpdateLegalEntityMutation>;
export type UpdateLegalEntityMutationOptions = Apollo.BaseMutationOptions<
  UpdateLegalEntityMutation,
  UpdateLegalEntityMutationVariables
>;
export const AddKvkNumberToLegalEntityDocument = gql`
  mutation AddKvkNumberToLegalEntity($legalEntityId: ID!, $kvkNumber: String!) {
    addKvkNumberToLegalEntity(legalEntityId: $legalEntityId, kvkNumber: $kvkNumber) {
      id
      ...LegalEntityFields
      lastFetchedFromKvkOn
    }
  }
  ${LegalEntityFieldsFragmentDoc}
`;
export type AddKvkNumberToLegalEntityMutationFn = Apollo.MutationFunction<
  AddKvkNumberToLegalEntityMutation,
  AddKvkNumberToLegalEntityMutationVariables
>;

/**
 * __useAddKvkNumberToLegalEntityMutation__
 *
 * To run a mutation, you first call `useAddKvkNumberToLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKvkNumberToLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKvkNumberToLegalEntityMutation, { data, loading, error }] = useAddKvkNumberToLegalEntityMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      kvkNumber: // value for 'kvkNumber'
 *   },
 * });
 */
export function useAddKvkNumberToLegalEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddKvkNumberToLegalEntityMutation,
    AddKvkNumberToLegalEntityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddKvkNumberToLegalEntityMutation,
    AddKvkNumberToLegalEntityMutationVariables
  >(AddKvkNumberToLegalEntityDocument, options);
}
export type AddKvkNumberToLegalEntityMutationHookResult = ReturnType<
  typeof useAddKvkNumberToLegalEntityMutation
>;
export type AddKvkNumberToLegalEntityMutationResult =
  Apollo.MutationResult<AddKvkNumberToLegalEntityMutation>;
export type AddKvkNumberToLegalEntityMutationOptions = Apollo.BaseMutationOptions<
  AddKvkNumberToLegalEntityMutation,
  AddKvkNumberToLegalEntityMutationVariables
>;
export const AddLegalEntityToRegisterDocument = gql`
  mutation AddLegalEntityToRegister($legalEntityId: ID!, $registerId: ID!) {
    addLegalEntityToRegister(legalEntityId: $legalEntityId, registerId: $registerId) {
      id
      ...LegalEntityFields
    }
  }
  ${LegalEntityFieldsFragmentDoc}
`;
export type AddLegalEntityToRegisterMutationFn = Apollo.MutationFunction<
  AddLegalEntityToRegisterMutation,
  AddLegalEntityToRegisterMutationVariables
>;

/**
 * __useAddLegalEntityToRegisterMutation__
 *
 * To run a mutation, you first call `useAddLegalEntityToRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLegalEntityToRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLegalEntityToRegisterMutation, { data, loading, error }] = useAddLegalEntityToRegisterMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useAddLegalEntityToRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLegalEntityToRegisterMutation,
    AddLegalEntityToRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddLegalEntityToRegisterMutation,
    AddLegalEntityToRegisterMutationVariables
  >(AddLegalEntityToRegisterDocument, options);
}
export type AddLegalEntityToRegisterMutationHookResult = ReturnType<
  typeof useAddLegalEntityToRegisterMutation
>;
export type AddLegalEntityToRegisterMutationResult =
  Apollo.MutationResult<AddLegalEntityToRegisterMutation>;
export type AddLegalEntityToRegisterMutationOptions = Apollo.BaseMutationOptions<
  AddLegalEntityToRegisterMutation,
  AddLegalEntityToRegisterMutationVariables
>;
export const UsersDocument = gql`
  query Users {
    users {
      ...ManagementUserFields
    }
  }
  ${ManagementUserFieldsFragmentDoc}
`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export function useUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
// @ts-ignore
export function useUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UsersByGroupDocument = gql`
  query UsersByGroup($groupId: ID!) {
    users(groupId: $groupId) {
      ...ManagementUserFields
    }
  }
  ${ManagementUserFieldsFragmentDoc}
`;

/**
 * __useUsersByGroupQuery__
 *
 * To run a query within a React component, call `useUsersByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersByGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useUsersByGroupQuery(
  baseOptions: Apollo.QueryHookOptions<UsersByGroupQuery, UsersByGroupQueryVariables> &
    ({ variables: UsersByGroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsersByGroupQuery, UsersByGroupQueryVariables>(
    UsersByGroupDocument,
    options,
  );
}
export function useUsersByGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UsersByGroupQuery, UsersByGroupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsersByGroupQuery, UsersByGroupQueryVariables>(
    UsersByGroupDocument,
    options,
  );
}
// @ts-ignore
export function useUsersByGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<UsersByGroupQuery, UsersByGroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsersByGroupQuery, UsersByGroupQueryVariables>;
export function useUsersByGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersByGroupQuery, UsersByGroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<UsersByGroupQuery | undefined, UsersByGroupQueryVariables>;
export function useUsersByGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<UsersByGroupQuery, UsersByGroupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<UsersByGroupQuery, UsersByGroupQueryVariables>(
    UsersByGroupDocument,
    options,
  );
}
export type UsersByGroupQueryHookResult = ReturnType<typeof useUsersByGroupQuery>;
export type UsersByGroupLazyQueryHookResult = ReturnType<typeof useUsersByGroupLazyQuery>;
export type UsersByGroupSuspenseQueryHookResult = ReturnType<typeof useUsersByGroupSuspenseQuery>;
export type UsersByGroupQueryResult = Apollo.QueryResult<
  UsersByGroupQuery,
  UsersByGroupQueryVariables
>;
export const GroupsDocument = gql`
  query Groups {
    groups {
      ...ManagementGroupFields
    }
  }
  ${ManagementGroupFieldsFragmentDoc}
`;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
}
export function useGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
}
// @ts-ignore
export function useGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupsQuery, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupsQuery | undefined, GroupsQueryVariables>;
export function useGroupsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery, GroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupsQuery, GroupsQueryVariables>(GroupsDocument, options);
}
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQueryHookResult = ReturnType<typeof useGroupsLazyQuery>;
export type GroupsSuspenseQueryHookResult = ReturnType<typeof useGroupsSuspenseQuery>;
export type GroupsQueryResult = Apollo.QueryResult<GroupsQuery, GroupsQueryVariables>;
export const GroupDocument = gql`
  query Group($groupId: ID!) {
    group(groupId: $groupId) {
      ...ManagementGroupFields
    }
  }
  ${ManagementGroupFieldsFragmentDoc}
`;

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> &
    ({ variables: GroupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
}
export function useGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
}
// @ts-ignore
export function useGroupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupQuery, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupQuery | undefined, GroupQueryVariables>;
export function useGroupSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(GroupDocument, options);
}
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>;
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>;
export type GroupSuspenseQueryHookResult = ReturnType<typeof useGroupSuspenseQuery>;
export type GroupQueryResult = Apollo.QueryResult<GroupQuery, GroupQueryVariables>;
export const MutationSummaryDocument = gql`
  query MutationSummary($groupId: ID) {
    mutationSummary(groupId: $groupId) {
      mutation {
        ...MutationFields
        register {
          legalEntity {
            name
          }
        }
      }
      group {
        id
        name
        logo
      }
    }
  }
  ${MutationFieldsFragmentDoc}
`;

/**
 * __useMutationSummaryQuery__
 *
 * To run a query within a React component, call `useMutationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutationSummaryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useMutationSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<MutationSummaryQuery, MutationSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MutationSummaryQuery, MutationSummaryQueryVariables>(
    MutationSummaryDocument,
    options,
  );
}
export function useMutationSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MutationSummaryQuery, MutationSummaryQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MutationSummaryQuery, MutationSummaryQueryVariables>(
    MutationSummaryDocument,
    options,
  );
}
// @ts-ignore
export function useMutationSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MutationSummaryQuery,
    MutationSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<MutationSummaryQuery, MutationSummaryQueryVariables>;
export function useMutationSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MutationSummaryQuery, MutationSummaryQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationSummaryQuery | undefined, MutationSummaryQueryVariables>;
export function useMutationSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MutationSummaryQuery, MutationSummaryQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MutationSummaryQuery, MutationSummaryQueryVariables>(
    MutationSummaryDocument,
    options,
  );
}
export type MutationSummaryQueryHookResult = ReturnType<typeof useMutationSummaryQuery>;
export type MutationSummaryLazyQueryHookResult = ReturnType<typeof useMutationSummaryLazyQuery>;
export type MutationSummarySuspenseQueryHookResult = ReturnType<
  typeof useMutationSummarySuspenseQuery
>;
export type MutationSummaryQueryResult = Apollo.QueryResult<
  MutationSummaryQuery,
  MutationSummaryQueryVariables
>;
export const CreateGroupDocument = gql`
  mutation CreateGroup($group: GroupInput!) {
    createGroup(group: $group) {
      ...ManagementGroupFields
    }
  }
  ${ManagementGroupFieldsFragmentDoc}
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      group: // value for 'group'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options,
  );
}
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const UpdateGroupDocument = gql`
  mutation UpdateGroup($groupId: ID!, $group: GroupInput!) {
    updateGroup(groupId: $groupId, group: $group) {
      ...ManagementGroupFields
    }
  }
  ${ManagementGroupFieldsFragmentDoc}
`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useUpdateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(
    UpdateGroupDocument,
    options,
  );
}
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateGroupMutation,
  UpdateGroupMutationVariables
>;
export const UploadGroupLogoDocument = gql`
  mutation UploadGroupLogo($groupId: ID!, $logo: String!) {
    uploadGroupLogo(groupId: $groupId, logo: $logo) {
      id
      logo
    }
  }
`;
export type UploadGroupLogoMutationFn = Apollo.MutationFunction<
  UploadGroupLogoMutation,
  UploadGroupLogoMutationVariables
>;

/**
 * __useUploadGroupLogoMutation__
 *
 * To run a mutation, you first call `useUploadGroupLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGroupLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGroupLogoMutation, { data, loading, error }] = useUploadGroupLogoMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useUploadGroupLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadGroupLogoMutation,
    UploadGroupLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadGroupLogoMutation, UploadGroupLogoMutationVariables>(
    UploadGroupLogoDocument,
    options,
  );
}
export type UploadGroupLogoMutationHookResult = ReturnType<typeof useUploadGroupLogoMutation>;
export type UploadGroupLogoMutationResult = Apollo.MutationResult<UploadGroupLogoMutation>;
export type UploadGroupLogoMutationOptions = Apollo.BaseMutationOptions<
  UploadGroupLogoMutation,
  UploadGroupLogoMutationVariables
>;
export const DeleteGroupLogoDocument = gql`
  mutation DeleteGroupLogo($groupId: ID!) {
    deleteGroupLogo(groupId: $groupId) {
      id
      logo
    }
  }
`;
export type DeleteGroupLogoMutationFn = Apollo.MutationFunction<
  DeleteGroupLogoMutation,
  DeleteGroupLogoMutationVariables
>;

/**
 * __useDeleteGroupLogoMutation__
 *
 * To run a mutation, you first call `useDeleteGroupLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupLogoMutation, { data, loading, error }] = useDeleteGroupLogoMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupLogoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteGroupLogoMutation,
    DeleteGroupLogoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteGroupLogoMutation, DeleteGroupLogoMutationVariables>(
    DeleteGroupLogoDocument,
    options,
  );
}
export type DeleteGroupLogoMutationHookResult = ReturnType<typeof useDeleteGroupLogoMutation>;
export type DeleteGroupLogoMutationResult = Apollo.MutationResult<DeleteGroupLogoMutation>;
export type DeleteGroupLogoMutationOptions = Apollo.BaseMutationOptions<
  DeleteGroupLogoMutation,
  DeleteGroupLogoMutationVariables
>;
export const CreateUserDocument = gql`
  mutation CreateUser($user: UserInput!) {
    createUser(user: $user) {
      ...ManagementUserFields
    }
  }
  ${ManagementUserFieldsFragmentDoc}
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($userId: ID!, $user: UserInput!) {
    updateUser(userId: $userId, user: $user) {
      ...ManagementUserFields
    }
  }
  ${ManagementUserFieldsFragmentDoc}
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options,
  );
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId)
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options,
  );
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const JsonRegisterDocument = gql`
  query JsonRegister($registerId: ID!) {
    jsonRegister(registerId: $registerId)
  }
`;

/**
 * __useJsonRegisterQuery__
 *
 * To run a query within a React component, call `useJsonRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useJsonRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJsonRegisterQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useJsonRegisterQuery(
  baseOptions: Apollo.QueryHookOptions<JsonRegisterQuery, JsonRegisterQueryVariables> &
    ({ variables: JsonRegisterQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<JsonRegisterQuery, JsonRegisterQueryVariables>(
    JsonRegisterDocument,
    options,
  );
}
export function useJsonRegisterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<JsonRegisterQuery, JsonRegisterQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<JsonRegisterQuery, JsonRegisterQueryVariables>(
    JsonRegisterDocument,
    options,
  );
}
// @ts-ignore
export function useJsonRegisterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<JsonRegisterQuery, JsonRegisterQueryVariables>,
): Apollo.UseSuspenseQueryResult<JsonRegisterQuery, JsonRegisterQueryVariables>;
export function useJsonRegisterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JsonRegisterQuery, JsonRegisterQueryVariables>,
): Apollo.UseSuspenseQueryResult<JsonRegisterQuery | undefined, JsonRegisterQueryVariables>;
export function useJsonRegisterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<JsonRegisterQuery, JsonRegisterQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<JsonRegisterQuery, JsonRegisterQueryVariables>(
    JsonRegisterDocument,
    options,
  );
}
export type JsonRegisterQueryHookResult = ReturnType<typeof useJsonRegisterQuery>;
export type JsonRegisterLazyQueryHookResult = ReturnType<typeof useJsonRegisterLazyQuery>;
export type JsonRegisterSuspenseQueryHookResult = ReturnType<typeof useJsonRegisterSuspenseQuery>;
export type JsonRegisterQueryResult = Apollo.QueryResult<
  JsonRegisterQuery,
  JsonRegisterQueryVariables
>;
export const DeleteRegisterDocument = gql`
  mutation DeleteRegister($registerId: ID!) {
    deleteRegister(registerId: $registerId)
  }
`;
export type DeleteRegisterMutationFn = Apollo.MutationFunction<
  DeleteRegisterMutation,
  DeleteRegisterMutationVariables
>;

/**
 * __useDeleteRegisterMutation__
 *
 * To run a mutation, you first call `useDeleteRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegisterMutation, { data, loading, error }] = useDeleteRegisterMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useDeleteRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRegisterMutation, DeleteRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRegisterMutation, DeleteRegisterMutationVariables>(
    DeleteRegisterDocument,
    options,
  );
}
export type DeleteRegisterMutationHookResult = ReturnType<typeof useDeleteRegisterMutation>;
export type DeleteRegisterMutationResult = Apollo.MutationResult<DeleteRegisterMutation>;
export type DeleteRegisterMutationOptions = Apollo.BaseMutationOptions<
  DeleteRegisterMutation,
  DeleteRegisterMutationVariables
>;
export const DeepDeleteRegisterDocument = gql`
  mutation DeepDeleteRegister($registerId: ID!) {
    deepDeleteRegister(registerId: $registerId)
  }
`;
export type DeepDeleteRegisterMutationFn = Apollo.MutationFunction<
  DeepDeleteRegisterMutation,
  DeepDeleteRegisterMutationVariables
>;

/**
 * __useDeepDeleteRegisterMutation__
 *
 * To run a mutation, you first call `useDeepDeleteRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeepDeleteRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deepDeleteRegisterMutation, { data, loading, error }] = useDeepDeleteRegisterMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useDeepDeleteRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeepDeleteRegisterMutation,
    DeepDeleteRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeepDeleteRegisterMutation, DeepDeleteRegisterMutationVariables>(
    DeepDeleteRegisterDocument,
    options,
  );
}
export type DeepDeleteRegisterMutationHookResult = ReturnType<typeof useDeepDeleteRegisterMutation>;
export type DeepDeleteRegisterMutationResult = Apollo.MutationResult<DeepDeleteRegisterMutation>;
export type DeepDeleteRegisterMutationOptions = Apollo.BaseMutationOptions<
  DeepDeleteRegisterMutation,
  DeepDeleteRegisterMutationVariables
>;
export const SaveJsonRegisterDocument = gql`
  mutation SaveJsonRegister($registerJson: String!) {
    saveJsonRegister(registerJson: $registerJson) {
      register {
        id
      }
    }
  }
`;
export type SaveJsonRegisterMutationFn = Apollo.MutationFunction<
  SaveJsonRegisterMutation,
  SaveJsonRegisterMutationVariables
>;

/**
 * __useSaveJsonRegisterMutation__
 *
 * To run a mutation, you first call `useSaveJsonRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJsonRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJsonRegisterMutation, { data, loading, error }] = useSaveJsonRegisterMutation({
 *   variables: {
 *      registerJson: // value for 'registerJson'
 *   },
 * });
 */
export function useSaveJsonRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveJsonRegisterMutation,
    SaveJsonRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveJsonRegisterMutation, SaveJsonRegisterMutationVariables>(
    SaveJsonRegisterDocument,
    options,
  );
}
export type SaveJsonRegisterMutationHookResult = ReturnType<typeof useSaveJsonRegisterMutation>;
export type SaveJsonRegisterMutationResult = Apollo.MutationResult<SaveJsonRegisterMutation>;
export type SaveJsonRegisterMutationOptions = Apollo.BaseMutationOptions<
  SaveJsonRegisterMutation,
  SaveJsonRegisterMutationVariables
>;
export const MutationDocument = gql`
  query Mutation($mutationId: ID!) {
    mutation(mutationId: $mutationId) {
      ...MutationWithDocumentFields
      register {
        ...RegisterFields
      }
    }
  }
  ${MutationWithDocumentFieldsFragmentDoc}
  ${RegisterFieldsFragmentDoc}
`;

/**
 * __useMutationQuery__
 *
 * To run a query within a React component, call `useMutationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutationQuery({
 *   variables: {
 *      mutationId: // value for 'mutationId'
 *   },
 * });
 */
export function useMutationQuery(
  baseOptions: Apollo.QueryHookOptions<MutationQuery, MutationQueryVariables> &
    ({ variables: MutationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MutationQuery, MutationQueryVariables>(MutationDocument, options);
}
export function useMutationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MutationQuery, MutationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MutationQuery, MutationQueryVariables>(MutationDocument, options);
}
// @ts-ignore
export function useMutationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MutationQuery, MutationQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationQuery, MutationQueryVariables>;
export function useMutationSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutationQuery, MutationQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationQuery | undefined, MutationQueryVariables>;
export function useMutationSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutationQuery, MutationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MutationQuery, MutationQueryVariables>(MutationDocument, options);
}
export type MutationQueryHookResult = ReturnType<typeof useMutationQuery>;
export type MutationLazyQueryHookResult = ReturnType<typeof useMutationLazyQuery>;
export type MutationSuspenseQueryHookResult = ReturnType<typeof useMutationSuspenseQuery>;
export type MutationQueryResult = Apollo.QueryResult<MutationQuery, MutationQueryVariables>;
export const MutationsDocument = gql`
  query Mutations($filter: MutationFilterInput, $pagination: PaginationInput!) {
    mutations(filter: $filter, pagination: $pagination) {
      items {
        ...MutationFields
        register {
          legalEntity {
            id
            name
          }
        }
      }
      pagination {
        totalCount
      }
    }
  }
  ${MutationFieldsFragmentDoc}
`;

/**
 * __useMutationsQuery__
 *
 * To run a query within a React component, call `useMutationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMutationsQuery(
  baseOptions: Apollo.QueryHookOptions<MutationsQuery, MutationsQueryVariables> &
    ({ variables: MutationsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MutationsQuery, MutationsQueryVariables>(MutationsDocument, options);
}
export function useMutationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MutationsQuery, MutationsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MutationsQuery, MutationsQueryVariables>(MutationsDocument, options);
}
// @ts-ignore
export function useMutationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MutationsQuery, MutationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationsQuery, MutationsQueryVariables>;
export function useMutationsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutationsQuery, MutationsQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationsQuery | undefined, MutationsQueryVariables>;
export function useMutationsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MutationsQuery, MutationsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MutationsQuery, MutationsQueryVariables>(
    MutationsDocument,
    options,
  );
}
export type MutationsQueryHookResult = ReturnType<typeof useMutationsQuery>;
export type MutationsLazyQueryHookResult = ReturnType<typeof useMutationsLazyQuery>;
export type MutationsSuspenseQueryHookResult = ReturnType<typeof useMutationsSuspenseQuery>;
export type MutationsQueryResult = Apollo.QueryResult<MutationsQuery, MutationsQueryVariables>;
export const CreateDocument = gql`
  mutation Create(
    $legalEntityId: ID!
    $mutationType: MutationType!
    $mutation: RegisterMutationInput
  ) {
    createMutation(
      legalEntityId: $legalEntityId
      mutationType: $mutationType
      mutation: $mutation
    ) {
      ...MutationWithDocumentFields
      register {
        ...RegisterFields
      }
      validationErrors {
        ...ValidationErrorsFields
      }
    }
  }
  ${MutationWithDocumentFieldsFragmentDoc}
  ${RegisterFieldsFragmentDoc}
  ${ValidationErrorsFieldsFragmentDoc}
`;
export type CreateMutationFn = Apollo.MutationFunction<CreateMutation, CreateMutationVariables>;

/**
 * __useCreateMutation__
 *
 * To run a mutation, you first call `useCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMutation, { data, loading, error }] = useCreateMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      mutationType: // value for 'mutationType'
 *      mutation: // value for 'mutation'
 *   },
 * });
 */
export function useCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateMutation, CreateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateMutation, CreateMutationVariables>(CreateDocument, options);
}
export type CreateMutationHookResult = ReturnType<typeof useCreateMutation>;
export type CreateMutationResult = Apollo.MutationResult<CreateMutation>;
export type CreateMutationOptions = Apollo.BaseMutationOptions<
  CreateMutation,
  CreateMutationVariables
>;
export const UpdateDocument = gql`
  mutation Update($mutationId: ID!, $mutation: RegisterMutationInput!) {
    updateMutation(mutationId: $mutationId, mutation: $mutation) {
      ...MutationWithDocumentFields
      register {
        ...RegisterFields
      }
      validationErrors {
        ...ValidationErrorsFields
      }
    }
  }
  ${MutationWithDocumentFieldsFragmentDoc}
  ${RegisterFieldsFragmentDoc}
  ${ValidationErrorsFieldsFragmentDoc}
`;
export type UpdateMutationFn = Apollo.MutationFunction<UpdateMutation, UpdateMutationVariables>;

/**
 * __useUpdateMutation__
 *
 * To run a mutation, you first call `useUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMutation, { data, loading, error }] = useUpdateMutation({
 *   variables: {
 *      mutationId: // value for 'mutationId'
 *      mutation: // value for 'mutation'
 *   },
 * });
 */
export function useUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateMutation, UpdateMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateMutation, UpdateMutationVariables>(UpdateDocument, options);
}
export type UpdateMutationHookResult = ReturnType<typeof useUpdateMutation>;
export type UpdateMutationResult = Apollo.MutationResult<UpdateMutation>;
export type UpdateMutationOptions = Apollo.BaseMutationOptions<
  UpdateMutation,
  UpdateMutationVariables
>;
export const DeleteDocument = gql`
  mutation Delete($mutationId: ID!) {
    deleteMutation(mutationId: $mutationId) {
      ...MutationWithDocumentFields
    }
  }
  ${MutationWithDocumentFieldsFragmentDoc}
`;
export type DeleteMutationFn = Apollo.MutationFunction<DeleteMutation, DeleteMutationVariables>;

/**
 * __useDeleteMutation__
 *
 * To run a mutation, you first call `useDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMutation, { data, loading, error }] = useDeleteMutation({
 *   variables: {
 *      mutationId: // value for 'mutationId'
 *   },
 * });
 */
export function useDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteMutation, DeleteMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteMutation, DeleteMutationVariables>(DeleteDocument, options);
}
export type DeleteMutationHookResult = ReturnType<typeof useDeleteMutation>;
export type DeleteMutationResult = Apollo.MutationResult<DeleteMutation>;
export type DeleteMutationOptions = Apollo.BaseMutationOptions<
  DeleteMutation,
  DeleteMutationVariables
>;
export const MutationPriceDocument = gql`
  query MutationPrice($legalEntityId: ID!, $mutationType: MutationType!, $effectiveDate: Date) {
    mutationPrice(
      legalEntityId: $legalEntityId
      mutationType: $mutationType
      effectiveDate: $effectiveDate
    ) {
      amountEuros
      exemption
    }
  }
`;

/**
 * __useMutationPriceQuery__
 *
 * To run a query within a React component, call `useMutationPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMutationPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMutationPriceQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      mutationType: // value for 'mutationType'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useMutationPriceQuery(
  baseOptions: Apollo.QueryHookOptions<MutationPriceQuery, MutationPriceQueryVariables> &
    ({ variables: MutationPriceQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MutationPriceQuery, MutationPriceQueryVariables>(
    MutationPriceDocument,
    options,
  );
}
export function useMutationPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MutationPriceQuery, MutationPriceQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MutationPriceQuery, MutationPriceQueryVariables>(
    MutationPriceDocument,
    options,
  );
}
// @ts-ignore
export function useMutationPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MutationPriceQuery, MutationPriceQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationPriceQuery, MutationPriceQueryVariables>;
export function useMutationPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MutationPriceQuery, MutationPriceQueryVariables>,
): Apollo.UseSuspenseQueryResult<MutationPriceQuery | undefined, MutationPriceQueryVariables>;
export function useMutationPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<MutationPriceQuery, MutationPriceQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MutationPriceQuery, MutationPriceQueryVariables>(
    MutationPriceDocument,
    options,
  );
}
export type MutationPriceQueryHookResult = ReturnType<typeof useMutationPriceQuery>;
export type MutationPriceLazyQueryHookResult = ReturnType<typeof useMutationPriceLazyQuery>;
export type MutationPriceSuspenseQueryHookResult = ReturnType<typeof useMutationPriceSuspenseQuery>;
export type MutationPriceQueryResult = Apollo.QueryResult<
  MutationPriceQuery,
  MutationPriceQueryVariables
>;
export const NaturalPersonDocument = gql`
  query NaturalPerson($naturalPersonId: ID!) {
    naturalPerson(naturalPersonId: $naturalPersonId) {
      ...NaturalPersonFields
      participation {
        ...ParticipationsFields
        register {
          legalEntity {
            id
            name
          }
        }
      }
      entitlement
    }
  }
  ${NaturalPersonFieldsFragmentDoc}
  ${ParticipationsFieldsFragmentDoc}
`;

/**
 * __useNaturalPersonQuery__
 *
 * To run a query within a React component, call `useNaturalPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useNaturalPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNaturalPersonQuery({
 *   variables: {
 *      naturalPersonId: // value for 'naturalPersonId'
 *   },
 * });
 */
export function useNaturalPersonQuery(
  baseOptions: Apollo.QueryHookOptions<NaturalPersonQuery, NaturalPersonQueryVariables> &
    ({ variables: NaturalPersonQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NaturalPersonQuery, NaturalPersonQueryVariables>(
    NaturalPersonDocument,
    options,
  );
}
export function useNaturalPersonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NaturalPersonQuery, NaturalPersonQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NaturalPersonQuery, NaturalPersonQueryVariables>(
    NaturalPersonDocument,
    options,
  );
}
// @ts-ignore
export function useNaturalPersonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<NaturalPersonQuery, NaturalPersonQueryVariables>,
): Apollo.UseSuspenseQueryResult<NaturalPersonQuery, NaturalPersonQueryVariables>;
export function useNaturalPersonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NaturalPersonQuery, NaturalPersonQueryVariables>,
): Apollo.UseSuspenseQueryResult<NaturalPersonQuery | undefined, NaturalPersonQueryVariables>;
export function useNaturalPersonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NaturalPersonQuery, NaturalPersonQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NaturalPersonQuery, NaturalPersonQueryVariables>(
    NaturalPersonDocument,
    options,
  );
}
export type NaturalPersonQueryHookResult = ReturnType<typeof useNaturalPersonQuery>;
export type NaturalPersonLazyQueryHookResult = ReturnType<typeof useNaturalPersonLazyQuery>;
export type NaturalPersonSuspenseQueryHookResult = ReturnType<typeof useNaturalPersonSuspenseQuery>;
export type NaturalPersonQueryResult = Apollo.QueryResult<
  NaturalPersonQuery,
  NaturalPersonQueryVariables
>;
export const CreateNaturalPersonDocument = gql`
  mutation CreateNaturalPerson($registerId: ID!, $naturalPerson: NaturalPersonInput!) {
    createNaturalPerson(registerId: $registerId, naturalPerson: $naturalPerson) {
      ...NaturalPersonFields
    }
  }
  ${NaturalPersonFieldsFragmentDoc}
`;
export type CreateNaturalPersonMutationFn = Apollo.MutationFunction<
  CreateNaturalPersonMutation,
  CreateNaturalPersonMutationVariables
>;

/**
 * __useCreateNaturalPersonMutation__
 *
 * To run a mutation, you first call `useCreateNaturalPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNaturalPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNaturalPersonMutation, { data, loading, error }] = useCreateNaturalPersonMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      naturalPerson: // value for 'naturalPerson'
 *   },
 * });
 */
export function useCreateNaturalPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateNaturalPersonMutation,
    CreateNaturalPersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNaturalPersonMutation, CreateNaturalPersonMutationVariables>(
    CreateNaturalPersonDocument,
    options,
  );
}
export type CreateNaturalPersonMutationHookResult = ReturnType<
  typeof useCreateNaturalPersonMutation
>;
export type CreateNaturalPersonMutationResult = Apollo.MutationResult<CreateNaturalPersonMutation>;
export type CreateNaturalPersonMutationOptions = Apollo.BaseMutationOptions<
  CreateNaturalPersonMutation,
  CreateNaturalPersonMutationVariables
>;
export const UpdateNaturalPersonDocument = gql`
  mutation UpdateNaturalPerson($naturalPersonId: ID!, $naturalPerson: NaturalPersonInput!) {
    updateNaturalPerson(naturalPersonId: $naturalPersonId, naturalPerson: $naturalPerson) {
      ...NaturalPersonFields
    }
  }
  ${NaturalPersonFieldsFragmentDoc}
`;
export type UpdateNaturalPersonMutationFn = Apollo.MutationFunction<
  UpdateNaturalPersonMutation,
  UpdateNaturalPersonMutationVariables
>;

/**
 * __useUpdateNaturalPersonMutation__
 *
 * To run a mutation, you first call `useUpdateNaturalPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNaturalPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNaturalPersonMutation, { data, loading, error }] = useUpdateNaturalPersonMutation({
 *   variables: {
 *      naturalPersonId: // value for 'naturalPersonId'
 *      naturalPerson: // value for 'naturalPerson'
 *   },
 * });
 */
export function useUpdateNaturalPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNaturalPersonMutation,
    UpdateNaturalPersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateNaturalPersonMutation, UpdateNaturalPersonMutationVariables>(
    UpdateNaturalPersonDocument,
    options,
  );
}
export type UpdateNaturalPersonMutationHookResult = ReturnType<
  typeof useUpdateNaturalPersonMutation
>;
export type UpdateNaturalPersonMutationResult = Apollo.MutationResult<UpdateNaturalPersonMutation>;
export type UpdateNaturalPersonMutationOptions = Apollo.BaseMutationOptions<
  UpdateNaturalPersonMutation,
  UpdateNaturalPersonMutationVariables
>;
export const NotariesDocument = gql`
  query Notaries {
    notaries {
      ...NotaryFields
    }
  }
  ${NotaryFieldsFragmentDoc}
`;

/**
 * __useNotariesQuery__
 *
 * To run a query within a React component, call `useNotariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotariesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotariesQuery(
  baseOptions?: Apollo.QueryHookOptions<NotariesQuery, NotariesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotariesQuery, NotariesQueryVariables>(NotariesDocument, options);
}
export function useNotariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotariesQuery, NotariesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotariesQuery, NotariesQueryVariables>(NotariesDocument, options);
}
// @ts-ignore
export function useNotariesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<NotariesQuery, NotariesQueryVariables>,
): Apollo.UseSuspenseQueryResult<NotariesQuery, NotariesQueryVariables>;
export function useNotariesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotariesQuery, NotariesQueryVariables>,
): Apollo.UseSuspenseQueryResult<NotariesQuery | undefined, NotariesQueryVariables>;
export function useNotariesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotariesQuery, NotariesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NotariesQuery, NotariesQueryVariables>(NotariesDocument, options);
}
export type NotariesQueryHookResult = ReturnType<typeof useNotariesQuery>;
export type NotariesLazyQueryHookResult = ReturnType<typeof useNotariesLazyQuery>;
export type NotariesSuspenseQueryHookResult = ReturnType<typeof useNotariesSuspenseQuery>;
export type NotariesQueryResult = Apollo.QueryResult<NotariesQuery, NotariesQueryVariables>;
export const CreateNotaryDocument = gql`
  mutation CreateNotary($input: CreateNotaryInput!) {
    createNotary(input: $input) {
      ...NotaryFields
    }
  }
  ${NotaryFieldsFragmentDoc}
`;
export type CreateNotaryMutationFn = Apollo.MutationFunction<
  CreateNotaryMutation,
  CreateNotaryMutationVariables
>;

/**
 * __useCreateNotaryMutation__
 *
 * To run a mutation, you first call `useCreateNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotaryMutation, { data, loading, error }] = useCreateNotaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotaryMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateNotaryMutation, CreateNotaryMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateNotaryMutation, CreateNotaryMutationVariables>(
    CreateNotaryDocument,
    options,
  );
}
export type CreateNotaryMutationHookResult = ReturnType<typeof useCreateNotaryMutation>;
export type CreateNotaryMutationResult = Apollo.MutationResult<CreateNotaryMutation>;
export type CreateNotaryMutationOptions = Apollo.BaseMutationOptions<
  CreateNotaryMutation,
  CreateNotaryMutationVariables
>;
export const UpdateNotaryDocument = gql`
  mutation UpdateNotary($id: ID!, $input: UpdateNotaryInput!) {
    updateNotary(id: $id, input: $input) {
      ...NotaryFields
    }
  }
  ${NotaryFieldsFragmentDoc}
`;
export type UpdateNotaryMutationFn = Apollo.MutationFunction<
  UpdateNotaryMutation,
  UpdateNotaryMutationVariables
>;

/**
 * __useUpdateNotaryMutation__
 *
 * To run a mutation, you first call `useUpdateNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotaryMutation, { data, loading, error }] = useUpdateNotaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotaryMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateNotaryMutation, UpdateNotaryMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateNotaryMutation, UpdateNotaryMutationVariables>(
    UpdateNotaryDocument,
    options,
  );
}
export type UpdateNotaryMutationHookResult = ReturnType<typeof useUpdateNotaryMutation>;
export type UpdateNotaryMutationResult = Apollo.MutationResult<UpdateNotaryMutation>;
export type UpdateNotaryMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotaryMutation,
  UpdateNotaryMutationVariables
>;
export const DeleteNotaryDocument = gql`
  mutation DeleteNotary($id: ID!) {
    deleteNotary(id: $id)
  }
`;
export type DeleteNotaryMutationFn = Apollo.MutationFunction<
  DeleteNotaryMutation,
  DeleteNotaryMutationVariables
>;

/**
 * __useDeleteNotaryMutation__
 *
 * To run a mutation, you first call `useDeleteNotaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotaryMutation, { data, loading, error }] = useDeleteNotaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotaryMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteNotaryMutation, DeleteNotaryMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteNotaryMutation, DeleteNotaryMutationVariables>(
    DeleteNotaryDocument,
    options,
  );
}
export type DeleteNotaryMutationHookResult = ReturnType<typeof useDeleteNotaryMutation>;
export type DeleteNotaryMutationResult = Apollo.MutationResult<DeleteNotaryMutation>;
export type DeleteNotaryMutationOptions = Apollo.BaseMutationOptions<
  DeleteNotaryMutation,
  DeleteNotaryMutationVariables
>;
export const SetNotaryActiveDocument = gql`
  mutation SetNotaryActive($id: ID!, $active: Boolean!) {
    setNotaryActive(id: $id, active: $active) {
      ...NotaryFields
    }
  }
  ${NotaryFieldsFragmentDoc}
`;
export type SetNotaryActiveMutationFn = Apollo.MutationFunction<
  SetNotaryActiveMutation,
  SetNotaryActiveMutationVariables
>;

/**
 * __useSetNotaryActiveMutation__
 *
 * To run a mutation, you first call `useSetNotaryActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNotaryActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNotaryActiveMutation, { data, loading, error }] = useSetNotaryActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetNotaryActiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetNotaryActiveMutation,
    SetNotaryActiveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetNotaryActiveMutation, SetNotaryActiveMutationVariables>(
    SetNotaryActiveDocument,
    options,
  );
}
export type SetNotaryActiveMutationHookResult = ReturnType<typeof useSetNotaryActiveMutation>;
export type SetNotaryActiveMutationResult = Apollo.MutationResult<SetNotaryActiveMutation>;
export type SetNotaryActiveMutationOptions = Apollo.BaseMutationOptions<
  SetNotaryActiveMutation,
  SetNotaryActiveMutationVariables
>;
export const UpdateParticipationDocument = gql`
  mutation UpdateParticipation($partyId: ID!, $participationInput: ParticipationInput!) {
    updateParticipation(partyId: $partyId, participationInput: $participationInput) {
      validationErrors {
        ...ValidationErrorsFields
      }
      party {
        id
      }
    }
  }
  ${ValidationErrorsFieldsFragmentDoc}
`;
export type UpdateParticipationMutationFn = Apollo.MutationFunction<
  UpdateParticipationMutation,
  UpdateParticipationMutationVariables
>;

/**
 * __useUpdateParticipationMutation__
 *
 * To run a mutation, you first call `useUpdateParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParticipationMutation, { data, loading, error }] = useUpdateParticipationMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      participationInput: // value for 'participationInput'
 *   },
 * });
 */
export function useUpdateParticipationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateParticipationMutation,
    UpdateParticipationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateParticipationMutation, UpdateParticipationMutationVariables>(
    UpdateParticipationDocument,
    options,
  );
}
export type UpdateParticipationMutationHookResult = ReturnType<
  typeof useUpdateParticipationMutation
>;
export type UpdateParticipationMutationResult = Apollo.MutationResult<UpdateParticipationMutation>;
export type UpdateParticipationMutationOptions = Apollo.BaseMutationOptions<
  UpdateParticipationMutation,
  UpdateParticipationMutationVariables
>;
export const DeleteParticipationDocument = gql`
  mutation DeleteParticipation($partyId: ID!, $registerId: ID!) {
    deleteParticipation(partyId: $partyId, registerId: $registerId) {
      validationErrors {
        ...ValidationErrorsFields
      }
      party {
        id
      }
    }
  }
  ${ValidationErrorsFieldsFragmentDoc}
`;
export type DeleteParticipationMutationFn = Apollo.MutationFunction<
  DeleteParticipationMutation,
  DeleteParticipationMutationVariables
>;

/**
 * __useDeleteParticipationMutation__
 *
 * To run a mutation, you first call `useDeleteParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteParticipationMutation, { data, loading, error }] = useDeleteParticipationMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useDeleteParticipationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteParticipationMutation,
    DeleteParticipationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteParticipationMutation, DeleteParticipationMutationVariables>(
    DeleteParticipationDocument,
    options,
  );
}
export type DeleteParticipationMutationHookResult = ReturnType<
  typeof useDeleteParticipationMutation
>;
export type DeleteParticipationMutationResult = Apollo.MutationResult<DeleteParticipationMutation>;
export type DeleteParticipationMutationOptions = Apollo.BaseMutationOptions<
  DeleteParticipationMutation,
  DeleteParticipationMutationVariables
>;
export const PartyDashboardDocument = gql`
  query PartyDashboard($filter: PartySearchFilterInput, $pagination: PaginationInput!) {
    partySearch(filter: $filter, pagination: $pagination) {
      items {
        legalEntity {
          id
          name
          tradeRegisterNumber
          countryOfRegistration
          incorporatedOn
          entitlement
          otherEntitledCount
          register {
            id
            isSigned
            replacement
            endedOn
            signatures {
              id
            }
          }
        }
      }
      pagination {
        totalPages
        totalCount
        page
        count
      }
    }
  }
`;

/**
 * __usePartyDashboardQuery__
 *
 * To run a query within a React component, call `usePartyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartyDashboardQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePartyDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<PartyDashboardQuery, PartyDashboardQueryVariables> &
    ({ variables: PartyDashboardQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PartyDashboardQuery, PartyDashboardQueryVariables>(
    PartyDashboardDocument,
    options,
  );
}
export function usePartyDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PartyDashboardQuery, PartyDashboardQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PartyDashboardQuery, PartyDashboardQueryVariables>(
    PartyDashboardDocument,
    options,
  );
}
// @ts-ignore
export function usePartyDashboardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PartyDashboardQuery, PartyDashboardQueryVariables>,
): Apollo.UseSuspenseQueryResult<PartyDashboardQuery, PartyDashboardQueryVariables>;
export function usePartyDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PartyDashboardQuery, PartyDashboardQueryVariables>,
): Apollo.UseSuspenseQueryResult<PartyDashboardQuery | undefined, PartyDashboardQueryVariables>;
export function usePartyDashboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PartyDashboardQuery, PartyDashboardQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PartyDashboardQuery, PartyDashboardQueryVariables>(
    PartyDashboardDocument,
    options,
  );
}
export type PartyDashboardQueryHookResult = ReturnType<typeof usePartyDashboardQuery>;
export type PartyDashboardLazyQueryHookResult = ReturnType<typeof usePartyDashboardLazyQuery>;
export type PartyDashboardSuspenseQueryHookResult = ReturnType<
  typeof usePartyDashboardSuspenseQuery
>;
export type PartyDashboardQueryResult = Apollo.QueryResult<
  PartyDashboardQuery,
  PartyDashboardQueryVariables
>;
export const PartySearchDocument = gql`
  query PartySearch($filter: PartySearchFilterInput, $pagination: PaginationInput!) {
    partySearch(filter: $filter, pagination: $pagination) {
      items {
        naturalPerson {
          id
          dateOfBirth
          placeOfBirth
          postalAddress {
            ...PostalAddressFields
          }
          tag
          name {
            ...NameFields
          }
        }
        legalEntity {
          id
          name
          tradeRegisterNumber
          countryOfRegistration
          visitorAddress {
            ...PostalAddressFields
          }
          register {
            id
            entitlement
            requestForAccess {
              id
            }
          }
        }
      }
      pagination {
        totalPages
        totalCount
        page
        count
      }
    }
  }
  ${PostalAddressFieldsFragmentDoc}
  ${NameFieldsFragmentDoc}
`;

/**
 * __usePartySearchQuery__
 *
 * To run a query within a React component, call `usePartySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartySearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePartySearchQuery(
  baseOptions: Apollo.QueryHookOptions<PartySearchQuery, PartySearchQueryVariables> &
    ({ variables: PartySearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PartySearchQuery, PartySearchQueryVariables>(PartySearchDocument, options);
}
export function usePartySearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PartySearchQuery, PartySearchQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PartySearchQuery, PartySearchQueryVariables>(
    PartySearchDocument,
    options,
  );
}
// @ts-ignore
export function usePartySearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PartySearchQuery, PartySearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<PartySearchQuery, PartySearchQueryVariables>;
export function usePartySearchSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartySearchQuery, PartySearchQueryVariables>,
): Apollo.UseSuspenseQueryResult<PartySearchQuery | undefined, PartySearchQueryVariables>;
export function usePartySearchSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartySearchQuery, PartySearchQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PartySearchQuery, PartySearchQueryVariables>(
    PartySearchDocument,
    options,
  );
}
export type PartySearchQueryHookResult = ReturnType<typeof usePartySearchQuery>;
export type PartySearchLazyQueryHookResult = ReturnType<typeof usePartySearchLazyQuery>;
export type PartySearchSuspenseQueryHookResult = ReturnType<typeof usePartySearchSuspenseQuery>;
export type PartySearchQueryResult = Apollo.QueryResult<
  PartySearchQuery,
  PartySearchQueryVariables
>;
export const GroupRegistersDocument = gql`
  query GroupRegisters($groupId: ID!, $pagination: PaginationInput!) {
    partySearch(filter: { type: GROUP_REGISTERS, groupId: $groupId }, pagination: $pagination) {
      items {
        legalEntity {
          id
          name
          tradeRegisterNumber
          countryOfRegistration
          register {
            id
            isSigned
            entitlement
            signatures {
              id
            }
          }
        }
      }
      pagination {
        totalPages
        totalCount
        page
        count
      }
    }
  }
`;

/**
 * __useGroupRegistersQuery__
 *
 * To run a query within a React component, call `useGroupRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupRegistersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGroupRegistersQuery(
  baseOptions: Apollo.QueryHookOptions<GroupRegistersQuery, GroupRegistersQueryVariables> &
    ({ variables: GroupRegistersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GroupRegistersQuery, GroupRegistersQueryVariables>(
    GroupRegistersDocument,
    options,
  );
}
export function useGroupRegistersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupRegistersQuery, GroupRegistersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GroupRegistersQuery, GroupRegistersQueryVariables>(
    GroupRegistersDocument,
    options,
  );
}
// @ts-ignore
export function useGroupRegistersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GroupRegistersQuery, GroupRegistersQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupRegistersQuery, GroupRegistersQueryVariables>;
export function useGroupRegistersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupRegistersQuery, GroupRegistersQueryVariables>,
): Apollo.UseSuspenseQueryResult<GroupRegistersQuery | undefined, GroupRegistersQueryVariables>;
export function useGroupRegistersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupRegistersQuery, GroupRegistersQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GroupRegistersQuery, GroupRegistersQueryVariables>(
    GroupRegistersDocument,
    options,
  );
}
export type GroupRegistersQueryHookResult = ReturnType<typeof useGroupRegistersQuery>;
export type GroupRegistersLazyQueryHookResult = ReturnType<typeof useGroupRegistersLazyQuery>;
export type GroupRegistersSuspenseQueryHookResult = ReturnType<
  typeof useGroupRegistersSuspenseQuery
>;
export type GroupRegistersQueryResult = Apollo.QueryResult<
  GroupRegistersQuery,
  GroupRegistersQueryVariables
>;
export const EntitledEntityRegistersDocument = gql`
  query EntitledEntityRegisters($entityId: ID!, $pagination: PaginationInput!) {
    partySearch(
      filter: { type: ENTITLED_ENTITY_REGISTERS, entityId: $entityId }
      pagination: $pagination
    ) {
      items {
        legalEntity {
          id
          name
          tradeRegisterNumber
          countryOfRegistration
          register {
            id
            isSigned
          }
        }
      }
      pagination {
        totalPages
        totalCount
        page
        count
      }
    }
  }
`;

/**
 * __useEntitledEntityRegistersQuery__
 *
 * To run a query within a React component, call `useEntitledEntityRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitledEntityRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitledEntityRegistersQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useEntitledEntityRegistersQuery(
  baseOptions: Apollo.QueryHookOptions<
    EntitledEntityRegistersQuery,
    EntitledEntityRegistersQueryVariables
  > &
    ({ variables: EntitledEntityRegistersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EntitledEntityRegistersQuery, EntitledEntityRegistersQueryVariables>(
    EntitledEntityRegistersDocument,
    options,
  );
}
export function useEntitledEntityRegistersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EntitledEntityRegistersQuery,
    EntitledEntityRegistersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EntitledEntityRegistersQuery, EntitledEntityRegistersQueryVariables>(
    EntitledEntityRegistersDocument,
    options,
  );
}
// @ts-ignore
export function useEntitledEntityRegistersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    EntitledEntityRegistersQuery,
    EntitledEntityRegistersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  EntitledEntityRegistersQuery,
  EntitledEntityRegistersQueryVariables
>;
export function useEntitledEntityRegistersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntitledEntityRegistersQuery,
        EntitledEntityRegistersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  EntitledEntityRegistersQuery | undefined,
  EntitledEntityRegistersQueryVariables
>;
export function useEntitledEntityRegistersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        EntitledEntityRegistersQuery,
        EntitledEntityRegistersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    EntitledEntityRegistersQuery,
    EntitledEntityRegistersQueryVariables
  >(EntitledEntityRegistersDocument, options);
}
export type EntitledEntityRegistersQueryHookResult = ReturnType<
  typeof useEntitledEntityRegistersQuery
>;
export type EntitledEntityRegistersLazyQueryHookResult = ReturnType<
  typeof useEntitledEntityRegistersLazyQuery
>;
export type EntitledEntityRegistersSuspenseQueryHookResult = ReturnType<
  typeof useEntitledEntityRegistersSuspenseQuery
>;
export type EntitledEntityRegistersQueryResult = Apollo.QueryResult<
  EntitledEntityRegistersQuery,
  EntitledEntityRegistersQueryVariables
>;
export const KvkUpdatesDocument = gql`
  query KvkUpdates($partyId: ID!) {
    kvkUpdates(partyId: $partyId) {
      ...PartyUpdateFields
    }
  }
  ${PartyUpdateFieldsFragmentDoc}
`;

/**
 * __useKvkUpdatesQuery__
 *
 * To run a query within a React component, call `useKvkUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useKvkUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKvkUpdatesQuery({
 *   variables: {
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useKvkUpdatesQuery(
  baseOptions: Apollo.QueryHookOptions<KvkUpdatesQuery, KvkUpdatesQueryVariables> &
    ({ variables: KvkUpdatesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<KvkUpdatesQuery, KvkUpdatesQueryVariables>(KvkUpdatesDocument, options);
}
export function useKvkUpdatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<KvkUpdatesQuery, KvkUpdatesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<KvkUpdatesQuery, KvkUpdatesQueryVariables>(
    KvkUpdatesDocument,
    options,
  );
}
// @ts-ignore
export function useKvkUpdatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<KvkUpdatesQuery, KvkUpdatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<KvkUpdatesQuery, KvkUpdatesQueryVariables>;
export function useKvkUpdatesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KvkUpdatesQuery, KvkUpdatesQueryVariables>,
): Apollo.UseSuspenseQueryResult<KvkUpdatesQuery | undefined, KvkUpdatesQueryVariables>;
export function useKvkUpdatesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KvkUpdatesQuery, KvkUpdatesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<KvkUpdatesQuery, KvkUpdatesQueryVariables>(
    KvkUpdatesDocument,
    options,
  );
}
export type KvkUpdatesQueryHookResult = ReturnType<typeof useKvkUpdatesQuery>;
export type KvkUpdatesLazyQueryHookResult = ReturnType<typeof useKvkUpdatesLazyQuery>;
export type KvkUpdatesSuspenseQueryHookResult = ReturnType<typeof useKvkUpdatesSuspenseQuery>;
export type KvkUpdatesQueryResult = Apollo.QueryResult<KvkUpdatesQuery, KvkUpdatesQueryVariables>;
export const SavePartyUpdatesDocument = gql`
  mutation SavePartyUpdates($partyUpdates: [PartyUpdateInput!]!, $document: DocumentInput) {
    savePartyUpdates(partyUpdates: $partyUpdates, document: $document) {
      ...PartyUpdateFields
    }
  }
  ${PartyUpdateFieldsFragmentDoc}
`;
export type SavePartyUpdatesMutationFn = Apollo.MutationFunction<
  SavePartyUpdatesMutation,
  SavePartyUpdatesMutationVariables
>;

/**
 * __useSavePartyUpdatesMutation__
 *
 * To run a mutation, you first call `useSavePartyUpdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePartyUpdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePartyUpdatesMutation, { data, loading, error }] = useSavePartyUpdatesMutation({
 *   variables: {
 *      partyUpdates: // value for 'partyUpdates'
 *      document: // value for 'document'
 *   },
 * });
 */
export function useSavePartyUpdatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SavePartyUpdatesMutation,
    SavePartyUpdatesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SavePartyUpdatesMutation, SavePartyUpdatesMutationVariables>(
    SavePartyUpdatesDocument,
    options,
  );
}
export type SavePartyUpdatesMutationHookResult = ReturnType<typeof useSavePartyUpdatesMutation>;
export type SavePartyUpdatesMutationResult = Apollo.MutationResult<SavePartyUpdatesMutation>;
export type SavePartyUpdatesMutationOptions = Apollo.BaseMutationOptions<
  SavePartyUpdatesMutation,
  SavePartyUpdatesMutationVariables
>;
export const PostalAddressLookupDocument = gql`
  query PostalAddressLookup($postalCode: String!, $streetNumber: String!) {
    postalAddressLookup(postalCode: $postalCode, streetNumber: $streetNumber) {
      ...PostalAddressFields
    }
  }
  ${PostalAddressFieldsFragmentDoc}
`;

/**
 * __usePostalAddressLookupQuery__
 *
 * To run a query within a React component, call `usePostalAddressLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostalAddressLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostalAddressLookupQuery({
 *   variables: {
 *      postalCode: // value for 'postalCode'
 *      streetNumber: // value for 'streetNumber'
 *   },
 * });
 */
export function usePostalAddressLookupQuery(
  baseOptions: Apollo.QueryHookOptions<
    PostalAddressLookupQuery,
    PostalAddressLookupQueryVariables
  > &
    ({ variables: PostalAddressLookupQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>(
    PostalAddressLookupDocument,
    options,
  );
}
export function usePostalAddressLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PostalAddressLookupQuery,
    PostalAddressLookupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>(
    PostalAddressLookupDocument,
    options,
  );
}
// @ts-ignore
export function usePostalAddressLookupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PostalAddressLookupQuery,
    PostalAddressLookupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>;
export function usePostalAddressLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  PostalAddressLookupQuery | undefined,
  PostalAddressLookupQueryVariables
>;
export function usePostalAddressLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PostalAddressLookupQuery, PostalAddressLookupQueryVariables>(
    PostalAddressLookupDocument,
    options,
  );
}
export type PostalAddressLookupQueryHookResult = ReturnType<typeof usePostalAddressLookupQuery>;
export type PostalAddressLookupLazyQueryHookResult = ReturnType<
  typeof usePostalAddressLookupLazyQuery
>;
export type PostalAddressLookupSuspenseQueryHookResult = ReturnType<
  typeof usePostalAddressLookupSuspenseQuery
>;
export type PostalAddressLookupQueryResult = Apollo.QueryResult<
  PostalAddressLookupQuery,
  PostalAddressLookupQueryVariables
>;
export const PpuMutationDocument = gql`
  query PpuMutation($filter: PpuFilterInput) {
    ppuMutation(filter: $filter) {
      items {
        ... on PpuMutation {
          legalEntity {
            id
            name
            tradeRegisterNumber
          }
          description
          amountEuros
          created
        }
      }
      totalCount
      totalSpentEuros
    }
  }
`;

/**
 * __usePpuMutationQuery__
 *
 * To run a query within a React component, call `usePpuMutationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpuMutationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpuMutationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePpuMutationQuery(
  baseOptions?: Apollo.QueryHookOptions<PpuMutationQuery, PpuMutationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PpuMutationQuery, PpuMutationQueryVariables>(PpuMutationDocument, options);
}
export function usePpuMutationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PpuMutationQuery, PpuMutationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PpuMutationQuery, PpuMutationQueryVariables>(
    PpuMutationDocument,
    options,
  );
}
// @ts-ignore
export function usePpuMutationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PpuMutationQuery, PpuMutationQueryVariables>,
): Apollo.UseSuspenseQueryResult<PpuMutationQuery, PpuMutationQueryVariables>;
export function usePpuMutationSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PpuMutationQuery, PpuMutationQueryVariables>,
): Apollo.UseSuspenseQueryResult<PpuMutationQuery | undefined, PpuMutationQueryVariables>;
export function usePpuMutationSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PpuMutationQuery, PpuMutationQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PpuMutationQuery, PpuMutationQueryVariables>(
    PpuMutationDocument,
    options,
  );
}
export type PpuMutationQueryHookResult = ReturnType<typeof usePpuMutationQuery>;
export type PpuMutationLazyQueryHookResult = ReturnType<typeof usePpuMutationLazyQuery>;
export type PpuMutationSuspenseQueryHookResult = ReturnType<typeof usePpuMutationSuspenseQuery>;
export type PpuMutationQueryResult = Apollo.QueryResult<
  PpuMutationQuery,
  PpuMutationQueryVariables
>;
export const PpuMutationExcelDocument = gql`
  query PpuMutationExcel($filter: PpuFilterInput, $pagination: PaginationInput!) {
    ppuMutationExcel(filter: $filter, pagination: $pagination)
  }
`;

/**
 * __usePpuMutationExcelQuery__
 *
 * To run a query within a React component, call `usePpuMutationExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `usePpuMutationExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePpuMutationExcelQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePpuMutationExcelQuery(
  baseOptions: Apollo.QueryHookOptions<PpuMutationExcelQuery, PpuMutationExcelQueryVariables> &
    ({ variables: PpuMutationExcelQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>(
    PpuMutationExcelDocument,
    options,
  );
}
export function usePpuMutationExcelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>(
    PpuMutationExcelDocument,
    options,
  );
}
// @ts-ignore
export function usePpuMutationExcelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PpuMutationExcelQuery,
    PpuMutationExcelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>;
export function usePpuMutationExcelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>,
): Apollo.UseSuspenseQueryResult<PpuMutationExcelQuery | undefined, PpuMutationExcelQueryVariables>;
export function usePpuMutationExcelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PpuMutationExcelQuery, PpuMutationExcelQueryVariables>(
    PpuMutationExcelDocument,
    options,
  );
}
export type PpuMutationExcelQueryHookResult = ReturnType<typeof usePpuMutationExcelQuery>;
export type PpuMutationExcelLazyQueryHookResult = ReturnType<typeof usePpuMutationExcelLazyQuery>;
export type PpuMutationExcelSuspenseQueryHookResult = ReturnType<
  typeof usePpuMutationExcelSuspenseQuery
>;
export type PpuMutationExcelQueryResult = Apollo.QueryResult<
  PpuMutationExcelQuery,
  PpuMutationExcelQueryVariables
>;
export const RegisterDocument = gql`
  query Register($registerId: ID!, $atDate: Date, $mutationId: String) {
    register(registerId: $registerId, atDate: $atDate, mutationId: $mutationId) {
      ...RegisterFields
    }
  }
  ${RegisterFieldsFragmentDoc}
`;

/**
 * __useRegisterQuery__
 *
 * To run a query within a React component, call `useRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      atDate: // value for 'atDate'
 *      mutationId: // value for 'mutationId'
 *   },
 * });
 */
export function useRegisterQuery(
  baseOptions: Apollo.QueryHookOptions<RegisterQuery, RegisterQueryVariables> &
    ({ variables: RegisterQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterQuery, RegisterQueryVariables>(RegisterDocument, options);
}
export function useRegisterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegisterQuery, RegisterQueryVariables>(RegisterDocument, options);
}
// @ts-ignore
export function useRegisterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
): Apollo.UseSuspenseQueryResult<RegisterQuery, RegisterQueryVariables>;
export function useRegisterSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
): Apollo.UseSuspenseQueryResult<RegisterQuery | undefined, RegisterQueryVariables>;
export function useRegisterSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegisterQuery, RegisterQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegisterQuery, RegisterQueryVariables>(RegisterDocument, options);
}
export type RegisterQueryHookResult = ReturnType<typeof useRegisterQuery>;
export type RegisterLazyQueryHookResult = ReturnType<typeof useRegisterLazyQuery>;
export type RegisterSuspenseQueryHookResult = ReturnType<typeof useRegisterSuspenseQuery>;
export type RegisterQueryResult = Apollo.QueryResult<RegisterQuery, RegisterQueryVariables>;
export const RegisterDistributionChartDocument = gql`
  query RegisterDistributionChart(
    $registerId: ID!
    $groupBy: DistributionChartGroupBy!
    $filterBy: DistributionChartFilterBy
  ) {
    registerDistributionChart(registerId: $registerId, groupBy: $groupBy, filterBy: $filterBy) {
      pieces {
        quantity
        quantityPercentage
        amount {
          currencyCode
          units
          cents
          precision
        }
        amountPercentage
        party {
          ...PartyFields
        }
      }
    }
  }
  ${PartyFieldsFragmentDoc}
`;

/**
 * __useRegisterDistributionChartQuery__
 *
 * To run a query within a React component, call `useRegisterDistributionChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterDistributionChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterDistributionChartQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      groupBy: // value for 'groupBy'
 *      filterBy: // value for 'filterBy'
 *   },
 * });
 */
export function useRegisterDistributionChartQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterDistributionChartQuery,
    RegisterDistributionChartQueryVariables
  > &
    ({ variables: RegisterDistributionChartQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterDistributionChartQuery, RegisterDistributionChartQueryVariables>(
    RegisterDistributionChartDocument,
    options,
  );
}
export function useRegisterDistributionChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterDistributionChartQuery,
    RegisterDistributionChartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RegisterDistributionChartQuery,
    RegisterDistributionChartQueryVariables
  >(RegisterDistributionChartDocument, options);
}
// @ts-ignore
export function useRegisterDistributionChartSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegisterDistributionChartQuery,
    RegisterDistributionChartQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RegisterDistributionChartQuery,
  RegisterDistributionChartQueryVariables
>;
export function useRegisterDistributionChartSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterDistributionChartQuery,
        RegisterDistributionChartQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RegisterDistributionChartQuery | undefined,
  RegisterDistributionChartQueryVariables
>;
export function useRegisterDistributionChartSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterDistributionChartQuery,
        RegisterDistributionChartQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RegisterDistributionChartQuery,
    RegisterDistributionChartQueryVariables
  >(RegisterDistributionChartDocument, options);
}
export type RegisterDistributionChartQueryHookResult = ReturnType<
  typeof useRegisterDistributionChartQuery
>;
export type RegisterDistributionChartLazyQueryHookResult = ReturnType<
  typeof useRegisterDistributionChartLazyQuery
>;
export type RegisterDistributionChartSuspenseQueryHookResult = ReturnType<
  typeof useRegisterDistributionChartSuspenseQuery
>;
export type RegisterDistributionChartQueryResult = Apollo.QueryResult<
  RegisterDistributionChartQuery,
  RegisterDistributionChartQueryVariables
>;
export const RegisterOfShareholdersDocument = gql`
  query RegisterOfShareholders($registerId: ID!, $locale: Locale!) {
    registerOfShareholders(registerId: $registerId, locale: $locale) {
      register {
        ...RegisterFields
      }
      partyUpdateHistory {
        date
        party {
          ...PartyFields
        }
        updateFields
      }
      capitalHistory {
        authorized {
          date
          shares {
            shareType {
              ...ShareTypeFields
            }
            amount
          }
        }
        issued {
          date
          shares {
            shareType {
              ...ShareTypeFields
            }
            amount
          }
        }
        paid {
          date
          shares {
            shareType {
              ...ShareTypeFields
            }
            amount
          }
        }
        unpaid {
          date
          shares {
            shareType {
              ...ShareTypeFields
            }
            amount
          }
        }
      }
      partyMutationHistory {
        ...PartyMutationHistoryFields
      }
      pledgeeMutationHistory {
        ...PartyMutationHistoryFields
      }
      usufructuaryMutationHistory {
        ...PartyMutationHistoryFields
      }
      guardianMutationHistory {
        ...PartyMutationHistoryFields
      }
      partyAttachmentStates {
        party {
          ...PartyFields
        }
        attachments {
          attachedAt
          requiredBy {
            ...PartyFields
          }
          bailiff {
            ...PartyFields
          }
          type
          shareSeries {
            ...ShareBatchFields
          }
        }
      }
      locale
    }
  }
  ${RegisterFieldsFragmentDoc}
  ${PartyFieldsFragmentDoc}
  ${ShareTypeFieldsFragmentDoc}
  ${PartyMutationHistoryFieldsFragmentDoc}
  ${ShareBatchFieldsFragmentDoc}
`;

/**
 * __useRegisterOfShareholdersQuery__
 *
 * To run a query within a React component, call `useRegisterOfShareholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegisterOfShareholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegisterOfShareholdersQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useRegisterOfShareholdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegisterOfShareholdersQuery,
    RegisterOfShareholdersQueryVariables
  > &
    ({ variables: RegisterOfShareholdersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RegisterOfShareholdersQuery, RegisterOfShareholdersQueryVariables>(
    RegisterOfShareholdersDocument,
    options,
  );
}
export function useRegisterOfShareholdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegisterOfShareholdersQuery,
    RegisterOfShareholdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RegisterOfShareholdersQuery, RegisterOfShareholdersQueryVariables>(
    RegisterOfShareholdersDocument,
    options,
  );
}
// @ts-ignore
export function useRegisterOfShareholdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RegisterOfShareholdersQuery,
    RegisterOfShareholdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<RegisterOfShareholdersQuery, RegisterOfShareholdersQueryVariables>;
export function useRegisterOfShareholdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterOfShareholdersQuery,
        RegisterOfShareholdersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RegisterOfShareholdersQuery | undefined,
  RegisterOfShareholdersQueryVariables
>;
export function useRegisterOfShareholdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegisterOfShareholdersQuery,
        RegisterOfShareholdersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RegisterOfShareholdersQuery, RegisterOfShareholdersQueryVariables>(
    RegisterOfShareholdersDocument,
    options,
  );
}
export type RegisterOfShareholdersQueryHookResult = ReturnType<
  typeof useRegisterOfShareholdersQuery
>;
export type RegisterOfShareholdersLazyQueryHookResult = ReturnType<
  typeof useRegisterOfShareholdersLazyQuery
>;
export type RegisterOfShareholdersSuspenseQueryHookResult = ReturnType<
  typeof useRegisterOfShareholdersSuspenseQuery
>;
export type RegisterOfShareholdersQueryResult = Apollo.QueryResult<
  RegisterOfShareholdersQuery,
  RegisterOfShareholdersQueryVariables
>;
export const ExportRegisterOfShareholdersDocument = gql`
  query ExportRegisterOfShareholders($registerId: ID!, $locale: Locale!, $sign: Boolean) {
    exportRegisterOfShareholders(registerId: $registerId, locale: $locale, sign: $sign)
  }
`;

/**
 * __useExportRegisterOfShareholdersQuery__
 *
 * To run a query within a React component, call `useExportRegisterOfShareholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportRegisterOfShareholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportRegisterOfShareholdersQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      locale: // value for 'locale'
 *      sign: // value for 'sign'
 *   },
 * });
 */
export function useExportRegisterOfShareholdersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  > &
    ({ variables: ExportRegisterOfShareholdersQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  >(ExportRegisterOfShareholdersDocument, options);
}
export function useExportRegisterOfShareholdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  >(ExportRegisterOfShareholdersDocument, options);
}
// @ts-ignore
export function useExportRegisterOfShareholdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportRegisterOfShareholdersQuery,
  ExportRegisterOfShareholdersQueryVariables
>;
export function useExportRegisterOfShareholdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportRegisterOfShareholdersQuery,
        ExportRegisterOfShareholdersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportRegisterOfShareholdersQuery | undefined,
  ExportRegisterOfShareholdersQueryVariables
>;
export function useExportRegisterOfShareholdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportRegisterOfShareholdersQuery,
        ExportRegisterOfShareholdersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportRegisterOfShareholdersQuery,
    ExportRegisterOfShareholdersQueryVariables
  >(ExportRegisterOfShareholdersDocument, options);
}
export type ExportRegisterOfShareholdersQueryHookResult = ReturnType<
  typeof useExportRegisterOfShareholdersQuery
>;
export type ExportRegisterOfShareholdersLazyQueryHookResult = ReturnType<
  typeof useExportRegisterOfShareholdersLazyQuery
>;
export type ExportRegisterOfShareholdersSuspenseQueryHookResult = ReturnType<
  typeof useExportRegisterOfShareholdersSuspenseQuery
>;
export type ExportRegisterOfShareholdersQueryResult = Apollo.QueryResult<
  ExportRegisterOfShareholdersQuery,
  ExportRegisterOfShareholdersQueryVariables
>;
export const ExportShareholderCsvDocument = gql`
  query ExportShareholderCsv(
    $registerId: ID!
    $locale: Locale!
    $grouped: Boolean
    $extended: Boolean
  ) {
    exportShareholderCsv(
      registerId: $registerId
      locale: $locale
      grouped: $grouped
      extended: $extended
    )
  }
`;

/**
 * __useExportShareholderCsvQuery__
 *
 * To run a query within a React component, call `useExportShareholderCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportShareholderCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportShareholderCsvQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      locale: // value for 'locale'
 *      grouped: // value for 'grouped'
 *      extended: // value for 'extended'
 *   },
 * });
 */
export function useExportShareholderCsvQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportShareholderCsvQuery,
    ExportShareholderCsvQueryVariables
  > &
    ({ variables: ExportShareholderCsvQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportShareholderCsvQuery, ExportShareholderCsvQueryVariables>(
    ExportShareholderCsvDocument,
    options,
  );
}
export function useExportShareholderCsvLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportShareholderCsvQuery,
    ExportShareholderCsvQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportShareholderCsvQuery, ExportShareholderCsvQueryVariables>(
    ExportShareholderCsvDocument,
    options,
  );
}
// @ts-ignore
export function useExportShareholderCsvSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportShareholderCsvQuery,
    ExportShareholderCsvQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportShareholderCsvQuery, ExportShareholderCsvQueryVariables>;
export function useExportShareholderCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderCsvQuery,
        ExportShareholderCsvQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportShareholderCsvQuery | undefined,
  ExportShareholderCsvQueryVariables
>;
export function useExportShareholderCsvSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderCsvQuery,
        ExportShareholderCsvQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportShareholderCsvQuery, ExportShareholderCsvQueryVariables>(
    ExportShareholderCsvDocument,
    options,
  );
}
export type ExportShareholderCsvQueryHookResult = ReturnType<typeof useExportShareholderCsvQuery>;
export type ExportShareholderCsvLazyQueryHookResult = ReturnType<
  typeof useExportShareholderCsvLazyQuery
>;
export type ExportShareholderCsvSuspenseQueryHookResult = ReturnType<
  typeof useExportShareholderCsvSuspenseQuery
>;
export type ExportShareholderCsvQueryResult = Apollo.QueryResult<
  ExportShareholderCsvQuery,
  ExportShareholderCsvQueryVariables
>;
export const ExportShareholderExcelDocument = gql`
  query ExportShareholderExcel(
    $registerId: ID!
    $locale: Locale!
    $grouped: Boolean
    $extended: Boolean
  ) {
    exportShareholderExcel(
      registerId: $registerId
      locale: $locale
      grouped: $grouped
      extended: $extended
    )
  }
`;

/**
 * __useExportShareholderExcelQuery__
 *
 * To run a query within a React component, call `useExportShareholderExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportShareholderExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportShareholderExcelQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      locale: // value for 'locale'
 *      grouped: // value for 'grouped'
 *      extended: // value for 'extended'
 *   },
 * });
 */
export function useExportShareholderExcelQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportShareholderExcelQuery,
    ExportShareholderExcelQueryVariables
  > &
    ({ variables: ExportShareholderExcelQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportShareholderExcelQuery, ExportShareholderExcelQueryVariables>(
    ExportShareholderExcelDocument,
    options,
  );
}
export function useExportShareholderExcelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportShareholderExcelQuery,
    ExportShareholderExcelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportShareholderExcelQuery, ExportShareholderExcelQueryVariables>(
    ExportShareholderExcelDocument,
    options,
  );
}
// @ts-ignore
export function useExportShareholderExcelSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportShareholderExcelQuery,
    ExportShareholderExcelQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ExportShareholderExcelQuery, ExportShareholderExcelQueryVariables>;
export function useExportShareholderExcelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderExcelQuery,
        ExportShareholderExcelQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportShareholderExcelQuery | undefined,
  ExportShareholderExcelQueryVariables
>;
export function useExportShareholderExcelSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderExcelQuery,
        ExportShareholderExcelQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportShareholderExcelQuery, ExportShareholderExcelQueryVariables>(
    ExportShareholderExcelDocument,
    options,
  );
}
export type ExportShareholderExcelQueryHookResult = ReturnType<
  typeof useExportShareholderExcelQuery
>;
export type ExportShareholderExcelLazyQueryHookResult = ReturnType<
  typeof useExportShareholderExcelLazyQuery
>;
export type ExportShareholderExcelSuspenseQueryHookResult = ReturnType<
  typeof useExportShareholderExcelSuspenseQuery
>;
export type ExportShareholderExcelQueryResult = Apollo.QueryResult<
  ExportShareholderExcelQuery,
  ExportShareholderExcelQueryVariables
>;
export const ExportShareholderExtractDocument = gql`
  query ExportShareholderExtract($registerId: ID!, $partyId: ID!, $locale: Locale!) {
    exportShareholderExtract(registerId: $registerId, partyId: $partyId, locale: $locale)
  }
`;

/**
 * __useExportShareholderExtractQuery__
 *
 * To run a query within a React component, call `useExportShareholderExtractQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportShareholderExtractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportShareholderExtractQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      partyId: // value for 'partyId'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useExportShareholderExtractQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportShareholderExtractQuery,
    ExportShareholderExtractQueryVariables
  > &
    ({ variables: ExportShareholderExtractQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportShareholderExtractQuery, ExportShareholderExtractQueryVariables>(
    ExportShareholderExtractDocument,
    options,
  );
}
export function useExportShareholderExtractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportShareholderExtractQuery,
    ExportShareholderExtractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportShareholderExtractQuery, ExportShareholderExtractQueryVariables>(
    ExportShareholderExtractDocument,
    options,
  );
}
// @ts-ignore
export function useExportShareholderExtractSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportShareholderExtractQuery,
    ExportShareholderExtractQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ExportShareholderExtractQuery,
  ExportShareholderExtractQueryVariables
>;
export function useExportShareholderExtractSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderExtractQuery,
        ExportShareholderExtractQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ExportShareholderExtractQuery | undefined,
  ExportShareholderExtractQueryVariables
>;
export function useExportShareholderExtractSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ExportShareholderExtractQuery,
        ExportShareholderExtractQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ExportShareholderExtractQuery,
    ExportShareholderExtractQueryVariables
  >(ExportShareholderExtractDocument, options);
}
export type ExportShareholderExtractQueryHookResult = ReturnType<
  typeof useExportShareholderExtractQuery
>;
export type ExportShareholderExtractLazyQueryHookResult = ReturnType<
  typeof useExportShareholderExtractLazyQuery
>;
export type ExportShareholderExtractSuspenseQueryHookResult = ReturnType<
  typeof useExportShareholderExtractSuspenseQuery
>;
export type ExportShareholderExtractQueryResult = Apollo.QueryResult<
  ExportShareholderExtractQuery,
  ExportShareholderExtractQueryVariables
>;
export const RecalculateRegisterDocument = gql`
  mutation RecalculateRegister($registerId: ID!) {
    recalculateRegister(registerId: $registerId) {
      ...RegisterFields
    }
  }
  ${RegisterFieldsFragmentDoc}
`;
export type RecalculateRegisterMutationFn = Apollo.MutationFunction<
  RecalculateRegisterMutation,
  RecalculateRegisterMutationVariables
>;

/**
 * __useRecalculateRegisterMutation__
 *
 * To run a mutation, you first call `useRecalculateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecalculateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recalculateRegisterMutation, { data, loading, error }] = useRecalculateRegisterMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useRecalculateRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecalculateRegisterMutation,
    RecalculateRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RecalculateRegisterMutation, RecalculateRegisterMutationVariables>(
    RecalculateRegisterDocument,
    options,
  );
}
export type RecalculateRegisterMutationHookResult = ReturnType<
  typeof useRecalculateRegisterMutation
>;
export type RecalculateRegisterMutationResult = Apollo.MutationResult<RecalculateRegisterMutation>;
export type RecalculateRegisterMutationOptions = Apollo.BaseMutationOptions<
  RecalculateRegisterMutation,
  RecalculateRegisterMutationVariables
>;
export const UpdateRegisterDocument = gql`
  mutation UpdateRegister($registerId: ID!, $register: RegisterInput!) {
    updateRegister(registerId: $registerId, register: $register) {
      replacement
    }
  }
`;
export type UpdateRegisterMutationFn = Apollo.MutationFunction<
  UpdateRegisterMutation,
  UpdateRegisterMutationVariables
>;

/**
 * __useUpdateRegisterMutation__
 *
 * To run a mutation, you first call `useUpdateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisterMutation, { data, loading, error }] = useUpdateRegisterMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      register: // value for 'register'
 *   },
 * });
 */
export function useUpdateRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateRegisterMutation, UpdateRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRegisterMutation, UpdateRegisterMutationVariables>(
    UpdateRegisterDocument,
    options,
  );
}
export type UpdateRegisterMutationHookResult = ReturnType<typeof useUpdateRegisterMutation>;
export type UpdateRegisterMutationResult = Apollo.MutationResult<UpdateRegisterMutation>;
export type UpdateRegisterMutationOptions = Apollo.BaseMutationOptions<
  UpdateRegisterMutation,
  UpdateRegisterMutationVariables
>;
export const SignRegisterDocument = gql`
  mutation SignRegister($registerId: ID!) {
    signRegister(registerId: $registerId) {
      ...RegisterFields
    }
  }
  ${RegisterFieldsFragmentDoc}
`;
export type SignRegisterMutationFn = Apollo.MutationFunction<
  SignRegisterMutation,
  SignRegisterMutationVariables
>;

/**
 * __useSignRegisterMutation__
 *
 * To run a mutation, you first call `useSignRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signRegisterMutation, { data, loading, error }] = useSignRegisterMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useSignRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<SignRegisterMutation, SignRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignRegisterMutation, SignRegisterMutationVariables>(
    SignRegisterDocument,
    options,
  );
}
export type SignRegisterMutationHookResult = ReturnType<typeof useSignRegisterMutation>;
export type SignRegisterMutationResult = Apollo.MutationResult<SignRegisterMutation>;
export type SignRegisterMutationOptions = Apollo.BaseMutationOptions<
  SignRegisterMutation,
  SignRegisterMutationVariables
>;
export const UnsignRegisterDocument = gql`
  mutation UnsignRegister($registerSignatureId: ID!) {
    unsignRegister(registerSignatureId: $registerSignatureId) {
      ...RegisterFields
    }
  }
  ${RegisterFieldsFragmentDoc}
`;
export type UnsignRegisterMutationFn = Apollo.MutationFunction<
  UnsignRegisterMutation,
  UnsignRegisterMutationVariables
>;

/**
 * __useUnsignRegisterMutation__
 *
 * To run a mutation, you first call `useUnsignRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsignRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsignRegisterMutation, { data, loading, error }] = useUnsignRegisterMutation({
 *   variables: {
 *      registerSignatureId: // value for 'registerSignatureId'
 *   },
 * });
 */
export function useUnsignRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<UnsignRegisterMutation, UnsignRegisterMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnsignRegisterMutation, UnsignRegisterMutationVariables>(
    UnsignRegisterDocument,
    options,
  );
}
export type UnsignRegisterMutationHookResult = ReturnType<typeof useUnsignRegisterMutation>;
export type UnsignRegisterMutationResult = Apollo.MutationResult<UnsignRegisterMutation>;
export type UnsignRegisterMutationOptions = Apollo.BaseMutationOptions<
  UnsignRegisterMutation,
  UnsignRegisterMutationVariables
>;
export const ReleasesDocument = gql`
  query Releases($locale: Locale) {
    releases(locale: $locale) {
      id
      locale
      date
      title
      media
      content
    }
  }
`;

/**
 * __useReleasesQuery__
 *
 * To run a query within a React component, call `useReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReleasesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useReleasesQuery(
  baseOptions?: Apollo.QueryHookOptions<ReleasesQuery, ReleasesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReleasesQuery, ReleasesQueryVariables>(ReleasesDocument, options);
}
export function useReleasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ReleasesQuery, ReleasesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReleasesQuery, ReleasesQueryVariables>(ReleasesDocument, options);
}
// @ts-ignore
export function useReleasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ReleasesQuery, ReleasesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReleasesQuery, ReleasesQueryVariables>;
export function useReleasesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReleasesQuery, ReleasesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ReleasesQuery | undefined, ReleasesQueryVariables>;
export function useReleasesSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReleasesQuery, ReleasesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ReleasesQuery, ReleasesQueryVariables>(ReleasesDocument, options);
}
export type ReleasesQueryHookResult = ReturnType<typeof useReleasesQuery>;
export type ReleasesLazyQueryHookResult = ReturnType<typeof useReleasesLazyQuery>;
export type ReleasesSuspenseQueryHookResult = ReturnType<typeof useReleasesSuspenseQuery>;
export type ReleasesQueryResult = Apollo.QueryResult<ReleasesQuery, ReleasesQueryVariables>;
export const ShareGroupsDocument = gql`
  query ShareGroups($registerId: ID!) {
    shareGroups(registerId: $registerId) {
      ...ShareGroupFields
    }
  }
  ${ShareGroupFieldsFragmentDoc}
`;

/**
 * __useShareGroupsQuery__
 *
 * To run a query within a React component, call `useShareGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareGroupsQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useShareGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<ShareGroupsQuery, ShareGroupsQueryVariables> &
    ({ variables: ShareGroupsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShareGroupsQuery, ShareGroupsQueryVariables>(ShareGroupsDocument, options);
}
export function useShareGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ShareGroupsQuery, ShareGroupsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShareGroupsQuery, ShareGroupsQueryVariables>(
    ShareGroupsDocument,
    options,
  );
}
// @ts-ignore
export function useShareGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ShareGroupsQuery, ShareGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShareGroupsQuery, ShareGroupsQueryVariables>;
export function useShareGroupsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareGroupsQuery, ShareGroupsQueryVariables>,
): Apollo.UseSuspenseQueryResult<ShareGroupsQuery | undefined, ShareGroupsQueryVariables>;
export function useShareGroupsSuspenseQuery(
  baseOptions?:
    Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShareGroupsQuery, ShareGroupsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShareGroupsQuery, ShareGroupsQueryVariables>(
    ShareGroupsDocument,
    options,
  );
}
export type ShareGroupsQueryHookResult = ReturnType<typeof useShareGroupsQuery>;
export type ShareGroupsLazyQueryHookResult = ReturnType<typeof useShareGroupsLazyQuery>;
export type ShareGroupsSuspenseQueryHookResult = ReturnType<typeof useShareGroupsSuspenseQuery>;
export type ShareGroupsQueryResult = Apollo.QueryResult<
  ShareGroupsQuery,
  ShareGroupsQueryVariables
>;
export const ShareGroupEntriesDocument = gql`
  query ShareGroupEntries($registerId: ID!) {
    shareGroupEntries(registerId: $registerId) {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;

/**
 * __useShareGroupEntriesQuery__
 *
 * To run a query within a React component, call `useShareGroupEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareGroupEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareGroupEntriesQuery({
 *   variables: {
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useShareGroupEntriesQuery(
  baseOptions: Apollo.QueryHookOptions<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables> &
    ({ variables: ShareGroupEntriesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>(
    ShareGroupEntriesDocument,
    options,
  );
}
export function useShareGroupEntriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShareGroupEntriesQuery,
    ShareGroupEntriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>(
    ShareGroupEntriesDocument,
    options,
  );
}
// @ts-ignore
export function useShareGroupEntriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ShareGroupEntriesQuery,
    ShareGroupEntriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>;
export function useShareGroupEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ShareGroupEntriesQuery | undefined,
  ShareGroupEntriesQueryVariables
>;
export function useShareGroupEntriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ShareGroupEntriesQuery, ShareGroupEntriesQueryVariables>(
    ShareGroupEntriesDocument,
    options,
  );
}
export type ShareGroupEntriesQueryHookResult = ReturnType<typeof useShareGroupEntriesQuery>;
export type ShareGroupEntriesLazyQueryHookResult = ReturnType<typeof useShareGroupEntriesLazyQuery>;
export type ShareGroupEntriesSuspenseQueryHookResult = ReturnType<
  typeof useShareGroupEntriesSuspenseQuery
>;
export type ShareGroupEntriesQueryResult = Apollo.QueryResult<
  ShareGroupEntriesQuery,
  ShareGroupEntriesQueryVariables
>;
export const CreateShareGroupDocument = gql`
  mutation CreateShareGroup($registerId: ID!, $shareGroupName: String!) {
    createShareGroup(registerId: $registerId, shareGroupName: $shareGroupName) {
      ...ShareGroupFields
    }
  }
  ${ShareGroupFieldsFragmentDoc}
`;
export type CreateShareGroupMutationFn = Apollo.MutationFunction<
  CreateShareGroupMutation,
  CreateShareGroupMutationVariables
>;

/**
 * __useCreateShareGroupMutation__
 *
 * To run a mutation, you first call `useCreateShareGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareGroupMutation, { data, loading, error }] = useCreateShareGroupMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      shareGroupName: // value for 'shareGroupName'
 *   },
 * });
 */
export function useCreateShareGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateShareGroupMutation,
    CreateShareGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateShareGroupMutation, CreateShareGroupMutationVariables>(
    CreateShareGroupDocument,
    options,
  );
}
export type CreateShareGroupMutationHookResult = ReturnType<typeof useCreateShareGroupMutation>;
export type CreateShareGroupMutationResult = Apollo.MutationResult<CreateShareGroupMutation>;
export type CreateShareGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateShareGroupMutation,
  CreateShareGroupMutationVariables
>;
export const UpdateShareGroupDocument = gql`
  mutation UpdateShareGroup($shareGroupId: ID!, $shareGroupName: String!) {
    updateShareGroup(shareGroupId: $shareGroupId, shareGroupName: $shareGroupName) {
      ...ShareGroupFields
    }
  }
  ${ShareGroupFieldsFragmentDoc}
`;
export type UpdateShareGroupMutationFn = Apollo.MutationFunction<
  UpdateShareGroupMutation,
  UpdateShareGroupMutationVariables
>;

/**
 * __useUpdateShareGroupMutation__
 *
 * To run a mutation, you first call `useUpdateShareGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareGroupMutation, { data, loading, error }] = useUpdateShareGroupMutation({
 *   variables: {
 *      shareGroupId: // value for 'shareGroupId'
 *      shareGroupName: // value for 'shareGroupName'
 *   },
 * });
 */
export function useUpdateShareGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateShareGroupMutation,
    UpdateShareGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateShareGroupMutation, UpdateShareGroupMutationVariables>(
    UpdateShareGroupDocument,
    options,
  );
}
export type UpdateShareGroupMutationHookResult = ReturnType<typeof useUpdateShareGroupMutation>;
export type UpdateShareGroupMutationResult = Apollo.MutationResult<UpdateShareGroupMutation>;
export type UpdateShareGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateShareGroupMutation,
  UpdateShareGroupMutationVariables
>;
export const DeleteShareGroupDocument = gql`
  mutation DeleteShareGroup($shareGroupId: ID!) {
    deleteShareGroup(shareGroupId: $shareGroupId) {
      ...ShareGroupFields
    }
  }
  ${ShareGroupFieldsFragmentDoc}
`;
export type DeleteShareGroupMutationFn = Apollo.MutationFunction<
  DeleteShareGroupMutation,
  DeleteShareGroupMutationVariables
>;

/**
 * __useDeleteShareGroupMutation__
 *
 * To run a mutation, you first call `useDeleteShareGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareGroupMutation, { data, loading, error }] = useDeleteShareGroupMutation({
 *   variables: {
 *      shareGroupId: // value for 'shareGroupId'
 *   },
 * });
 */
export function useDeleteShareGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteShareGroupMutation,
    DeleteShareGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteShareGroupMutation, DeleteShareGroupMutationVariables>(
    DeleteShareGroupDocument,
    options,
  );
}
export type DeleteShareGroupMutationHookResult = ReturnType<typeof useDeleteShareGroupMutation>;
export type DeleteShareGroupMutationResult = Apollo.MutationResult<DeleteShareGroupMutation>;
export type DeleteShareGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteShareGroupMutation,
  DeleteShareGroupMutationVariables
>;
export const CreateShareGroupEntryDocument = gql`
  mutation CreateShareGroupEntry($shareGroupEntryInput: ShareGroupEntryInput!) {
    createShareGroupEntry(shareGroupEntryInput: $shareGroupEntryInput) {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;
export type CreateShareGroupEntryMutationFn = Apollo.MutationFunction<
  CreateShareGroupEntryMutation,
  CreateShareGroupEntryMutationVariables
>;

/**
 * __useCreateShareGroupEntryMutation__
 *
 * To run a mutation, you first call `useCreateShareGroupEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareGroupEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareGroupEntryMutation, { data, loading, error }] = useCreateShareGroupEntryMutation({
 *   variables: {
 *      shareGroupEntryInput: // value for 'shareGroupEntryInput'
 *   },
 * });
 */
export function useCreateShareGroupEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateShareGroupEntryMutation,
    CreateShareGroupEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateShareGroupEntryMutation, CreateShareGroupEntryMutationVariables>(
    CreateShareGroupEntryDocument,
    options,
  );
}
export type CreateShareGroupEntryMutationHookResult = ReturnType<
  typeof useCreateShareGroupEntryMutation
>;
export type CreateShareGroupEntryMutationResult =
  Apollo.MutationResult<CreateShareGroupEntryMutation>;
export type CreateShareGroupEntryMutationOptions = Apollo.BaseMutationOptions<
  CreateShareGroupEntryMutation,
  CreateShareGroupEntryMutationVariables
>;
export const UpdateShareGroupEntryDocument = gql`
  mutation UpdateShareGroupEntry(
    $shareGroupEntryId: ID!
    $shareGroupEntryInput: ShareGroupEntryInput!
  ) {
    updateShareGroupEntry(
      shareGroupEntryId: $shareGroupEntryId
      shareGroupEntryInput: $shareGroupEntryInput
    ) {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;
export type UpdateShareGroupEntryMutationFn = Apollo.MutationFunction<
  UpdateShareGroupEntryMutation,
  UpdateShareGroupEntryMutationVariables
>;

/**
 * __useUpdateShareGroupEntryMutation__
 *
 * To run a mutation, you first call `useUpdateShareGroupEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareGroupEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareGroupEntryMutation, { data, loading, error }] = useUpdateShareGroupEntryMutation({
 *   variables: {
 *      shareGroupEntryId: // value for 'shareGroupEntryId'
 *      shareGroupEntryInput: // value for 'shareGroupEntryInput'
 *   },
 * });
 */
export function useUpdateShareGroupEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateShareGroupEntryMutation,
    UpdateShareGroupEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateShareGroupEntryMutation, UpdateShareGroupEntryMutationVariables>(
    UpdateShareGroupEntryDocument,
    options,
  );
}
export type UpdateShareGroupEntryMutationHookResult = ReturnType<
  typeof useUpdateShareGroupEntryMutation
>;
export type UpdateShareGroupEntryMutationResult =
  Apollo.MutationResult<UpdateShareGroupEntryMutation>;
export type UpdateShareGroupEntryMutationOptions = Apollo.BaseMutationOptions<
  UpdateShareGroupEntryMutation,
  UpdateShareGroupEntryMutationVariables
>;
export const DeleteShareGroupEntryDocument = gql`
  mutation DeleteShareGroupEntry($shareGroupEntryId: ID!) {
    deleteShareGroupEntry(shareGroupEntryId: $shareGroupEntryId) {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;
export type DeleteShareGroupEntryMutationFn = Apollo.MutationFunction<
  DeleteShareGroupEntryMutation,
  DeleteShareGroupEntryMutationVariables
>;

/**
 * __useDeleteShareGroupEntryMutation__
 *
 * To run a mutation, you first call `useDeleteShareGroupEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareGroupEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareGroupEntryMutation, { data, loading, error }] = useDeleteShareGroupEntryMutation({
 *   variables: {
 *      shareGroupEntryId: // value for 'shareGroupEntryId'
 *   },
 * });
 */
export function useDeleteShareGroupEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteShareGroupEntryMutation,
    DeleteShareGroupEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteShareGroupEntryMutation, DeleteShareGroupEntryMutationVariables>(
    DeleteShareGroupEntryDocument,
    options,
  );
}
export type DeleteShareGroupEntryMutationHookResult = ReturnType<
  typeof useDeleteShareGroupEntryMutation
>;
export type DeleteShareGroupEntryMutationResult =
  Apollo.MutationResult<DeleteShareGroupEntryMutation>;
export type DeleteShareGroupEntryMutationOptions = Apollo.BaseMutationOptions<
  DeleteShareGroupEntryMutation,
  DeleteShareGroupEntryMutationVariables
>;
export const AddAllSharesToShareGroupDocument = gql`
  mutation AddAllSharesToShareGroup($partyId: ID!, $shareGroupId: ID!) {
    addAllSharesToShareGroup(partyId: $partyId, shareGroupId: $shareGroupId) {
      ...ShareGroupEntryFields
    }
  }
  ${ShareGroupEntryFieldsFragmentDoc}
`;
export type AddAllSharesToShareGroupMutationFn = Apollo.MutationFunction<
  AddAllSharesToShareGroupMutation,
  AddAllSharesToShareGroupMutationVariables
>;

/**
 * __useAddAllSharesToShareGroupMutation__
 *
 * To run a mutation, you first call `useAddAllSharesToShareGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAllSharesToShareGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAllSharesToShareGroupMutation, { data, loading, error }] = useAddAllSharesToShareGroupMutation({
 *   variables: {
 *      partyId: // value for 'partyId'
 *      shareGroupId: // value for 'shareGroupId'
 *   },
 * });
 */
export function useAddAllSharesToShareGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAllSharesToShareGroupMutation,
    AddAllSharesToShareGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddAllSharesToShareGroupMutation,
    AddAllSharesToShareGroupMutationVariables
  >(AddAllSharesToShareGroupDocument, options);
}
export type AddAllSharesToShareGroupMutationHookResult = ReturnType<
  typeof useAddAllSharesToShareGroupMutation
>;
export type AddAllSharesToShareGroupMutationResult =
  Apollo.MutationResult<AddAllSharesToShareGroupMutation>;
export type AddAllSharesToShareGroupMutationOptions = Apollo.BaseMutationOptions<
  AddAllSharesToShareGroupMutation,
  AddAllSharesToShareGroupMutationVariables
>;
export const AvailableShareTypesForCertificationDocument = gql`
  query AvailableShareTypesForCertification($stakId: ID!) {
    availableShareTypesForCertification(stakId: $stakId) {
      legalEntity {
        ...LegalEntityFields
      }
      shareType {
        ...ShareTypeFields
      }
    }
  }
  ${LegalEntityFieldsFragmentDoc}
  ${ShareTypeFieldsFragmentDoc}
`;

/**
 * __useAvailableShareTypesForCertificationQuery__
 *
 * To run a query within a React component, call `useAvailableShareTypesForCertificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableShareTypesForCertificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableShareTypesForCertificationQuery({
 *   variables: {
 *      stakId: // value for 'stakId'
 *   },
 * });
 */
export function useAvailableShareTypesForCertificationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  > &
    (
      | { variables: AvailableShareTypesForCertificationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  >(AvailableShareTypesForCertificationDocument, options);
}
export function useAvailableShareTypesForCertificationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  >(AvailableShareTypesForCertificationDocument, options);
}
// @ts-ignore
export function useAvailableShareTypesForCertificationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AvailableShareTypesForCertificationQuery,
  AvailableShareTypesForCertificationQueryVariables
>;
export function useAvailableShareTypesForCertificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableShareTypesForCertificationQuery,
        AvailableShareTypesForCertificationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AvailableShareTypesForCertificationQuery | undefined,
  AvailableShareTypesForCertificationQueryVariables
>;
export function useAvailableShareTypesForCertificationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AvailableShareTypesForCertificationQuery,
        AvailableShareTypesForCertificationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AvailableShareTypesForCertificationQuery,
    AvailableShareTypesForCertificationQueryVariables
  >(AvailableShareTypesForCertificationDocument, options);
}
export type AvailableShareTypesForCertificationQueryHookResult = ReturnType<
  typeof useAvailableShareTypesForCertificationQuery
>;
export type AvailableShareTypesForCertificationLazyQueryHookResult = ReturnType<
  typeof useAvailableShareTypesForCertificationLazyQuery
>;
export type AvailableShareTypesForCertificationSuspenseQueryHookResult = ReturnType<
  typeof useAvailableShareTypesForCertificationSuspenseQuery
>;
export type AvailableShareTypesForCertificationQueryResult = Apollo.QueryResult<
  AvailableShareTypesForCertificationQuery,
  AvailableShareTypesForCertificationQueryVariables
>;
export const CreateShareTypeDocument = gql`
  mutation CreateShareType($registerId: ID!, $shareType: ShareTypeInput!) {
    createShareType(registerId: $registerId, shareType: $shareType) {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export type CreateShareTypeMutationFn = Apollo.MutationFunction<
  CreateShareTypeMutation,
  CreateShareTypeMutationVariables
>;

/**
 * __useCreateShareTypeMutation__
 *
 * To run a mutation, you first call `useCreateShareTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareTypeMutation, { data, loading, error }] = useCreateShareTypeMutation({
 *   variables: {
 *      registerId: // value for 'registerId'
 *      shareType: // value for 'shareType'
 *   },
 * });
 */
export function useCreateShareTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateShareTypeMutation,
    CreateShareTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateShareTypeMutation, CreateShareTypeMutationVariables>(
    CreateShareTypeDocument,
    options,
  );
}
export type CreateShareTypeMutationHookResult = ReturnType<typeof useCreateShareTypeMutation>;
export type CreateShareTypeMutationResult = Apollo.MutationResult<CreateShareTypeMutation>;
export type CreateShareTypeMutationOptions = Apollo.BaseMutationOptions<
  CreateShareTypeMutation,
  CreateShareTypeMutationVariables
>;
export const UpdateShareTypeDocument = gql`
  mutation UpdateShareType($shareTypeId: ID!, $shareType: ShareTypeInput!) {
    updateShareType(shareTypeId: $shareTypeId, shareType: $shareType) {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export type UpdateShareTypeMutationFn = Apollo.MutationFunction<
  UpdateShareTypeMutation,
  UpdateShareTypeMutationVariables
>;

/**
 * __useUpdateShareTypeMutation__
 *
 * To run a mutation, you first call `useUpdateShareTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareTypeMutation, { data, loading, error }] = useUpdateShareTypeMutation({
 *   variables: {
 *      shareTypeId: // value for 'shareTypeId'
 *      shareType: // value for 'shareType'
 *   },
 * });
 */
export function useUpdateShareTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateShareTypeMutation,
    UpdateShareTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateShareTypeMutation, UpdateShareTypeMutationVariables>(
    UpdateShareTypeDocument,
    options,
  );
}
export type UpdateShareTypeMutationHookResult = ReturnType<typeof useUpdateShareTypeMutation>;
export type UpdateShareTypeMutationResult = Apollo.MutationResult<UpdateShareTypeMutation>;
export type UpdateShareTypeMutationOptions = Apollo.BaseMutationOptions<
  UpdateShareTypeMutation,
  UpdateShareTypeMutationVariables
>;
export const CorrectShareTypeVersionDocument = gql`
  mutation CorrectShareTypeVersion($shareTypeVersionId: ID!, $shareType: ShareTypeInput!) {
    correctShareTypeVersion(shareTypeVersionId: $shareTypeVersionId, shareType: $shareType) {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export type CorrectShareTypeVersionMutationFn = Apollo.MutationFunction<
  CorrectShareTypeVersionMutation,
  CorrectShareTypeVersionMutationVariables
>;

/**
 * __useCorrectShareTypeVersionMutation__
 *
 * To run a mutation, you first call `useCorrectShareTypeVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectShareTypeVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctShareTypeVersionMutation, { data, loading, error }] = useCorrectShareTypeVersionMutation({
 *   variables: {
 *      shareTypeVersionId: // value for 'shareTypeVersionId'
 *      shareType: // value for 'shareType'
 *   },
 * });
 */
export function useCorrectShareTypeVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CorrectShareTypeVersionMutation,
    CorrectShareTypeVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CorrectShareTypeVersionMutation,
    CorrectShareTypeVersionMutationVariables
  >(CorrectShareTypeVersionDocument, options);
}
export type CorrectShareTypeVersionMutationHookResult = ReturnType<
  typeof useCorrectShareTypeVersionMutation
>;
export type CorrectShareTypeVersionMutationResult =
  Apollo.MutationResult<CorrectShareTypeVersionMutation>;
export type CorrectShareTypeVersionMutationOptions = Apollo.BaseMutationOptions<
  CorrectShareTypeVersionMutation,
  CorrectShareTypeVersionMutationVariables
>;
export const DeleteShareTypeVersionDocument = gql`
  mutation DeleteShareTypeVersion($shareTypeVersionId: ID!) {
    deleteShareTypeVersion(shareTypeVersionId: $shareTypeVersionId) {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export type DeleteShareTypeVersionMutationFn = Apollo.MutationFunction<
  DeleteShareTypeVersionMutation,
  DeleteShareTypeVersionMutationVariables
>;

/**
 * __useDeleteShareTypeVersionMutation__
 *
 * To run a mutation, you first call `useDeleteShareTypeVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareTypeVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareTypeVersionMutation, { data, loading, error }] = useDeleteShareTypeVersionMutation({
 *   variables: {
 *      shareTypeVersionId: // value for 'shareTypeVersionId'
 *   },
 * });
 */
export function useDeleteShareTypeVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteShareTypeVersionMutation,
    DeleteShareTypeVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteShareTypeVersionMutation,
    DeleteShareTypeVersionMutationVariables
  >(DeleteShareTypeVersionDocument, options);
}
export type DeleteShareTypeVersionMutationHookResult = ReturnType<
  typeof useDeleteShareTypeVersionMutation
>;
export type DeleteShareTypeVersionMutationResult =
  Apollo.MutationResult<DeleteShareTypeVersionMutation>;
export type DeleteShareTypeVersionMutationOptions = Apollo.BaseMutationOptions<
  DeleteShareTypeVersionMutation,
  DeleteShareTypeVersionMutationVariables
>;
export const DeleteShareTypeDocument = gql`
  mutation DeleteShareType($shareTypeId: ID!) {
    deleteShareType(shareTypeId: $shareTypeId) {
      ...ShareTypeFields
    }
  }
  ${ShareTypeFieldsFragmentDoc}
`;
export type DeleteShareTypeMutationFn = Apollo.MutationFunction<
  DeleteShareTypeMutation,
  DeleteShareTypeMutationVariables
>;

/**
 * __useDeleteShareTypeMutation__
 *
 * To run a mutation, you first call `useDeleteShareTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareTypeMutation, { data, loading, error }] = useDeleteShareTypeMutation({
 *   variables: {
 *      shareTypeId: // value for 'shareTypeId'
 *   },
 * });
 */
export function useDeleteShareTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteShareTypeMutation,
    DeleteShareTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteShareTypeMutation, DeleteShareTypeMutationVariables>(
    DeleteShareTypeDocument,
    options,
  );
}
export type DeleteShareTypeMutationHookResult = ReturnType<typeof useDeleteShareTypeMutation>;
export type DeleteShareTypeMutationResult = Apollo.MutationResult<DeleteShareTypeMutation>;
export type DeleteShareTypeMutationOptions = Apollo.BaseMutationOptions<
  DeleteShareTypeMutation,
  DeleteShareTypeMutationVariables
>;
